<template>
  <span v-resize="checkMobile" data-testid="company-profile-page">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <!-- Удалить демо контент -->
    <v-card>
      <v-banner single-line v-if="company && showRemoveDemo">
        <v-icon slot="icon" color="warning" size="36">
          mdi-information-outline
        </v-icon>
        {{ $t("demo_content.remove_demo_content_text_2") }}
        <template v-slot:actions>
          <v-btn color="warning" @click="removeDemoContent()">
            {{ $t("demo_content.remove") }}
          </v-btn>
        </template>
      </v-banner>
      <v-tabs v-model="tabs" :fixed-tabs="!isMobile" :centered="!isMobile" :vertical="isMobile" id="registration-step-7"
        @change="updateTab">
        <v-tab>
          {{ $t("companies.prices") }}
        </v-tab>
        <v-tab id="registration-step-15">
          {{ $t("companies.rent") }}
        </v-tab>
        <v-tab id="registration-step-22">
          {{ $t("companies.company") }}
        </v-tab>
        <v-tab id="registration-step-24">
          {{ $t("companies.templates") }}
        </v-tab>
        <v-tab>
          {{ $t("companies.notifications") }}
        </v-tab>
        <v-tab>
          {{ $t("companies.clients") }}
        </v-tab>
        <v-tab>
          {{ $t("companies.integrations") }}
        </v-tab>
        <v-tab>
          {{ $t("tags.manage_tags") }}
        </v-tab>
        <!-- FT-102: бронируемые допы (фасад склада) -->
        <v-tab>
          {{ $t("bookable_addons.tab") }}
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tabs" touchless>
        <!-- Цены (FT-085: вынесено в PricingSettingsTab) -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <pricing-settings-tab :company="pricing_company"></pricing-settings-tab>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Аренда -->
        <v-tab-item>
          <v-card flat v-if="company && company.id">
            <v-card-text>
              <v-row>
                <v-col cols="12" lg="3" md="3" sm="12" xs="12" id="registration-step-16">
                  <v-text-field v-model="company.age_limit" :label="$t('companies.age_limit')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="3" sm="12" xs="12" id="registration-step-17">
                  <v-text-field v-model.number="company.min_days" :label="$t('companies.min_days')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="3" sm="12" xs="12" id="registration-step-18">
                  <v-text-field v-model.number="company.mileage_limit" :label="$t('companies.mileage_limit')" outlined
                    v-tooltip="{
                      content: $t('companies.mileage_limit_info'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }"></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="3" sm="12" xs="12" id="registration-step-19">
                  <v-text-field v-model.number="company.mileage_limit_cost" :label="$t('companies.mileage_limit_price')"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="4" sm="12" xs="12" id="registration-step-21">
                  <v-text-field v-model.number="company.interval_bookings" :label="$t('companies.interval_bookings')"
                    v-tooltip="{
                      content: $t('companies.interval_bookings_info'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }" outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="4" sm="12" xs="12" id="registration-step-21">
                  <!-- Подсказка про правило добавления суток — за иконкой: текст длинный,
                       а прежний v-tooltip на самом поле не давал никакого намёка, что
                       подсказка вообще есть (и на тач-устройствах был недоступен).
                       Иконка кликабельна — тултип открывается и по тапу. -->
                  <v-text-field v-model.number="company.hours_limit" :label="$t('companies.hours_limit')"
                    outlined>
                    <template v-slot:append>
                      <!-- open-on-click, а не ручной toggle по @click: на тапе браузер шлёт
                           синтетический mouseover перед click, и own-toggle закрывал бы тултип
                           сразу после открытия (ревью 2026-07-31). -->
                      <v-tooltip bottom max-width="360" open-on-click>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small color="grey darken-1" v-on="on" v-bind="attrs"
                            data-testid="hours-limit-info">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t("companies.hours_limit_info") }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <!-- Судьба остатка часов, который по цене часа стоит не меньше суток
                     (staging 2026-07-31, решение USER 2026-08-01). Дефолт add_day —
                     легаси-поведение, прод не меняется. -->
                <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                  <!-- Короткие подписи режимов непонятны без примера (USER 2026-08-03),
                       поэтому каждый пункт несёт пояснение второй строкой, а выбранный —
                       постоянной подсказкой под полем. -->
                  <v-select v-model="company.expensive_hours_mode" :items="expensiveHoursModes"
                    item-text="text" item-value="value" :label="$t('companies.expensive_hours_mode')"
                    :hint="expensiveHoursModeHint" persistent-hint
                    outlined data-testid="expensive-hours-mode">
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-bind="attrs" v-on="on" style="max-width: 480px">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.text }}</v-list-item-title>
                          <v-list-item-subtitle class="text-wrap text-caption">
                            {{ item.hint }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                <!-- Ряды по 4+4+4: селект режима занял третье место в ряду порога, поэтому
                     «дни возврата залога» переехали в ряд к адресам — иначе сетка рвалась
                     (4+6 и одинокий адрес на своей строке). -->
                <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                  <v-text-field v-model.number="company.part_return_deposit_days"
                    :label="$t('companies.part_return_deposit_days')" v-tooltip="{
                      content: $t('companies.part_return_deposit_days_info'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }" outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                  <v-text-field v-model.trim="company.location_start" :label="$t('bookings.start_place_plc')"
                    :placeholder="$t('custom.start_location')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                  <v-text-field v-model.trim="company.location_end" :label="$t('bookings.end_place_plc')"
                    :placeholder="$t('custom.start_location')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-select v-model="company.rent_type" :items="booking_types"
                    :label="$t('bookings.booking_type_default')" outlined>
                  </v-select>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" id="registration-step-20">
                  <v-checkbox v-model="company.add_driver" :label="$t('companies.add_driver')"
                    :hint="$t('companies.add_driver_info')" persistent-hint outlined></v-checkbox>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-checkbox v-model="company.overbooking" :label="$t('companies.overbooking')" outlined color="error"
                    :hint="$t('companies.overbooking_info')" persistent-hint></v-checkbox>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-checkbox v-model="company.can_select_agents" :label="$t('agents.can_select_agents')" outlined
                    :hint="$t('agents.can_select_agents_info')" persistent-hint></v-checkbox>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" v-if="rental_object != 'cars'">
                  <v-checkbox v-model="company.damage_marking" :label="$t('companies.damage_marking')" outlined
                    :hint="$t('companies.damage_marking_info')" persistent-hint></v-checkbox>
                </v-col>
                
                <!-- Настройки периодических платежей -->
                <v-col cols="12" v-if="company.id == 2">
                  <v-divider class="my-4"></v-divider>
                  <h3 class="mb-4">{{ $t('companies.periodic_payments_settings') }}</h3>
                </v-col>
                
                <v-col cols="12" lg="6" md="6" sm="12" xs="12" v-if="company.id == 2">
                  <v-select 
                    v-model="company.periodic_pricing_method" 
                    :items="periodicPricingMethods"
                    :label="$t('companies.periodic_pricing_method')"
                    outlined
                    :hint="$t('companies.periodic_pricing_method_hint')"
                    persistent-hint
                  ></v-select>
                </v-col>
                
                <v-col cols="12" lg="6" md="6" sm="12" xs="12" v-if="company.id == 2">
                  <v-text-field 
                    v-model.number="company.periodic_balance_warning_days" 
                    :label="$t('companies.periodic_balance_warning_days')"
                    type="number"
                    min="1"
                    outlined
                    :hint="$t('companies.periodic_balance_warning_days_hint')"
                    persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="registration-step-221" color="success" @click="saveCompany()">
                {{ $t("custom.save") }}
                <v-icon class="ml-1">
                  mdi-content-save-check-outline
                </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <!-- Данные компании -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row align="start">
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.name" :label="$t('companies.name')"
                    :placeholder="$t('companies.name_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.phone" :label="$t('companies.phone')"
                    :placeholder="$t('companies.phone_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.site" :label="$t('companies.site')"
                    :placeholder="$t('companies.site_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      " data-testid="company-site-field"></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-autocomplete :label="$t('users.country')" v-model="company.country" :items="countries"
                    item-text="both" item-value="name" outlined>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.city" :label="$t('companies.city')"
                    :placeholder="$t('companies.city_plc')" outlined></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.address" :label="$t('companies.address_fact')"
                    :placeholder="$t('companies.address_fact_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-autocomplete v-model="company.locale" item-text="text" item-value="value" :items="locales"
                    :label="$t('companies.notification_locale')" :placeholder="$t('companies.locale_plc')"
                    outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-autocomplete v-model="company.time_zone" item-text="text" item-value="value" :items="time_zones"
                    :label="$t('companies.time_zone')" :placeholder="$t('companies.time_zone_plc')"
                    outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-select v-model="company.company_type" :items="organizations_forms" item-text="form" item-value="id"
                    :label="$t('companies.company_type')" outlined></v-select>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.company_name" :label="$t('companies.entity_name')"
                    :placeholder="$t('companies.entity_name_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.company_adress" :label="$t('companies.entity_address')"
                    :placeholder="$t('companies.entity_address_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.company_post_adress" :label="$t('companies.postal_address')"
                    :placeholder="$t('companies.postal_address_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.inn" :label="$t('companies.tax_number')"
                    :placeholder="$t('companies.tax_number')" 
                    :hint="vatNumberHint"
                    persistent-hint
                    outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.kpp" :label="$t('companies.kpp')"
                    :placeholder="$t('companies.kpp_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.ogrn" :label="$t('companies.entity_number')"
                    :placeholder="$t('companies.entity_number_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.bank_account" :label="$t('companies.bank_account')"
                    :placeholder="$t('companies.bank_account_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.correspondent_account"
                    :label="$t('companies.correspondent_account')"
                    :placeholder="$t('companies.correspondent_account_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.bank_name" :label="$t('companies.bank_name')"
                    :placeholder="$t('companies.bank_name_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.bik" :label="$t('companies.bik')"
                    :placeholder="$t('companies.bik_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.chief_name" :label="$t('companies.chief_name')"
                    :placeholder="$t('companies.chief_name_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.vk" :label="$t('companies.soc_set_1')"
                    :placeholder="$t('companies.soc_set_1_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.fb" :label="$t('companies.soc_set_2')"
                    :placeholder="$t('companies.soc_set_2_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.instagram" :label="$t('companies.soc_set_3')"
                    :placeholder="$t('companies.soc_set_3_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.youtube" :label="$t('companies.soc_set_4')"
                    :placeholder="$t('companies.soc_set_4_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.yandex" :label="$t('companies.soc_set_5')"
                    :placeholder="$t('companies.soc_set_5_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.google" :label="$t('companies.soc_set_6')"
                    :placeholder="$t('companies.soc_set_6_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-text-field v-model.trim="company.gis" :label="$t('companies.soc_set_7')"
                    :placeholder="$t('companies.soc_set_7_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" :class="isMobile ? '' : 'd-flex align-middle justify-center'
                  " :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    ">
                  <v-text-field v-model.trim="company.token" :label="$t('companies.token')"
                    :placeholder="$t('companies.plc_token')" readonly @click="copyToken()" ref="api_token"
                    type="password" hide-details autocomplete="off" outlined v-tooltip="{
                      content: $t('companies.token_tooltip'),
                      placement: 'bottom-center',
                      classes: ['white--text', 'black'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                    <v-icon slot="append" :color="company.token ? 'green' : 'grey'" @click="copyToken()"
                      cursor="pointer">
                      mdi-content-copy
                    </v-icon>
                  </v-text-field>
                  <v-btn @click="updateToken()" :class="isMobile ? 'my-2' : 'mx-2 my-auto'">{{
                    $t("companies.update_token")
                    }}<v-icon class="ml-1" color="warning">
                      mdi-reload-alert
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="text-left" id="registration-step-23">
                  <p>{{ $t("companies.cash") }}</p>
                  <v-switch v-model="company.cash_payment" :label="$t('companies.cash_payment')" outlined></v-switch>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="text-left">
                  <p>{{ $t("companies.card") }}</p>
                  <v-switch v-model="company.card_payment" :label="$t('companies.card_payment')" outlined></v-switch>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="text-left">
                  <p>{{ $t("companies.card_to_card") }}</p>
                  <v-switch v-model="company.card_to_card_payment" :label="$t('companies.card_to_card_payment')"
                    outlined></v-switch>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="text-left">
                  <p>{{ $t("companies.entity_transfer") }}</p>
                  <v-switch v-model="company.entity_payment" :label="$t('companies.entity_payment')"
                    outlined></v-switch>
                </v-col>
                <v-col v-if="(!includedInPlan('multicurrency') && !includedInPlan('multicashboxes'))" cols="12" lg="12"
                  md="12" sm="12" xs="12">
                  <v-row>
                    <v-col cols="12">
                      <v-select v-model="company.currency" item-text="name" item-value="symbol" :items="currencies"
                        :label="$t('companies.currency')" outlined></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-if="includedInPlan('multicurrency') || includedInPlan('multicashboxes')" cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col v-if="includedInPlan('multicashboxes') && includedInPlan('multicurrency')" cols="12" lg="12"
                  md="12" sm="12" xs="12">
                  <v-row>
                    <v-col cols="12">
                      <v-select v-model="company_currencies" @change="updateCurrencies()" multiple :items="currencies"
                        ref="currencySelect" :disabled="!includedInPlan('multicurrency') || isLoadingUpdateCurrencies"
                        item-text="name" item-value="id" :label="$t('companies.currencies')" outlined
                        :rules="[checkCurrencyLength()]" :loading="isLoadingUpdateCurrencies"
                        :menu-props="{ auto: true, overflowY: true, closeOnClick: false, closeOnContentClick: false, disableKeys: true }"
                        hide-selected return-object hide-details></v-select>
                    </v-col>
                    <v-col cols="12" v-if="!includedInPlan('multicurrency')">
                      <v-btn @click="addNewCurrency()" color="primary" outlined block class="mt-2">{{
                        $t('companies.add_new_currency') }}</v-btn>
                    </v-col>
                    <v-col cols="12" v-if="includedInPlan('multicurrency')">
                      <v-switch v-model="company.manual_currency_rate_update" @change="updateManualCurrencyRateUpdate()"
                        :label="$t('companies.manual_currency_rate_update')"
                        :loading="isLoadingUpdateManualCurrencyRateUpdate" :disabled="company.currencies.length <= 1"
                        hide-details dense></v-switch>
                    </v-col>
                    <v-col cols="12"
                      v-if="company && company.manual_currency_rate_update && company.exchange_rates && company.exchange_rates.length > 0">
                      <v-expansion-panels v-model="activeExchangeRatePanel">
                        <v-expansion-panel v-for="rate in company.exchange_rates" :key="rate.id">
                          <v-expansion-panel-header>
                            {{ findCurrencySymbol(rate.base_currency_id) }}
                            &lt;-&gt;
                              {{ findCurrencySymbol(rate.target_currency_id) }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-text-field :value="exchangeRateDraft(rate)"
                              @input="setExchangeRateDraft(rate, $event)"
                              @keyup.enter="updateExchangeRate(rate)" :label="$t('companies.rate')" outlined
                              hide-details :loading="isLoadingUpdateExchangeRate && updatingExchangeRateId == rate.id"
                              :append-icon="isLoadingUpdateExchangeRate && updatingExchangeRateId == rate.id ? 'mdi-loading' : 'mdi-content-save-outline'"
                              @click:append="updateExchangeRate(rate)"></v-text-field>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-else-if="includedInPlan('multicashboxes') && !includedInPlan('multicurrency')" cols="12"
                  lg="12" md="12" sm="12" xs="12">
                  <v-row>
                    <v-col cols="12" lg="6" md="12" sm="12" xs="12">
                      <v-select v-model="company.currency" item-text="name" item-value="symbol" :items="currencies"
                        :label="$t('companies.currency')" outlined></v-select>
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12" xs="12">
                      <v-btn @click="addNewCurrency()" color="primary" outlined block class="mt-2">{{
                        $t('companies.add_new_currency') }}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="d-flex justify-center">
                  <v-btn id="registration-step-14" color="success" data-testid="company-save-btn" @click="saveCompany()">
                    {{ $t("custom.save") }}
                    <v-icon class="ml-1">mdi-content-save-check-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col v-if="company && company.multicurrency_cashboxes" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-row>
                    <v-col cols="12" class="d-flex align-center justify-center">
                      <h3>{{ $t("companies.company_cashboxes") }}</h3>
                      <v-btn color="success" class="mx-2" outlined icon small @click="addCashbox()">
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col v-for="cashbox, index in company_cashboxes" :key="index" cols="12">
                      <v-row>
                        <v-col cols="12" lg="2" md="2" sm="12" xs="12">
                          <v-text-field v-model="cashbox.name" :label="$t('companies.cashbox_name')"
                            :placeholder="$t('companies.cashbox_name_plc')" outlined hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="3" md="3" sm="12" xs="12">
                          <v-text-field v-model="cashbox.cash" :label="$t('companies.cashbox_start_cash')"
                            :readonly="cashbox.id ? true : false" hide-details placeholder="0" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="3" md="3" sm="12" xs="12">
                          <v-text-field v-model="cashbox.cashless" :label="$t('companies.cashbox_start_cashless')"
                            :readonly="cashbox.id ? true : false" hide-details placeholder="0" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="2" md="2" sm="12" xs="12">
                          <v-select :items="company.currencies" v-model="cashbox.currency_id" item-text="name"
                            item-value="id" :readonly="cashbox.id ? true : false" :label="$t('companies.currency')"
                            outlined hide-details></v-select>
                        </v-col>
                        <v-col cols="12" lg="2" md="2" sm="12" xs="12" align="center" align-self="center">
                          <v-btn v-if="cashbox.new" class="mx-2" icon color="success"
                            @click="saveCashbox(cashbox), updating_cashbox = cashbox.id"
                            :disabled="!cashbox.name || !cashbox.currency_id ? true : false"
                            :loading="isLoadingSaveCashbox && updating_cashbox == cashbox.id">
                            <v-icon>mdi-content-save-outline</v-icon>
                          </v-btn>
                          <v-btn v-if="cashbox.id" class="mx-2" icon color="success"
                            @click="updateCashbox(cashbox), updating_cashbox = cashbox.id"
                            :disabled="!cashbox.name ? true : false"
                            :loading="isLoadingUpdateCashbox && updating_cashbox == cashbox.id">
                            <v-icon>mdi-content-save-outline</v-icon>
                          </v-btn>
                          <v-btn v-if="cashbox.id" class="mx-2" icon :color="cashbox.is_default ? 'red' : 'secondary'"
                            @click="makeCashboxDefault(cashbox), updating_cashbox = cashbox.id"
                            :loading="isLoadingMakeCashboxDefault && updating_cashbox == cashbox.id"
                            :disabled="!cashbox.is_active || cashbox.currency_id != base_currency_id">
                            <v-icon>mdi-heart-circle-outline</v-icon>
                          </v-btn>
                          <v-btn v-if="cashbox.id && cashbox.is_active" class="mx-2" icon color="secondary"
                            @click="deactivateCashbox(cashbox), updating_cashbox = cashbox.id"
                            :disabled="cashbox.is_default">
                            <v-icon>mdi-eye-off-outline</v-icon>
                          </v-btn>
                          <v-btn v-if="cashbox.id && !cashbox.is_active" class="mx-2" icon color="warning"
                            @click="activateCashbox(cashbox), updating_cashbox = cashbox.id"
                            :loading="isLoadingActivateCashbox && updating_cashbox == cashbox.id">
                            <v-icon>mdi-eye-outline</v-icon>
                          </v-btn>
                          <v-btn v-if="cashbox.id" icon color="error"
                            @click="deleteCashbox(cashbox), updating_cashbox = cashbox.id"
                            :loading="isLoadingDeleteCashbox && updating_cashbox == cashbox.id"
                            :disabled="cashbox.is_default">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                          <v-btn v-else color="error" icon @click="deleteCashboxFromStore(cashbox)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Загрузка шаблонов -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col md12 class="text-center my-3">
                  <a v-if="company.word_templates" :href="$i18n.locale == 'ru'
                    ? '/doc_example.docx'
                    : '/doc_example_en.docx'
                    " target="_blank" style="font-weight: bold" id="registration-step-25">{{
                      $t("companies.template_example_download") }}</a>
                  <br v-if="company.word_templates" />
                  <a v-if="company.word_templates" :href="$i18n.locale == 'ru'
                    ? '/entity_doc_example.docx'
                    : '/entity_doc_example_en.docx'
                    " target="_blank" style="font-weight: bold" id="registration-step-25">{{
                      $t("companies.entity_template_example_download") }}</a>
                  <br v-if="company.word_templates" />
                  <a v-if="company.word_templates" :href="$i18n.locale == 'ru'
                    ? '/invoice_example.docx'
                    : '/invoice_example_en.docx'
                    " target="_blank" style="font-weight: bold" id="registration-step-25">{{
                      $t("companies.invoice_template_example_download")
                    }}</a>
                  <br v-if="company.word_templates" />
                  <a v-if="company.word_templates" :href="$i18n.locale == 'ru'
                    ? '/prolong_example.docx'
                    : '/prolong_example_en.docx'
                    " target="_blank" style="font-weight: bold" id="registration-step-25">{{
                      $t("companies.prolong_template_example_download")
                    }}</a>
                  <br v-if="company.word_templates" />
                  <!-- <a v-if="company.word_templates" id="registration-step-26" text href="/help/doc_variables"
                      target="_blank" style="font-weight: bold">{{ $t("companies.variables") }}</a> -->
                  <div class="d-flex justify-center align-center mt-2">
                    <v-btn color="info" outlined to="/help/doc_variables">{{
                      $t("companies.variables")
                    }}</v-btn>
                  </div>
                  <v-row class="d-flex justify-center align-center">
                    <v-col cols="12" class="d-flex justify-center align-center">
                      <v-switch :label="$t('templates.word_templates')" hide-details class="mx-auto"
                        v-model="company.word_templates" @change="saveCompany()"></v-switch>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center align-center">
                      <v-switch :label="$t('companies.docx_upload_custom_templates')" hide-details class="mx-auto"
                        v-model="company.docx_templates_on" @change="saveCompany()"
                        :disabled="!company.word_templates"></v-switch>
                    </v-col>
                    <v-col v-if="!company.pdf_templates && company.new_templates" cols="12"
                      class="d-flex justify-center align-center">
                      <v-switch :label="$t('templates.new_templates')" hide-details class="mx-auto"
                        v-model="company.new_templates" @change="saveCompany()"></v-switch>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center align-center">
                      <v-switch :label="$t('header.pdf_templates')" hide-details class="mx-auto"
                        v-model="company.pdf_templates" @change="saveCompany()"></v-switch>
                    </v-col>
                  </v-row>
                  <v-divider class="mb-2 mt-4"></v-divider>
                </v-col>
                <v-col v-if="company.word_templates" cols="12" id="registration-step-27" class="text-center">
                  <h3 mb-3>{{ $t("companies.doc_upload") }}</h3>
                  <v-btn v-if="doc_template_url && isStaff" small text :href="doc_template_url"
                    target="_blank">{{ $t("companies.download_current") }}</v-btn>
                  <uppy :max-file-size-in-bytes="10000000" width="auto" :height="250"
                    :theme="$vuetify.theme.dark ? 'dark' : 'light'" v-if="isStaff"></uppy>
                </v-col>
                <v-col v-if="company.word_templates" cols="12" class="text-center">
                  <h3 mb-3>{{ $t("companies.entity_upload") }}</h3>
                  <v-btn v-if="entity_doc_template_url && isStaff" small text
                    :href="entity_doc_template_url" target="_blank">{{ $t("companies.download_current") }}</v-btn>
                  <uppy-entity :max-file-size-in-bytes="10000000" width="auto" :height="250"
                    :theme="$vuetify.theme.dark ? 'dark' : 'light'" v-if="isStaff"></uppy-entity>
                </v-col>
                <v-col v-if="company.word_templates" cols="12" class="text-center">
                  <h3 mb-3>{{ $t("companies.invoice_upload") }}</h3>
                  <v-btn v-if="invoice_doc_template_url && isStaff" small text
                    :href="invoice_doc_template_url" target="_blank">{{ $t("companies.download_current") }}</v-btn>
                  <uppy-invoice :max-file-size-in-bytes="10000000" width="auto" :height="250"
                    :theme="$vuetify.theme.dark ? 'dark' : 'light'" v-if="isStaff"></uppy-invoice>
                </v-col>
                <v-col v-if="company.word_templates" cols="12" class="text-center">
                  <h3 mb-3>{{ $t("companies.prolong_upload") }}</h3>
                  <v-btn v-if="prolong_template_url && isStaff" small text :href="prolong_template_url"
                    target="_blank">{{ $t("companies.download_current") }}</v-btn>
                  <uppy-prolong :max-file-size-in-bytes="10000000" width="auto" :height="250"
                    :theme="$vuetify.theme.dark ? 'dark' : 'light'" v-if="isStaff"></uppy-prolong>
                </v-col>
                <v-divider class="my-2"></v-divider>
                <v-col v-if="company.word_templates && company.docx_templates_on" cols="12">
                  <v-card outlined :class="isMobile ? 'pa-2' : 'pa-4'">
                    <v-card-title :class="isMobile ? 'flex-column align-start pb-2 px-2' : 'pb-2'">
                      <div class="d-flex align-center" :class="isMobile ? 'mb-2' : ''">
                        <v-icon color="primary" class="mr-2">mdi-file-document-multiple</v-icon>
                        <span :class="isMobile ? 'text-subtitle-1' : 'text-h6'">{{ $t("companies.docx_upload_custom_templates_title") }}</span>
                      </div>
                      <v-spacer v-if="!isMobile"></v-spacer>
                      <v-btn 
                        color="primary" 
                        depressed 
                        @click="addNewDocxTemplate()" 
                        :class="isMobile ? 'px-3' : 'px-6'"
                        :small="isMobile"
                        :block="isMobile"
                      >
                        <span class="mr-1">{{ $t("companies.upload_new_docx_template_btn") }}</span>
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-divider class="mb-4"></v-divider>

                    <v-row v-if="company && company.docx_templates_on && docx_templates.length === 0" justify="center"
                      class="py-8">
                      <v-col cols="12" class="text-center">
                        <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-file-document-plus</v-icon>
                        <p class="text-h6 grey--text">{{ $t("companies.no_docx_templates") }}</p>
                        <p class="grey--text">{{ $t("companies.click_to_add_new_docx_template") }}</p>
                      </v-col>
                    </v-row>

                    <v-row v-else-if="company && company.docx_templates_on">
                      <v-col cols="12" md="6" lg="4" v-for="(docx_template, index) in docx_templates" :key="index"
                        class="mb-4">
                        <v-card outlined hover class="h-100">
                          <v-card-title class="py-2 d-flex align-center justify-end">
                            <v-btn v-if="docx_template && docx_template.id" icon small color="primary"
                              @click="moveDocxTemplate(docx_template, index, 'up')" class="ml-2"
                              :disabled="index === 0 || isLoadingMoveDocxTemplate"
                              :loading="isLoadingMoveDocxTemplate && docx_template.id == moved_up_docx_template">
                              <v-icon>mdi-arrow-up</v-icon>
                            </v-btn>
                            <v-btn v-if="docx_template && docx_template.id" icon small color="primary"
                              @click="moveDocxTemplate(docx_template, index, 'down')" class="ml-2"
                              :disabled="index === docx_templates.length - 1 || isLoadingMoveDocxTemplate"
                              :loading="isLoadingMoveDocxTemplate && docx_template.id == moved_down_docx_template">
                              <v-icon>mdi-arrow-down</v-icon>
                            </v-btn>
                            <v-btn icon small color="error" @click="deleteDocxTemplate(docx_template, index)"
                              class="ml-2"
                              :loading="isLoadingDeleteDocxTemplate && docx_template.id == deleted_docx_template.id">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-card-title>

                          <v-card-text class="pb-2">
                            <v-row>
                              <v-col cols="12" class="mb-0 pb-0">
                                <v-text-field v-model="docx_template.name" :label="$t('companies.docx_template_name')"
                                  outlined dense prepend-inner-icon="mdi-rename-box" clearable
                                  @blur="updateDocxTemplate(docx_template)"
                                  :loading="isLoadingUpdateDocxTemplate && docx_template.id == updated_docx_template.id"></v-text-field>
                              </v-col>
                              <v-col cols="12" class="text-center mb-4">
                                <v-btn text :disabled="!docx_template.url" :href="docx_template.url" target="_blank">{{
                                  $t("companies.download_current") }}</v-btn>
                              </v-col>
                              <v-col cols="12">
                                <div class="upload-container">
                                  <uppy-docx :max-file-size-in-bytes="10000000" width="100%" :height="200"
                                    :theme="$vuetify.theme.dark ? 'dark' : 'light'" v-if="isStaff"
                                    :docx_template="docx_template"></uppy-docx>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Уведомления -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-md :class="$vuetify.theme.dark ? 'dark' : ''">
                <v-layout row wrap class="">
                  <!-- Настройки каналов уведомлений для клиентов -->
                  <v-flex md12>
                    <h3 class="mb-2">{{ $t("notification_channels.title") }}</h3>
                    <p class="caption grey--text">{{ $t("notification_channels.description") }}</p>
                  </v-flex>

                  <v-flex md6 sm12>
                    <v-select
                      v-model="notificationChannelsMode"
                      :items="notificationChannelsModeOptions"
                      :label="$t('notification_channels.mode_label')"
                      outlined
                      dense
                      @change="saveNotificationChannelsConfig()"
                    ></v-select>
                  </v-flex>

                  <v-flex md6 sm12 v-if="notificationChannelsMode === 'single'">
                    <v-select
                      v-model="notificationChannelsPrimary"
                      :items="availableNotificationChannels"
                      :label="$t('notification_channels.primary_channel')"
                      outlined
                      dense
                      @change="saveNotificationChannelsConfig()"
                    ></v-select>
                  </v-flex>

                  <v-flex md12 v-if="notificationChannelsMode === 'cascade'">
                    <p class="subtitle-2 mb-2">{{ $t("notification_channels.priority_label") }}</p>
                    <p class="caption grey--text mb-2">{{ $t("notification_channels.priority_hint") }}</p>
                    <v-chip-group v-if="notificationChannelsPriority.length > 0">
                      <v-chip
                        v-for="(channel, index) in notificationChannelsPriority"
                        :key="channel"
                        class="ma-1"
                        :color="getChannelColor(channel)"
                        dark
                        small
                      >
                        <v-icon small left v-if="index > 0" @click="moveChannelUp(index)">mdi-arrow-up</v-icon>
                        {{ index + 1 }}. {{ getChannelName(channel) }}
                        <v-icon small right v-if="index < notificationChannelsPriority.length - 1" @click="moveChannelDown(index)">mdi-arrow-down</v-icon>
                      </v-chip>
                    </v-chip-group>
                    <v-alert v-else type="info" text dense class="mt-2">
                      {{ $t("notification_channels.no_channels_hint") }}
                    </v-alert>
                  </v-flex>

                  <v-flex md6 sm12 v-if="notificationChannelsMode === 'single' && availableNotificationChannels.length === 0">
                    <v-alert type="info" text dense>
                      {{ $t("notification_channels.no_channels_hint") }}
                    </v-alert>
                  </v-flex>

                  <v-flex lg12 md12>
                    <v-divider class="my-4"></v-divider>
                  </v-flex>
                  <!-- /Настройки каналов уведомлений для клиентов -->

                  <v-flex md4 sm12>
                    <v-switch v-model="company.send_new_bookings" @change="saveCompany()"
                      :label="$t('companies.notify_new_bookings')" outlined></v-switch>
                  </v-flex>
                  <v-flex md8 sm12>
                    <v-text-field v-model.trim="company.email_for_bookings" :label="$t('companies.email_for_bookings')"
                      :placeholder="$t('companies.email_for_bookings_plc')" outlined hide-details>
                      <template v-slot:append>
                        <!-- Адрес отклонён Postmark (invalid_email): письма не доставляются -->
                        <v-icon v-if="company.invalid_email" color="warning" v-tooltip="{
                          content: $t('custom.invalid_email_tooltip'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                        }">mdi-email-alert-outline</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex md4 sm12>
                    <v-switch v-model="company.send_booking_icalendar" @change="saveCompany()"
                      :label="$t('companies.send_booking_icalendar')" outlined></v-switch>
                  </v-flex>
                  <v-flex md8 sm12>
                    <p>{{ $t("companies.send_booking_icalendar_info") }}</p>
                  </v-flex>
                  <!-- Новые настраиваемые шаблоны уведомлений о бронировании -->
                  <v-flex lg12 md12>
                    <v-divider class="my-4"></v-divider>
                  </v-flex>
                  <v-flex md12>
                    <BookingMessageTemplates />
                  </v-flex>
                  
                  <!-- Новые настраиваемые шаблоны периодических платежей -->
                  <v-flex lg12 md12>
                    <v-divider class="my-4"></v-divider>
                  </v-flex>
                  <v-flex md12>
                    <PeriodicPaymentTemplates />
                  </v-flex>
                  
                  <v-flex lg12 md12>
                    <v-divider class="my-2"></v-divider>
                  </v-flex>
                  <v-flex md12>
                    <v-switch v-model="company.new_booking_sound" :label="$t('companies.new_booking_sound')" outlined></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="registration-step-14" color="success" @click="saveCompany()">
                {{ $t("custom.save") }}
                <v-icon class="ml-1">
                  mdi-content-save-check-outline
                </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <!-- Клиенты -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout row wrap centered class="d-flex text-center justify-center">
                  <v-flex md12>
                    <h2 class="mb-2">{{ $t("companies.clients_sources") }}</h2>
                    <v-btn small color="info" @click="addClientSource">
                      + {{ $t("companies.add_source") }}
                    </v-btn>
                  </v-flex>
                  <v-flex md4 xs12 v-for="(source, index) in clients_sources" :key="index"
                    class="d-flex text-center justify-center">
                    <v-text-field v-model.trim="source.value" :label="$t('companies.source')" outlined hide-details
                      dense></v-text-field>
                    <v-btn small icon @click="deleteClientSource(index)" class="mt-1 ml-1">
                      <v-icon> mdi-delete </v-icon>
                    </v-btn>
                  </v-flex>
                  <v-row v-if="ygibdd_active" class="mt-2">
                    <v-col cols="12" class="text-center mt-2 ">
                      <h2 class="mb-2">{{ $t("custom.fines") }}</h2>
                    </v-col>
                    <v-col cols="12" class="text-center">
                      <v-switch v-model="fines_auto_select" @change="saveCompany()" :label="$t('fines.fines_auto_select')
                        " class="mt-0 pt-0" hide-details v-tooltip="{
                          content: $t('fines.fines_auto_select_tooltip'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }"></v-switch>
                      <p class="text-left caption">{{ $t('fines.fines_auto_select_tooltip') }}</p>
                    </v-col>
                  </v-row>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="saveCompany()">{{ $t("custom.save")
              }}<v-icon class="ml-1">
                  mdi-content-save-check-outline
                </v-icon></v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <!-- Интеграции -->
        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-expansion-panels v-model="dataIntegrationsPanel">
                    <v-expansion-panel :disabled="!includedInPlan('whatsapp_notifications')">
                      <v-expansion-panel-header>
                        WhatsApp
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t("whatsapp.whatsapp_not_official") }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" v-if="company && company.whatsapp_state == 'blocked'" class="text-center">
                            <v-alert type="error" outlined>{{ $t("companies.whatsapp_blocked") }}</v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && (company.whatsapp_state == 'not_authorized' || company.whatsapp_state == 'notAuthorized')"
                            class="text-center">
                            <v-alert type="warning" outlined>{{ $t("companies.whatsapp_not_authorized") }}</v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && (company.whatsapp_state == 'suspended' || company.whatsapp_state == 'yellowCard')"
                            class="text-center">
                            <v-alert type="warning" outlined>
                              {{ $t("companies.whatsapp_suspended_text") }}<template v-if="company.whatsapp_suspended_until"><br>
                                {{ $t("companies.whatsapp_suspended_until") }}: {{ formatWhatsappSuspendedUntil(company.whatsapp_suspended_until) }}</template>
                            </v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && company.whatsapp_state && company.whatsapp_state !== 'not_exists'" class="text-center">
                            <v-chip
                              :color="getWhatsappStateColor(company.whatsapp_state)"
                              dark
                              small
                            >
                              <v-icon small left>mdi-information-outline</v-icon>
                              {{ $t("companies.whatsapp_state") }}: {{ getWhatsappStateText(company.whatsapp_state) }}
                            </v-chip>
                          </v-col>
                          <v-col cols="12" class="d-flex justify-center align-center">
                            <v-btn v-if="!company.whatsapp || company.whatsapp_state === 'not_exists'" small depressed class="mx-1" color="success" :disabled="!(
                              main_company.balance > 0 || isLoadingCreateWhatsappInstance || isLoadingDeleteWhatsappInstance
                            )
                              " @click="createWhatsappInstance()"
                              :loading="isLoadingCreateWhatsappInstance || isLoadingDeleteWhatsappInstance">{{
                                $t("companies.whatsapp_create_instance") }}
                            </v-btn>
                            <v-btn v-if="company.whatsapp && company.whatsapp_state !== 'not_exists' && !isLoadingCreateWhatsappInstance" small depressed
                              class="mx-1" color="error" :disabled="!(
                                company.chat_api_instance &&
                                company.chat_api_instance.length > 0 &&
                                company.chat_api_token &&
                                company.chat_api_token.length > 0
                              ) || isLoadingDeleteWhatsappInstance || isLoadingCreateWhatsappInstance
                                " @click="deleteWhatsappInstance()"
                              :loading="isLoadingDeleteWhatsappInstance || isLoadingCreateWhatsappInstance">{{
                                $t("companies.whatsapp_delete_instance") }}
                            </v-btn>
                            <v-btn v-if="company.whatsapp && company.whatsapp_state !== 'not_exists'" small depressed class="mx-1" color="success"
                              :disabled="!company.whatsapp || isLoadingCreateWhatsappInstance || isLoadingDeleteWhatsappInstance || company.whatsapp_state == 'blocked' || company.whatsapp_state == 'starting'"
                              @click="authoriseWhatsapp()"
                              :loading="isLoadingAuthoriseWhatsapp || isLoadingCreateWhatsappInstance || isLoadingDeleteWhatsappInstance">
                              {{ $t("companies.whatsapp_authorise") }}
                            </v-btn>
                            <v-btn v-if="company.whatsapp && company.whatsapp_state !== 'not_exists'" small depressed class="mx-1" color="primary"
                              :disabled="isLoadingWhatsappActions || company.whatsapp_state === 'starting'"
                              @click="checkWhatsappState()"
                              :loading="isLoadingWhatsappActions">
                              {{ $t("companies.whatsapp_check_state") }}
                            </v-btn>
                            <v-btn v-if="company.whatsapp && company.whatsapp_state !== 'not_exists'" small depressed class="mx-1" color="warning"
                              :disabled="isLoadingWhatsappActions || company.whatsapp_state === 'starting'"
                              @click="rebootWhatsapp()"
                              :loading="isLoadingWhatsappActions">
                              {{ $t("companies.whatsapp_reboot") }}
                            </v-btn>
                            <v-btn v-if="company.whatsapp && company.whatsapp_state === 'authorized'" small depressed class="mx-1" color="secondary"
                              :disabled="isLoadingWhatsappActions || company.whatsapp_state === 'starting'"
                              @click="logoutWhatsapp()"
                              :loading="isLoadingWhatsappActions">
                              {{ $t("companies.whatsapp_logout") }}
                            </v-btn>
                            <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
                              }/${$root.$i18n.locale}/categories/8/guides/39`" target="_blank">
                              <v-icon>mdi-help-circle</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12">
                            <p>
                              {{ $t("companies.whatsapp_info") }} {{ main_company && main_company.plan && main_company.currency == 'RUB'
                                ? $t("companies.whatsapp_price_rub", { price: main_company.plan.whatsapp_cost, currency: main_company.plan.currency })
                                : (main_company && main_company.plan ? $t("companies.whatsapp_price_eur", { price: main_company.plan.whatsapp_cost, currency: main_company.plan.currency }) : '') }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Telegram Notifications -->
                    <v-expansion-panel :disabled="!includedInPlan('telegram_notifications')">
                      <v-expansion-panel-header>
                        Telegram
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t("included_services.telegram_notifications") }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-switch v-model="company.telegram_on" :label="$t('companies.telegram_on')"
                              outlined></v-switch>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model.number="company.telegram_id" dense label="Telegram ID"
                              :placeholder="$t('companies.tg_id')" outlined hide-details></v-text-field>
                            <p>
                              <!-- {{ $t("companies.telegram_info") }} -->
                              <a :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
                                }/${$root.$i18n.locale}/categories/8/guides/32`">{{ $t("telegram.more")
                                }}</a>
                            </p>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" @click="saveCompany()">
                              {{ $t("custom.save") }}
                              <v-icon class="ml-1">
                                mdi-content-save-check-outline
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Telegram Green-API -->
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Telegram
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t("telegram_green_api.title") }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" v-if="company && company.telegram_green_api_state == 'blocked'" class="text-center">
                            <v-alert type="error" outlined>{{ $t("telegram_green_api.blocked") }}</v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && (company.telegram_green_api_state == 'not_authorized' || company.telegram_green_api_state == 'notAuthorized')"
                            class="text-center">
                            <v-alert type="warning" outlined>{{ $t("telegram_green_api.not_authorized") }}</v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && company.telegram_green_api_state && company.telegram_green_api_state !== 'not_exists'" class="text-center">
                            <v-chip
                              :color="getTelegramGreenApiStateColor(company.telegram_green_api_state)"
                              dark
                              small
                            >
                              <v-icon small left>mdi-information-outline</v-icon>
                              {{ $t("telegram_green_api.state") }}: {{ getTelegramGreenApiStateText(company.telegram_green_api_state) }}
                            </v-chip>
                          </v-col>
                          <v-col cols="12" class="d-flex justify-center align-center flex-wrap">
                            <v-btn v-if="!company.telegram_green_api_enabled || company.telegram_green_api_state === 'not_exists'" small depressed class="mx-1 my-1" color="success"
                              :disabled="!(main_company.balance > 0) || isLoadingCreateTelegramGreenApiInstance || isLoadingDeleteTelegramGreenApiInstance"
                              @click="createTelegramGreenApiInstance()"
                              :loading="isLoadingCreateTelegramGreenApiInstance || isLoadingDeleteTelegramGreenApiInstance">
                              {{ $t("telegram_green_api.create_instance") }}
                            </v-btn>
                            <v-btn v-if="company.telegram_green_api_enabled && company.telegram_green_api_state !== 'not_exists' && !isLoadingCreateTelegramGreenApiInstance" small depressed
                              class="mx-1 my-1" color="error"
                              :disabled="!(company.telegram_green_api_instance && company.telegram_green_api_instance.length > 0 && company.telegram_green_api_token && company.telegram_green_api_token.length > 0) || isLoadingDeleteTelegramGreenApiInstance || isLoadingCreateTelegramGreenApiInstance"
                              @click="deleteTelegramGreenApiInstance()"
                              :loading="isLoadingDeleteTelegramGreenApiInstance || isLoadingCreateTelegramGreenApiInstance">
                              {{ $t("telegram_green_api.delete_instance") }}
                            </v-btn>
                            <v-btn v-if="company.telegram_green_api_enabled && company.telegram_green_api_state !== 'not_exists'" small depressed class="mx-1 my-1" color="success"
                              :disabled="!company.telegram_green_api_enabled || isLoadingCreateTelegramGreenApiInstance || isLoadingDeleteTelegramGreenApiInstance || company.telegram_green_api_state == 'blocked' || company.telegram_green_api_state == 'starting'"
                              @click="openTelegramGreenApiAuthDialog()"
                              :loading="isLoadingTelegramGreenApiQr">
                              {{ $t("telegram_green_api.authorise") }}
                            </v-btn>
                            <v-btn v-if="company.telegram_green_api_enabled && company.telegram_green_api_state !== 'not_exists'" small depressed class="mx-1 my-1" color="primary"
                              :disabled="isLoadingTelegramGreenApiActions || company.telegram_green_api_state === 'starting'"
                              @click="checkTelegramGreenApiState()"
                              :loading="isLoadingTelegramGreenApiActions">
                              {{ $t("telegram_green_api.check_state") }}
                            </v-btn>
                            <v-btn v-if="company.telegram_green_api_enabled && company.telegram_green_api_state !== 'not_exists'" small depressed class="mx-1 my-1" color="warning"
                              :disabled="isLoadingTelegramGreenApiActions || company.telegram_green_api_state === 'starting'"
                              @click="rebootTelegramGreenApi()"
                              :loading="isLoadingTelegramGreenApiActions">
                              {{ $t("telegram_green_api.reboot") }}
                            </v-btn>
                            <v-btn v-if="company.telegram_green_api_enabled && company.telegram_green_api_state === 'authorized'" small depressed class="mx-1 my-1" color="secondary"
                              :disabled="isLoadingTelegramGreenApiActions || company.telegram_green_api_state === 'starting'"
                              @click="logoutTelegramGreenApi()"
                              :loading="isLoadingTelegramGreenApiActions">
                              {{ $t("telegram_green_api.logout") }}
                            </v-btn>
                          </v-col>
                          <v-col cols="12">
                            <p>
                              {{ $t("telegram_green_api.info") }} {{ main_company && main_company.plan && main_company.currency == 'RUB'
                                ? $t("telegram_green_api.price_rub", { price: main_company.plan.telegram_cost, currency: main_company.plan.currency })
                                : (main_company && main_company.plan ? $t("telegram_green_api.price_eur", { price: main_company.plan.telegram_cost, currency: main_company.plan.currency }) : '') }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- Telegram Green-API Authorization Dialog (QR Code) -->
                    <v-dialog v-model="telegramGreenApiAuthDialog" max-width="500" @click:outside="closeTelegramGreenApiAuthDialog">
                      <v-card>
                        <v-card-title class="headline">
                          {{ $t("telegram_green_api.authorise_title") }}
                        </v-card-title>

                        <v-card-text class="text-center">
                          <!-- Шаг: Ожидание ввода 2FA-пароля (QR отсканирован) -->
                          <div v-if="telegramGreenApiAuthStep === 'pendingPassword'">
                            <v-alert type="warning" text dense class="mb-4">
                              {{ $t("telegram_green_api.pending_password_hint") }}
                            </v-alert>
                            <div class="text-left">
                              <v-text-field
                                v-model="telegramGreenApiAuthPassword"
                                :label="$t('telegram_green_api.password_label')"
                                outlined
                                type="password"
                                autofocus
                              ></v-text-field>
                              <v-btn
                                color="primary"
                                block
                                :loading="isLoadingTelegramGreenApiSendPassword"
                                :disabled="!telegramGreenApiAuthPassword"
                                @click="telegramGreenApiSendPassword()"
                              >
                                {{ $t("telegram_green_api.send_password") }}
                              </v-btn>
                            </div>

                            <!-- Ошибка отправки пароля -->
                            <v-alert v-if="telegramGreenApiPasswordError" type="error" text class="mt-4">
                              {{ telegramGreenApiPasswordError }}
                            </v-alert>
                          </div>

                          <!-- Шаг: Загрузка QR-кода -->
                          <div v-else-if="isLoadingTelegramGreenApiQr" class="py-8">
                            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                            <p class="mt-4">{{ $t("telegram_green_api.loading_qr") }}</p>
                          </div>

                          <!-- Шаг: QR-код -->
                          <div v-else-if="telegramGreenApiQrCode">
                            <v-img
                              :src="'data:image/png;base64,' + telegramGreenApiQrCode"
                              max-height="300"
                              max-width="300"
                              class="mx-auto"
                            ></v-img>
                            <v-alert type="info" text dense class="mt-4">
                              {{ $t("telegram_green_api.scan_qr_hint") }}
                            </v-alert>

                            <!-- 2FA пароль (опционально — можно ввести заранее) -->
                            <div class="mt-4 text-left">
                              <v-text-field
                                v-model="telegramGreenApiAuthPassword"
                                :label="$t('telegram_green_api.password_label')"
                                :hint="$t('telegram_green_api.password_hint')"
                                persistent-hint
                                outlined
                                dense
                                type="password"
                              ></v-text-field>
                              <v-btn
                                color="primary"
                                block
                                class="mt-2"
                                :loading="isLoadingTelegramGreenApiSendPassword"
                                :disabled="!telegramGreenApiAuthPassword"
                                @click="telegramGreenApiSendPassword()"
                              >
                                {{ $t("telegram_green_api.send_password") }}
                              </v-btn>
                            </div>

                            <!-- Ошибка отправки пароля -->
                            <v-alert v-if="telegramGreenApiPasswordError" type="error" text class="mt-4">
                              {{ telegramGreenApiPasswordError }}
                            </v-alert>
                          </div>

                          <!-- Ошибка получения QR -->
                          <div v-else-if="telegramGreenApiQrError">
                            <v-alert type="error" text>
                              {{ telegramGreenApiQrError }}
                            </v-alert>
                            <v-btn color="primary" class="mt-4" @click="fetchTelegramGreenApiQrCode">
                              {{ $t("custom.try_again") }}
                            </v-btn>
                          </div>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="closeTelegramGreenApiAuthDialog">
                            {{ $t("custom.close") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-expansion-panel v-if="includedInPlan('messenger_max')">
                      <v-expansion-panel-header>
                        {{ $t("companies.messenger_max") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" v-if="company && company.max_state == 'blocked'" class="text-center">
                            <v-alert type="error" outlined>{{ $t("companies.max_blocked") }}</v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && (company.max_state == 'suspended' || company.max_state == 'yellowCard')"
                            class="text-center">
                            <v-alert type="warning" outlined>
                              {{ $t("companies.max_suspended_text") }}<template v-if="company.max_suspended_until"><br>
                                {{ $t("companies.max_suspended_until") }}: {{ formatWhatsappSuspendedUntil(company.max_suspended_until) }}</template>
                            </v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && (company.max_state == 'not_authorized' || company.max_state == 'notAuthorized')"
                            class="text-center">
                            <v-alert type="warning" outlined>{{ $t("companies.max_not_authorized") }}</v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && company.max_state == 'pendingPassword'" class="text-center">
                            <v-alert type="warning" outlined>{{ $t("companies.max_pending_password") }}</v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && company.max_state && company.max_state !== 'not_exists'" class="text-center">
                            <v-chip
                              :color="getMaxStateColor(company.max_state)"
                              dark
                              small
                            >
                              <v-icon small left>mdi-information-outline</v-icon>
                              {{ $t("companies.max_state") }}: {{ getMaxStateText(company.max_state) }}
                            </v-chip>
                          </v-col>
                          <v-col cols="12" class="d-flex justify-center align-center">
                            <v-btn v-if="!company.max_enabled || company.max_state === 'not_exists'" small depressed class="mx-1" color="success" :disabled="!(
                              main_company.balance > 0 || isLoadingCreateMaxInstance || isLoadingDeleteMaxInstance
                            )
                              " @click="createMaxInstance()"
                              :loading="isLoadingCreateMaxInstance || isLoadingDeleteMaxInstance">{{
                                $t("companies.max_create_instance") }}
                            </v-btn>
                            <v-btn v-if="company.max_enabled && company.max_state !== 'not_exists' && !isLoadingCreateMaxInstance" small depressed
                              class="mx-1" color="error" :disabled="!(
                                company.max_instance &&
                                company.max_instance.length > 0 &&
                                company.max_token &&
                                company.max_token.length > 0
                              ) || isLoadingDeleteMaxInstance || isLoadingCreateMaxInstance
                                " @click="deleteMaxInstance()"
                              :loading="isLoadingDeleteMaxInstance || isLoadingCreateMaxInstance">{{
                                $t("companies.max_delete_instance") }}
                            </v-btn>
                            <v-btn v-if="company.max_enabled && company.max_state !== 'not_exists'" small depressed class="mx-1" color="success"
                              :disabled="!company.max_enabled || isLoadingCreateMaxInstance || isLoadingDeleteMaxInstance || company.max_state == 'blocked' || company.max_state == 'starting'"
                              @click="authoriseMax()"
                              :loading="isLoadingAuthoriseMax || isLoadingCreateMaxInstance || isLoadingDeleteMaxInstance">
                              {{ $t("companies.max_authorise") }}
                            </v-btn>
                            <v-btn v-if="company.max_enabled && company.max_state !== 'not_exists'" small depressed class="mx-1" color="primary"
                              :disabled="isLoadingMaxActions || company.max_state === 'starting'"
                              @click="checkMaxState()"
                              :loading="isLoadingMaxActions">
                              {{ $t("companies.max_check_state") }}
                            </v-btn>
                            <v-btn v-if="company.max_enabled && company.max_state !== 'not_exists'" small depressed class="mx-1" color="warning"
                              :disabled="isLoadingMaxActions || company.max_state === 'starting'"
                              @click="rebootMax()"
                              :loading="isLoadingMaxActions">
                              {{ $t("companies.max_reboot") }}
                            </v-btn>
                            <v-btn v-if="company.max_enabled && company.max_state === 'authorized'" small depressed class="mx-1" color="secondary"
                              :disabled="isLoadingMaxActions || company.max_state === 'starting'"
                              @click="logoutMax()"
                              :loading="isLoadingMaxActions">
                              {{ $t("companies.max_logout") }}
                            </v-btn>
                          </v-col>
                          <v-col cols="12">
                            <p>
                              {{ $t("companies.max_info") }} {{ main_company && main_company.plan && main_company.currency == 'RUB'
                                ? $t("companies.max_price_rub", { price: main_company.plan.messenger_max_cost, currency: main_company.plan.currency })
                                : (main_company && main_company.plan ? $t("companies.max_price_eur", { price: main_company.plan.messenger_max_cost, currency: main_company.plan.currency }) : '') }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                    <!-- FT-149 REQ-02: диалог авторизации WhatsApp — код по номеру (начальная вкладка) и QR -->
                    <v-dialog v-model="whatsappAuthDialog" max-width="500" @click:outside="closeWhatsappAuthDialog">
                      <v-card>
                        <v-card-title class="headline">
                          {{ $t("companies.whatsapp_authorise_title") }}
                        </v-card-title>
                        <v-tabs v-model="whatsappAuthTab" grow>
                          <v-tab href="#code">{{ $t("companies.whatsapp_auth_tab_code") }}</v-tab>
                          <v-tab href="#qr">{{ $t("companies.whatsapp_auth_tab_qr") }}</v-tab>
                        </v-tabs>
                        <v-card-text class="text-center pt-4">
                          <v-alert v-if="whatsappAuthState === 'starting'" type="info" text dense>
                            {{ $t("companies.whatsapp_auth_starting") }}
                          </v-alert>
                          <div v-else-if="['blocked', 'suspended', 'yellowCard', 'sleepMode'].includes(whatsappAuthState)">
                            <v-alert type="warning" text dense>
                              {{ $t("companies.whatsapp_auth_dead_state", { state: getWhatsappStateText(whatsappAuthState) }) }}
                            </v-alert>
                            <v-btn small depressed color="warning" class="mx-1" @click="closeWhatsappAuthDialog(); rebootWhatsapp()">{{ $t("companies.whatsapp_reboot") }}</v-btn>
                            <v-btn small depressed color="error" class="mx-1" @click="closeWhatsappAuthDialog(); logoutWhatsapp()">{{ $t("companies.whatsapp_logout") }}</v-btn>
                          </div>
                          <div v-else-if="whatsappAuthTab === 'code'" class="text-left">
                            <v-text-field v-model="whatsappAuthPhone" :label="$t('companies.whatsapp_auth_phone_label')" outlined dense
                              :disabled="isLoadingWhatsappAuth"></v-text-field>
                            <div v-if="isLoadingWhatsappAuth" class="text-center py-4">
                              <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                              <p class="mt-2">{{ $t("companies.whatsapp_loading") }}</p>
                            </div>
                            <div v-else-if="whatsappAuthCode && !whatsappAuthCodeExpired()" class="text-center" :data-tick="whatsappAuthTickAt">
                              <p>{{ $t("companies.whatsapp_auth_code_hint") }}</p>
                              <div class="text-h4 font-weight-bold my-3">{{ whatsappAuthCode }}</div>
                              <p class="text--secondary">{{ $t("companies.whatsapp_auth_code_expires", { seconds: whatsappAuthCodeSecondsLeft() }) }}</p>
                              <v-btn text color="primary" @click="requestWhatsappAuthCode">{{ $t("companies.whatsapp_auth_new_code") }}</v-btn>
                            </div>
                            <div v-else class="text-center">
                              <v-alert v-if="whatsappAuthCode && whatsappAuthCodeExpired()" type="warning" text dense>{{ $t("companies.whatsapp_auth_code_expired") }}</v-alert>
                              <v-alert v-if="whatsappAuthError" type="error" text dense>{{ whatsappAuthError }}</v-alert>
                              <v-btn color="primary" :disabled="!whatsappAuthPhone" @click="requestWhatsappAuthCode">
                                {{ whatsappAuthCode ? $t("companies.whatsapp_auth_new_code") : $t("companies.whatsapp_auth_get_code") }}
                              </v-btn>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="isLoadingWhatsappAuth && !whatsappQrCode" class="py-8">
                              <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                              <p class="mt-4">{{ $t("companies.whatsapp_loading") }}</p>
                            </div>
                            <div v-else-if="whatsappQrCode">
                              <v-img :src="'data:image/png;base64,' + whatsappQrCode" max-height="300" max-width="300" class="mx-auto"></v-img>
                              <v-alert type="info" text dense class="mt-4">{{ $t("companies.whatsapp_auth_qr_hint") }}</v-alert>
                            </div>
                            <div v-else>
                              <v-alert v-if="whatsappAuthError" type="error" text>{{ whatsappAuthError }}</v-alert>
                              <v-btn color="primary" class="mt-2" @click="fetchWhatsappQr">{{ $t("custom.retry") }}</v-btn>
                            </div>
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="closeWhatsappAuthDialog">{{ $t("custom.close") }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <!-- MAX Authorization Dialog (QR Code) -->
                    <v-dialog v-model="maxAuthDialog" max-width="500" @click:outside="closeMaxAuthDialog">
                      <v-card>
                        <v-card-title class="headline">
                          {{ $t("companies.max_authorise_title") }}
                        </v-card-title>
                        
                        <v-card-text class="text-center">
                          <!-- Шаг: Ожидание ввода 2FA-пароля (QR отсканирован) -->
                          <div v-if="maxAuthStep === 'pendingPassword'">
                            <v-alert type="warning" text dense class="mb-4">
                              {{ $t("companies.max_pending_password_hint") }}
                            </v-alert>
                            <div class="text-left">
                              <v-text-field
                                v-model="maxAuthPassword"
                                :label="$t('companies.max_password_label')"
                                outlined
                                type="password"
                                autofocus
                              ></v-text-field>
                              <v-btn
                                color="primary"
                                block
                                :loading="isLoadingMaxPassword"
                                :disabled="!maxAuthPassword || !maxAuthPassword.trim()"
                                @click="submitMaxAuthPassword"
                              >
                                {{ $t("companies.max_send_password") }}
                              </v-btn>
                              <v-alert v-if="maxPasswordError" type="error" text dense class="mt-4">
                                {{ maxPasswordError }}
                              </v-alert>
                            </div>
                          </div>

                          <!-- Загрузка QR-кода -->
                          <div v-else-if="isLoadingMaxQr" class="py-8">
                            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                            <p class="mt-4">{{ $t("companies.max_loading_qr") }}</p>
                          </div>

                          <!-- QR-код -->
                          <div v-else-if="maxQrCode">
                            <v-img
                              :src="'data:image/png;base64,' + maxQrCode"
                              max-height="300"
                              max-width="300"
                              class="mx-auto"
                            ></v-img>
                            <v-alert type="info" text dense class="mt-4">
                              {{ $t("companies.max_scan_qr_hint") }}
                            </v-alert>
                          </div>

                          <!-- Ошибка получения QR -->
                          <div v-else-if="maxQrError">
                            <v-alert type="error" text>
                              {{ maxQrError }}
                            </v-alert>
                            <v-btn color="primary" class="mt-4" @click="fetchMaxQrCode">
                              {{ $t("custom.retry") }}
                            </v-btn>
                          </div>
                        </v-card-text>
                        
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="closeMaxAuthDialog">
                            {{ $t("custom.close") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    
                    <v-expansion-panel :disabled="!includedInPlan('teletype')">
                      <v-expansion-panel-header>
                        {{ $t("teletype.teletype") }}
                        <p class="text-left caption ml-2">{{ $t("teletype.teletype_description") }}</p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <a href="https://teletype.app/?promo=W8QHEH&utm_source=email&utm_medium=link&utm_campaign=affiliate"
                              target="_blank">{{ $t("teletype.teletype") }}</a>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model="company.teletype_api_key" :label="$t('teletype.teletype_api_key')"
                              :placeholder="$t('teletype.teletype_api_key_placeholder')" outlined hide-details
                              autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" class="mt-2" block @click="saveCompany()">
                              {{ $t("custom.save") }}
                              <v-icon class="ml-1">
                                mdi-content-save-check-outline
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- Crisp (FT-080): чат-виджет сайта как источник CRM-инбокса -->
                    <v-expansion-panel :disabled="!isCrmEnabled">
                      <v-expansion-panel-header>
                        Crisp
                        <p class="text-left caption ml-2">
                          {{ isCrmEnabled ? $t("crisp.description") : $t("crisp.requires_crm") }}
                        </p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row v-if="crisp.connected">
                          <v-col cols="12">
                            <v-alert type="success" outlined dense>
                              {{ $t("crisp.connected") }} — {{ crisp.website_id }}
                            </v-alert>
                            <div class="caption mb-2">{{ $t("crisp.webhook_hint") }}</div>
                            <v-text-field :value="crisp.webhook_url" readonly outlined dense hide-details
                              :append-icon="crispCopied ? 'mdi-check' : 'mdi-content-copy'"
                              @click:append="copyCrispWebhookUrl"></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="error" outlined block :loading="isLoadingCrisp" @click="crispDisconnect()">
                              {{ $t("crisp.disconnect") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12">
                            <ol class="caption pl-4 mb-0">
                              <li>{{ $t("crisp.step1") }}</li>
                              <li>{{ $t("crisp.step2") }}</li>
                              <li>{{ $t("crisp.step3") }}</li>
                              <li>{{ $t("crisp.step4") }}</li>
                            </ol>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model.trim="crispForm.website_id" :label="$t('crisp.website_id')"
                              :hint="$t('crisp.website_id_hint')" persistent-hint outlined
                              autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model.trim="crispForm.identifier" :label="$t('crisp.identifier')"
                              outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model.trim="crispForm.key" :label="$t('crisp.key')" type="password"
                              outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" block :loading="isLoadingCrisp"
                              :disabled="!crispFormComplete" @click="crispConnect()">
                              {{ $t("crisp.connect") }}
                              <v-icon class="ml-1">mdi-link-variant</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- Avito Messenger (FT-093): нативная интеграция как источник CRM-инбокса -->
                    <v-expansion-panel data-testid="avito-integration-panel" :disabled="!isCrmEnabled">
                      <v-expansion-panel-header>
                        Avito
                        <p class="text-left caption ml-2">
                          {{ isCrmEnabled ? $t("avito.description") : $t("avito.requires_crm") }}
                        </p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row v-if="avito.connected">
                          <v-col cols="12">
                            <v-alert type="success" outlined dense>
                              {{ $t("avito.connected") }} — {{ avito.user_id }}
                            </v-alert>
                            <div class="caption mb-2">{{ $t("avito.webhook_hint") }}</div>
                            <v-text-field :value="avito.webhook_url" readonly outlined dense hide-details
                              :append-icon="avitoCopied ? 'mdi-check' : 'mdi-content-copy'"
                              @click:append="copyAvitoWebhookUrl"></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="error" outlined block :loading="isLoadingAvito" @click="avitoDisconnect()">
                              {{ $t("avito.disconnect") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12">
                            <ol class="caption pl-4 mb-0">
                              <li>{{ $t("avito.step1") }}</li>
                              <li>{{ $t("avito.step2") }}</li>
                              <li>{{ $t("avito.step3") }}</li>
                            </ol>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model.trim="avitoForm.client_id" :label="$t('avito.client_id')"
                              :hint="$t('avito.client_id_hint')" persistent-hint outlined
                              :error-messages="avitoFieldErrors.client_id"
                              @input="clearAvitoFieldError('client_id')"
                              data-cy="avito-client-id"
                              autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <!-- FT-157 REQ-04: секрет можно раскрыть и сообщение об отказе видно ПОД
                                 полем. Без этого клиент не видит, что вставил: обращение компании
                                 12659 — секрет был вставлен дважды и пережил семь попыток, потому
                                 что правился только видимый Client ID. hide-details снят намеренно:
                                 с ним error-messages не отрисовался бы. -->
                            <v-text-field v-model.trim="avitoForm.client_secret" :label="$t('avito.client_secret')"
                              :type="avitoSecretVisible ? 'text' : 'password'"
                              :append-icon="avitoSecretVisible ? 'mdi-eye-off' : 'mdi-eye'"
                              @click:append="avitoSecretVisible = !avitoSecretVisible"
                              :error-messages="avitoFieldErrors.client_secret"
                              @input="clearAvitoFieldError('client_secret')"
                              data-cy="avito-client-secret"
                              outlined autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" block :loading="isLoadingAvito"
                              :disabled="!avitoFormComplete" @click="avitoConnect()">
                              {{ $t("avito.connect") }}
                              <v-icon class="ml-1">mdi-link-variant</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel :disabled="company.taxi_park_type == 'not_taxi'" v-if="company.country == 'Russia' || company.country == 'Россия'">
                      <v-expansion-panel-header>
                        {{ $t("taxi.terminology.yandex_taxi") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-text-field v-model.trim="company.yandex_taxi_client_id"
                              :label="$t('taxi.terminology.yandex_taxi_client_id')"
                              :placeholder="$t('taxi.terminology.yandex_taxi_client_id_placeholder')" type="text"
                              hide-details autocomplete="off" outlined>
                              <v-icon slot="append" :color="company.yandex_taxi_client_id ? 'green' : 'grey'"
                                @click="saveCompany()" cursor="pointer">
                                mdi-content-save-outline
                              </v-icon>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-text-field v-model.trim="company.yandex_taxi_api_key"
                              :label="$t('taxi.terminology.yandex_taxi_api_key')"
                              :placeholder="$t('taxi.terminology.yandex_taxi_api_key_placeholder')" type="text"
                              hide-details autocomplete="off" outlined>
                              <v-icon slot="append" :color="company.yandex_taxi_api_key ? 'green' : 'grey'"
                                @click="saveCompany()" cursor="pointer">
                                mdi-content-save-outline
                              </v-icon>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-text-field v-model.trim="company.yandex_taxi_park_id"
                              :label="$t('taxi.terminology.yandex_taxi_park_id')"
                              :placeholder="$t('taxi.terminology.yandex_taxi_park_id_placeholder')" type="text"
                              hide-details autocomplete="off" outlined>
                              <v-icon slot="append" :color="company.yandex_taxi_park_id ? 'green' : 'grey'"
                                @click="saveCompany()" cursor="pointer">
                                mdi-content-save-outline
                              </v-icon>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel :disabled="!includedInPlan('yandex_prokat') || !main_company.api_access">
                      <v-expansion-panel-header>
                        {{ $t("yandex_prokat.yandex_prokat") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-text-field v-model.trim="company.token" :label="$t('companies.token')"
                              :placeholder="$t('companies.plc_token')" readonly @click="copyToken()" ref="api_token"
                              type="password" hide-details autocomplete="off" outlined v-tooltip="{
                                content: $t('companies.token_tooltip'),
                                placement: 'bottom-center',
                                classes: ['white--text', 'black'],
                                targetClasses: ['it-has-a-tooltip'],
                                delay: {
                                  show: 500,
                                  hide: 500,
                                },
                              }">
                              <v-icon slot="append" :color="company.token ? 'green' : 'grey'" @click="copyToken()"
                                cursor="pointer">
                                mdi-content-copy
                              </v-icon>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel :disabled="!includedInPlan('okidoki') || (company.docuseal_api_key && company.docuseal_api_key != '' && company.docuseal_api_key.length > 0) ? true : false" v-if="company.country == 'Russia' || company.country == 'Россия'">
                      <v-expansion-panel-header>
                        {{ $t("okidoki.okidoki") }}
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t("okidoki.okidoki_description") }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <!-- https://desktop.doki.online/register?promoCode=UCS7IK -->
                            <a href="https://desktop.doki.online/register?promoCode=UCS7IK" target="_blank">
                              {{ $t("okidoki.register") }}
                            </a>
                          </v-col>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-switch v-model="company.okidoki_enabled" :disabled="!company.okidoki_api_key || company.okidoki_api_key == '' || company.okidoki_api_key.length == 0" :label="$t('okidoki.okidoki_enabled')" @change="saveCompany()" outlined></v-switch>
                          </v-col>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-text-field v-model.trim="company.okidoki_api_key" :label="$t('okidoki.okidoki_api_key')"
                              :placeholder="$t('okidoki.okidoki_api_key_placeholder')" type="text" hide-details
                              autocomplete="off" outlined>
                              <v-icon slot="append" :color="company.okidoki_api_key ? 'green' : 'grey'"
                                @click="saveCompany()" cursor="pointer">
                                mdi-content-save-outline
                              </v-icon>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel :disabled="!includedInPlan('docuseal') || (company.okidoki_api_key && company.okidoki_api_key != '' && company.okidoki_api_key.length > 0) ? true : false">
                      <v-expansion-panel-header>
                        {{ $t("docuseal.docuseal") }}
                        <p class="text-left caption ml-2">{{ $t("docuseal.docuseal_description") }}</p> 
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <a href="https://docuseal.eu" target="_blank">
                              {{ $t("docuseal.register") }}
                            </a>
                          </v-col>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-switch v-model="company.docuseal_enabled" :disabled="!company.docuseal_api_key || company.docuseal_api_key == '' || company.docuseal_api_key.length == 0" :label="$t('docuseal.docuseal_enabled')" @change="saveCompany()" outlined></v-switch>
                          </v-col>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-text-field v-model.trim="company.docuseal_api_key" :label="$t('docuseal.docuseal_api_key')"
                              :placeholder="$t('docuseal.docuseal_api_key_placeholder')" type="text" hide-details
                              autocomplete="off" outlined>
                              <v-icon slot="append" :color="company.docuseal_api_key ? 'green' : 'grey'"
                                @click="saveCompany()" cursor="pointer">
                                mdi-content-save-outline
                              </v-icon>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                            <v-text-field v-model.trim="company.docuseal_domain" :label="$t('docuseal.docuseal_domain')"
                              :placeholder="$t('docuseal.docuseal_domain_placeholder')" type="text"
                              :hint="$t('docuseal.docuseal_domain_hint')" persistent-hint
                              autocomplete="off" outlined>
                              <v-icon slot="append" :color="company.docuseal_domain ? 'blue' : 'grey'"
                                @click="saveCompany()" cursor="pointer">
                                mdi-content-save-outline
                              </v-icon>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel :disabled="!includedInPlan('yandex_pay')" v-if="company.country == 'Russia' || company.country == 'Россия'">
                      <v-expansion-panel-header>
                        {{ $t("yandex_pay.title") }}
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t("yandex_pay.description") }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-switch v-model="yandex_pay_enabled" :label="$t('yandex_pay.enabled')" outlined></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="yandex_pay_api_key" :label="$t('yandex_pay.api_key')" outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="yandex_pay_merchant_id" :label="$t('yandex_pay.merchant_id')" outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <!-- <v-col cols="12" md="6">
                            <v-text-field v-model="yandex_pay_webhook_secret_key_id" :label="$t('yandex_pay.webhook_key_id')" outlined hide-details autocomplete="off" :hint="$t('yandex_pay.webhook_key_hint')" persistent-hint></v-text-field>
                          </v-col> -->
                          <v-col cols="12" md="4">
                            <v-text-field v-model="yandex_pay_redirect_success_url" :label="$t('yandex_pay.redirect_success')" outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="yandex_pay_redirect_error_url" :label="$t('yandex_pay.redirect_error')" outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="yandex_pay_redirect_abort_url" :label="$t('yandex_pay.redirect_abort')" outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-switch v-model="yandex_pay_use_sandbox" :label="$t('yandex_pay.use_sandbox')" outlined></v-switch>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" @click="saveYandexPaySettings" :loading="isSavingYandexPay" :disabled="isSavingYandexPay">
                              {{ $t("custom.save") }}
                              <v-icon class="ml-1">mdi-content-save-check-outline</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Stripe Payment Integration -->
                    <!-- <v-expansion-panel :disabled="!includedInPlan('stripe_payment')" v-if="company.country != 'Russia' && company.country != 'Россия' && company.country != 'Belarus' && company.country != 'Беларусь'"> -->
                    <v-expansion-panel :disabled="!includedInPlan('stripe_payment')">
                      <v-expansion-panel-header>
                          {{ $t("stripe_payment.title") }}
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t("stripe_payment.description") }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-switch v-model="stripe_enabled" :label="$t('stripe_payment.enabled')" outlined></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field 
                              v-model="stripe_publishable_key" 
                              :label="$t('stripe_payment.publishable_key')" 
                              outlined 
                              hide-details 
                              autocomplete="off"
                              placeholder="pk_test_... or pk_live_..."
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field 
                              v-model="stripe_secret_key" 
                              :label="$t('stripe_payment.secret_key')" 
                              outlined 
                              hide-details 
                              autocomplete="off"
                              type="password"
                              placeholder="sk_test_... or sk_live_..."
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field 
                              v-model="stripe_webhook_secret" 
                              :label="$t('stripe_payment.webhook_secret')" 
                              outlined 
                              hide-details 
                              autocomplete="off"
                              type="password"
                              placeholder="whsec_..."
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field 
                              v-model="stripe_redirect_success_url" 
                              :label="$t('stripe_payment.redirect_success')" 
                              outlined 
                              hide-details 
                              autocomplete="off"
                              placeholder="https://your-domain.com/success"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field 
                              v-model="stripe_redirect_cancel_url" 
                              :label="$t('stripe_payment.redirect_cancel')" 
                              outlined 
                              hide-details 
                              autocomplete="off"
                              placeholder="https://your-domain.com/cancel"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn 
                              color="success" 
                              @click="saveStripeSettings" 
                              :loading="isSavingStripe" 
                              :disabled="isSavingStripe"
                            >
                              {{ $t("custom.save") }}
                              <v-icon class="ml-1">mdi-content-save-check-outline</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="company.country == 'Russia'"
                      :disabled="company.id != 2 || !includedInPlan('payments_integration')">
                      <v-expansion-panel-header>
                        {{ $t("tinkoff.tinkoff") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row v-if="company.tinkoff">
                          <v-col cols="12">
                            <v-switch v-model="tinkoff_enabled" :label="$t('tinkoff.tinkoff_enabled')"
                              outlined></v-switch>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model="tinkoff_terminal_key" :label="$t('tinkoff.tinkoff_terminal_key')"
                              outlined hide-details autocomplete="off"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model="tinkoff_password" autocomplete="off"
                              :label="$t('tinkoff.tinkoff_password')" outlined hide-details></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-select v-model="tinkoff_taxation" :items="tinkoff_taxations"
                              :label="$t('tinkoff.taxation')" outlined></v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-select v-model="tinkoff_vat" :items="tinkoff_vats" :label="$t('tinkoff.vat')"
                              outlined></v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-select v-model="tinkoff_ffd_version" :items="tinkoff_ffd_versions" readonly
                              :label="$t('tinkoff.ffd_version')" outlined></v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model="tinkoff_tarrifs_link" autocomplete="off"
                              :label="$t('tinkoff.tarrifs_link_label')" outlined hide-details></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model="tinkoff_agreement_link" autocomplete="off"
                              :label="$t('tinkoff.agreement_link_label')" outlined hide-details></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model="tinkoff_privacy_link" autocomplete="off"
                              :label="$t('tinkoff.privacy_link_label')" outlined hide-details></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" @click="saveTinkoffSettings()">{{ $t("custom.save")
                              }}<v-icon class="ml-1">
                                mdi-content-save-check-outline
                              </v-icon></v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel :disabled="main_company && !(main_company.api_access && includedInPlan('api'))">
                      <v-expansion-panel-header>
                        {{ $t("api.api_token") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" lg="12" md="12" sm="12" xs="12"
                            :style="user_role == 'guest' || user_role == 'partner' ? 'display: none;' : ''">
                            <v-row>
                              <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                                <v-text-field v-model.trim="company.token" :label="$t('companies.token')"
                                  :placeholder="$t('companies.plc_token')" readonly @click="copyToken()" ref="api_token"
                                  type="password" hide-details autocomplete="off" outlined v-tooltip="{
                                    content: $t('companies.token_tooltip'),
                                    placement: 'bottom-center',
                                    classes: ['white--text', 'black'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                  <v-icon slot="append" :color="company.token ? 'green' : 'grey'" @click="copyToken()"
                                    cursor="pointer">
                                    mdi-content-copy
                                  </v-icon>
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="text-center">
                                <v-btn @click="updateToken()">{{
                                  $t("companies.update_token")
                                }}<v-icon class="ml-1" color="warning">
                                    mdi-reload-alert
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                      :disabled="!(main_company && main_company.api_access && main_company.webhook_access && includedInPlan('webhooks'))">
                      <v-expansion-panel-header>
                        {{ $t("api.webhooks") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" class="mx-2" outlined small @click="addWebhookEndpoint()">
                              {{ $t("api.add_endpoint") }}
                            </v-btn>
                          </v-col>
                          
                          <!-- Failed Webhook Events Section -->
                          <!-- Stay visible while has_more is true so the user can still page deeper after emptying the visible list via Resend. -->
                          <v-col v-if="(failed_webhook_events && failed_webhook_events.length > 0) || failedWebhookEventsHasMore" cols="12">
                            <v-card outlined>
                              <v-card-title class="error--text">
                                <v-icon left color="error">mdi-alert-circle</v-icon>
                                {{ $t("api.failed_webhook_events_count", { count: failed_webhook_events.length }) }}
                                <v-spacer></v-spacer>
                                <v-btn icon small @click="loadFailedWebhookEvents" :loading="isLoadingFailedWebhookEvents">
                                  <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-timeline dense>
                                  <v-timeline-item
                                    v-for="event in failed_webhook_events"
                                    :key="event.id"
                                    small
                                    color="error"
                                  >
                                    <v-row class="pt-1" align="center">
                                      <v-col cols="12" sm="9">
                                        <div class="text-caption grey--text">
                                          {{ formatedDate(event.created_at) }}
                                        </div>
                                        <div class="font-weight-bold">{{ event.event }}</div>
                                        <div class="text-caption">
                                          <strong>{{ $t("api.webhook_event_url") }}:</strong> {{ event.webhook_endpoint.url }}
                                        </div>
                                        <div v-if="event.response && event.response.status" class="text-caption">
                                          <strong>{{ $t("api.webhook_event_status") }}:</strong> {{ event.response.status }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="3" class="text-right">
                                        <v-btn
                                          outlined
                                          small
                                          color="primary"
                                          :loading="redeliveringWebhookEventIds.includes(event.id)"
                                          :disabled="redeliveringWebhookEventIds.includes(event.id)"
                                          @click="redeliverWebhookEvent(event)"
                                        >
                                          <v-icon left small>mdi-refresh</v-icon>
                                          {{ $t("api.redeliver_webhook_event") }}
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-timeline-item>
                                </v-timeline>
                                <div v-if="failedWebhookEventsHasMore" class="text-center mt-2">
                                  <v-btn
                                    outlined
                                    small
                                    color="primary"
                                    :loading="isLoadingMoreFailedWebhookEvents"
                                    :disabled="isLoadingMoreFailedWebhookEvents"
                                    @click="loadMoreFailedWebhookEvents"
                                  >
                                    {{ $t("api.load_more_webhook_events") }}
                                  </v-btn>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col v-for="webhook_endpoint, index in webhook_endpoints" :key="index" cols="12">
                            <v-row>
                              <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                                <v-text-field v-model="webhook_endpoint.url" :label="$t('api.webhook_endpoint_url')"
                                  :placeholder="$t('api.webhook_endpoint_plc')" outlined hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                                <v-select :items="webhook_subscriptions" multiple
                                  v-model="webhook_endpoint.subscriptions" item-text="name" item-value="value"
                                  :label="$t('api.subscriptions')" outlined hide-details></v-select>
                              </v-col>
                              <v-col v-if="webhookSecretsById[webhook_endpoint.id] && isStaff" cols="12" lg="12" md="12" sm="12" xs="12">
                                <v-text-field :value="webhookSecretsById[webhook_endpoint.id]"
                                  :label="$t('api.webhook_signing_secret')" :hint="$t('api.webhook_signing_secret_hint')"
                                  persistent-hint readonly outlined type="password" autocomplete="off"
                                  append-icon="mdi-content-copy"
                                  @click="copyWebhookSigningSecret(webhookSecretsById[webhook_endpoint.id])"
                                  @click:append="copyWebhookSigningSecret(webhookSecretsById[webhook_endpoint.id])"></v-text-field>
                              </v-col>
                              <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                                <v-row>
                                  <v-col cols="12" lg="6" md="6" sm="12" xs="12">
                                    <v-switch v-model="webhook_endpoint.created_from_api"
                                      :label="$t('api.only_created_from_api')" outlined hide-details></v-switch>
                                  </v-col>
                                  <v-col cols="12" lg="6" md="6" sm="12" xs="12">
                                    <v-switch v-model="webhook_endpoint.updated_from_api"
                                      :label="$t('api.only_updated_from_api')" outlined hide-details></v-switch>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="text-center">
                                <v-btn v-if="webhook_endpoint.new" class="mx-2" icon color="success"
                                  @click="saveWebhookEndpoint(webhook_endpoint)" :disabled="!webhook_endpoint.url"
                                  :loading="isLoadingSaveWebhookEndpoint" :title="$t('api.save_webhook_endpoint')">
                                  <v-icon>mdi-content-save-outline</v-icon>
                                </v-btn>
                                <v-btn v-if="webhook_endpoint.id" class="mx-2" icon color="success"
                                  @click="updateWebhookEndpoint(webhook_endpoint)"
                                  :loading="isLoadingUpdateWebhookEndpoint"
                                  :disabled="!webhook_endpoint.url ? true : false" :title="$t('api.update_webhook_endpoint')">
                                  <v-icon>mdi-content-save-outline</v-icon>
                                </v-btn>
                                <v-btn v-if="webhook_endpoint.id && webhook_endpoint.enabled" class="mx-2" icon
                                  :loading="isLoadingDeactivateWebhookEndpoint" color="secondary"
                                  @click="deactivateWebhookEndpoint(webhook_endpoint)" :title="$t('api.deactivate_webhook_endpoint')">
                                  <v-icon>mdi-eye-off-outline</v-icon>
                                </v-btn>
                                <v-btn v-if="webhook_endpoint.id && !webhook_endpoint.enabled" class="mx-2" icon
                                  color="warning" @click="activateWebhookEndpoint(webhook_endpoint)"
                                  :loading="isLoadingActivateWebhookEndpoint" :title="$t('api.activate_webhook_endpoint')">
                                  <v-icon>mdi-eye-outline</v-icon>
                                </v-btn>
                                <v-btn v-if="webhook_endpoint.id" icon color="error"
                                  @click="deleteWebhookEndpoint(webhook_endpoint)"
                                  :loading="isLoadingDeleteWebhookEndpoint" :title="$t('api.delete_webhook_endpoint')">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn v-else color="error" icon
                                  @click="deleteWebhookEndpointFromStore(webhook_endpoint)" :title="$t('api.delete_webhook_endpoint_from_store')">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- StarLine Integration -->
                    <v-expansion-panel :disabled="(!main_company || !main_company.starline_on) || !includedInPlan('starline')">
                      <v-expansion-panel-header>
                        StarLine
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t('traccar.gps_monitoring_service') }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-alert type="info" dense text class="mb-4">
                              {{ $t('starline.settings_info') }}
                            </v-alert>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.starline_app_id"
                              :label="$t('starline.app_id')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                              autocomplete="off"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.starline_secret"
                              :label="$t('starline.app_secret')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                              type="password"
                              autocomplete="off"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.starline_login"
                              :label="$t('starline.login')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                              autocomplete="off"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.starline_password"
                              :label="$t('starline.password')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                              type="password"
                              autocomplete="off"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-divider class="my-2"></v-divider>
                            <h4 class="mb-3">{{ $t('starline.mileage_settings') }}</h4>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-switch
                              v-model="company.starline_auto_mileage_sync"
                              :label="$t('starline.auto_mileage_sync')"
                              hide-details
                              class="mt-0"
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model.number="company.starline_mileage_threshold"
                              :label="$t('starline.mileage_threshold')"
                              autocomplete="off"
                              outlined
                              dense
                              hide-details
                              type="number"
                              :suffix="$t('custom.km')"
                              :disabled="!company.starline_auto_mileage_sync"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center mt-3">
                            <v-btn
                              color="success"
                              @click="saveStarlineSettings"
                              :loading="isSavingStarline"
                              :disabled="!company.starline_app_id || !company.starline_secret || !company.starline_login || !company.starline_password"
                            >
                              <v-icon left>mdi-content-save</v-icon>
                              {{ $t('custom.save') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                    <!-- Wialon интеграция -->
                    <v-expansion-panel :disabled="(!main_company || !main_company.wialon_on) || !includedInPlan('wialon')">
                      <v-expansion-panel-header>
                        <v-row align="center" no-gutters>
                          <span>Wialon</span>
                          <span class="grey--text text--darken-1 caption ml-2">{{ $t('traccar.gps_monitoring_service') }}</span>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-alert type="info" dense text class="mb-4">
                              {{ $t('wialon.settings_info') }}
                            </v-alert>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.wialon_token"
                              :label="$t('wialon.api_token')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                              autocomplete="off"
                              :type="showWialonToken ? 'text' : 'password'"
                              :append-icon="showWialonToken ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="showWialonToken = !showWialonToken"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="wialonHostSelection"
                              :items="wialonHosts"
                              :label="$t('wialon.server')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="6" v-if="wialonHostSelection === 'custom'">
                            <v-text-field
                              v-model="customWialonHost"
                              :label="$t('wialon.custom_server_url')"
                              :placeholder="$t('wialon.custom_server_placeholder')"
                              :rules="[validateWialonHostUrl]"
                              outlined
                              dense
                              class="mb-3"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-switch
                              v-model="company.wialon_auto_mileage_sync"
                              :label="$t('wialon.auto_mileage_sync')"
                              hide-details
                              class="mb-3"
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.wialon_mileage_threshold"
                              :label="$t('wialon.mileage_threshold')"
                              outlined
                              dense
                              hide-details
                              type="number"
                              :suffix="$t('custom.km')"
                              :disabled="!company.wialon_auto_mileage_sync"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center mt-3">
                            <v-btn
                              color="success"
                              @click="saveWialonSettings"
                              :loading="isSavingWialon"
                              :disabled="!company.wialon_token"
                            >
                              <v-icon left>mdi-content-save</v-icon>
                              {{ $t('custom.save') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                    <!-- AutoFon интеграция -->
                    <v-expansion-panel :disabled="(!main_company || !main_company.autofon_on) || !includedInPlan('autofon')">
                      <v-expansion-panel-header>
                        <v-row align="center" no-gutters>
                          <span>AutoFon</span>
                          <span class="grey--text text--darken-1 caption ml-2">{{ $t('traccar.gps_monitoring_service') }}</span>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-alert type="info" dense text class="mb-4">
                              {{ $t('autofon.settings_info') }}
                            </v-alert>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.autofon_api_key"
                              :label="$t('autofon.api_key')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                              autocomplete="off"
                              :type="showAutofonApiKey ? 'text' : 'password'"
                              :append-icon="showAutofonApiKey ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="showAutofonApiKey = !showAutofonApiKey"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="company.autofon_password"
                              :label="$t('autofon.password')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                              autocomplete="off"
                              :type="showAutofonPassword ? 'text' : 'password'"
                              :append-icon="showAutofonPassword ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="showAutofonPassword = !showAutofonPassword"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="text-center mt-3">
                            <v-btn
                              color="success"
                              @click="saveAutofonSettings"
                              :loading="isSavingAutofon"
                              :disabled="!company.autofon_api_key || !company.autofon_password"
                            >
                              <v-icon left>mdi-content-save</v-icon>
                              {{ $t('custom.save') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                    <!-- Traccar интеграция -->
                    <v-expansion-panel :disabled="!main_company || !main_company.beacons_on">
                      <v-expansion-panel-header>
                        <v-row align="center" no-gutters>
                          <v-col cols="auto" class="pa-0">
                            <span>{{ $t('traccar.traccar_from_rentprog') }}</span>
                            <span class="grey--text text--darken-1 caption ml-2">{{ $t('traccar.gps_monitoring_service') }}</span>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-alert type="info" dense text class="mb-4">
                              {{ $t('traccar.server_settings_info') }}
                            </v-alert>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="company.traccar_server_url"
                              :items="traccarServers"
                              item-text="name"
                              item-value="url"
                              :label="$t('traccar.server')"
                              outlined
                              dense
                              hide-details
                              class="mb-3"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" class="text-center mt-3">
                            <v-btn
                              color="success"
                              @click="saveTraccarSettings"
                              :loading="isSavingTraccar"
                            >
                              <v-icon left>mdi-content-save</v-icon>
                              {{ $t('custom.save') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel :disabled="!includedInPlan('localrent')">
                      <v-expansion-panel-header>
                        {{ $t("localrent.localrent") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-switch v-model="company.in_localrent" :label="$t('localrent.localrent_enabled')" outlined
                              disabled></v-switch>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <v-btn color="success" @click="saveCompany()">{{ $t("custom.save")
                            }}<v-icon class="ml-1">
                                mdi-content-save-check-outline
                              </v-icon></v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Мониторинг штрафов (Штрафус) — только для России -->
                    <v-expansion-panel v-if="company && company.country === 'Russia'">
                      <v-expansion-panel-header>
                        {{ $t("fines.fines_monitory_title") }}
                        <span class="grey--text text--darken-1 caption ml-2">{{ $t("fines.fines_provider_shtrafus") }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <v-alert type="info" dense text class="mb-2">
                              {{ $t("fines.fines_monitoring_description") }}
                            </v-alert>
                          </v-col>
                          <v-col cols="12" v-if="company && company.fines_provider === 'shtrafus' && company.shtrafus_division_id" class="text-center">
                            <v-chip color="success" dark small>
                              <v-icon small left>mdi-check-circle-outline</v-icon>
                              {{ $t("fines.shtrafus_division_registered") }}
                            </v-chip>
                          </v-col>
                          <v-col cols="12" v-else-if="company && company.fines_provider === 'shtrafus' && !company.shtrafus_division_id" class="text-center">
                            <v-chip color="warning" dark small>
                              <v-icon small left>mdi-clock-outline</v-icon>
                              {{ $t("fines.shtrafus_division_pending") }}
                            </v-chip>
                          </v-col>
                          <v-col cols="12" v-if="!finesMonitoringEnabled" class="text-center">
                            <v-btn
                              color="success"
                              :loading="isSavingFinesProvider"
                              :disabled="isSavingFinesProvider || !(main_company && main_company.balance > 0)"
                              @click="toggleFinesMonitoring(true)"
                            >
                              <v-icon left>mdi-power-plug</v-icon>
                              {{ $t("fines.enable_fines_monitoring") }}
                            </v-btn>
                            <p v-if="!(main_company && main_company.balance > 0)" class="caption error--text mt-2 mb-0">
                              {{ $t("fines.fines_monitoring_no_balance") }}
                            </p>
                          </v-col>
                          <v-col cols="12">
                            <p class="caption mb-0">
                              {{ main_company && main_company.plan
                                ? $t("fines.fines_monitoring_price", {
                                    price: parseFloat(main_company.plan.fines_monitoring_cost || 0).toFixed(1),
                                    currency: main_company.plan.currency,
                                  })
                                : "" }}
                            </p>
                            <p class="caption mb-0">{{ $t("fines.fines_monitoring_after_enable") }}</p>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel :disabled="!includedInPlan('sites_builder')">
                      <v-expansion-panel-header>
                        Sites Builder API
                        <span class="grey--text text--darken-1 caption ml-2">
                          {{ $t('sites_builder_tokens.tab_subtitle') }}
                        </span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <SitesBuilderTokens />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Теги -->
        <v-tab-item>
          <tag-group-manager />
        </v-tab-item>
        <!-- FT-102: бронируемые допы -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <bookable-addons-tab></bookable-addons-tab>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- Удалить демо контент -->
    <v-overlay :value="showOverlayRemoveDemo">
      <v-card>
        <v-card-text>
          {{ $t("demo_content.removing_demo_content") }}
          <v-progress-linear class="mt-2" color="error accent-4" indeterminate rounded height="6"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-dialog v-model="qrCodeDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t('companies.whatsapp_authorise_title') }}
        </v-card-title>

        <v-card-text class="">
          <v-img v-if="qrCode" max-height="300" max-width="300" class="mx-auto mt-2"
            :src="'data:image/png;base64,' + qrCode"></v-img>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="qrCodeDialog = false">
            {{ $t('custom.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import Uppy from "../../../plugins/uppy_contracts";
import UppyEntity from "../../../plugins/uppy_entity_contracts";
import UppyProlong from "../../../plugins/uppy_prolong";
import UppyInvoice from "../../../plugins/uppy_invoices";
import UppyDocx from "../../../plugins/uppy_docx";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import { buildTimeZoneOptions } from "@/helpers/timezones";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { countries } from "./../countries";
import { Capacitor } from "@capacitor/core";
import { copyToClipboard as copyTextToClipboard } from '@/utils/clipboard';
import PullToRefresh from "pulltorefreshjs";
import PeriodicPaymentTemplates from '@/components/dashboard/users/PeriodicPaymentTemplates.vue';
import BookingMessageTemplates from '@/components/dashboard/bookings/BookingMessageTemplates.vue';
import TagGroupManager from '@/components/dashboard/users/TagGroupManager.vue';
import SitesBuilderTokens from './SitesBuilderTokens.vue';
import PricingSettingsTab from "@/components/dashboard/company_settings/PricingSettingsTab.vue";
import BookableAddonsTab from "@/components/dashboard/company_settings/BookableAddonsTab.vue";

// FT-157. Коды отказа connect Avito, адресующие конкретное поле формы: код → [поле, ключ].
const AVITO_FIELD_ERROR_CODES = {
  avito_invalid_client_id: ["client_id", "avito.error_invalid_client_id"],
  avito_invalid_client_secret: ["client_secret", "avito.error_invalid_client_secret"],
  avito_doubled_client_id: ["client_id", "avito.error_doubled_client_id"],
  avito_doubled_client_secret: ["client_secret", "avito.error_doubled_client_secret"],
};

// Доменные коды, показываемые тостом. Полный перечень того, что отдаёт бэкенд:
// всё, чего здесь и выше нет, — не отказ Avito, а общий сбой, и уходит в setError.
const AVITO_TOAST_ERROR_CODES = {
  avito_missing_fields: "avito.error_missing_fields",
  avito_invalid_credentials: "avito.error_invalid_credentials",
  avito_insufficient_tariff: "avito.error_insufficient_tariff",
  avito_service_unavailable: "avito.error_service_unavailable",
  avito_webhook_subscribe_failed: "avito.error_subscribe_failed",
  avito_save_failed: "avito.error_save_failed",
};

// hasOwnProperty, а не `map[code]`: строка `toString`/`constructor` в теле ответа
// достала бы прототипную функцию — truthy, и отказ схлопывался бы в НЕМОЙ (ветка поля
// срабатывает, имя поля undefined, тост не показывается вовсе). Найдено dual-review.
const has = (map, key) => typeof key === "string" && Object.prototype.hasOwnProperty.call(map, key);

export default {
  // FT-149: таймеры диалогов авторизации инжектируемы — unit-тесты подменяют
  // их через $options.timers без библиотек fake timers (в проекте их нет).
  timers: {
    setInterval: (fn, ms) => window.setInterval(fn, ms),
    clearInterval: (id) => window.clearInterval(id),
    now: () => Date.now(),
  },
  data() {
    return {
      // Crisp (FT-080): состояние подключения + форма Website Token
      crisp: { connected: false, website_id: null, webhook_url: null },
      crispForm: { website_id: "", identifier: "", key: "" },
      isLoadingCrisp: false,
      crispCopied: false,
      // Avito Messenger (FT-093): состояние подключения + форма OAuth-креды
      avito: { connected: false, user_id: null, webhook_url: null },
      avitoForm: { client_id: "", client_secret: "" },
      avitoSecretVisible: false,
      // FT-157 REQ-04: сообщения об отказе, адресованные конкретному полю (коды CTR-02).
      avitoFieldErrors: { client_id: [], client_secret: [] },
      isLoadingAvito: false,
      avitoCopied: false,
      counts_groups: [],
      billingAddress: {
        country_code: '',
        city: '',
        first_line: '',
        postal_code: ''
      },
      time_zones: buildTimeZoneOptions(),
      locales: [
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      booking_message_locales: [
        { text: this.$t("companies.default_lang"), value: null },
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      booking_message_selected_locale: null,
      booking_types: [
        { text: this.$t("bookings.daily"), value: 0 },
        { text: this.$t("bookings.hourly"), value: 1 },
        { text: this.$t("bookings.monthly"), value: 2 },
        { text: this.$t("bookings.weekly"), value: 3 },
      ],
      periodicPricingMethods: [
        { text: this.$t("companies.periodic_pricing_current"), value: "current_price" },
        { text: this.$t("companies.periodic_pricing_recalculate"), value: "recalculate_full" },
      ],
      countries: countries,
      pricing_company: null,
      user: "",
      currencies: [],
      company_currencies: [],
      docx_templates: [],
      updating_cashbox: null,
      updatingExchangeRateId: null,
      activeExchangeRatePanel: null,
      // Черновики курсов: { [rate.id]: "12.5" }. Поле курса НЕ биндится на объект из
      // Vuex напрямую — этот же company.exchange_rates читают PaymentDialog,
      // ProlongDialog, Invoices, Debts и Fines, пересчитывая суммы по курсу. С
      // v-model="rate.rate" каждая нажатая цифра уезжала в стор (а он персистится в
      // localStorage), и недонабранный курс переживал даже перезагрузку.
      exchange_rate_drafts: {},
      tariffs: [
        { text: this.$t("rentprog_tariffs.start"), value: "Старт" },
        { text: this.$t("rentprog_tariffs.start"), value: "Безлимит" },
        { text: this.$t("rentprog_tariffs.start"), value: "Стандарт" },
        { text: this.$t("rentprog_tariffs.start"), value: "Средний" },
        { text: this.$t("rentprog_tariffs.start"), value: "Профессионал" },
        { text: this.$t("rentprog_tariffs.start"), value: "Эксперт" },
        { text: this.$t("rentprog_tariffs.start"), value: "Индивидуальный" },
      ],
      clients_sources: [],
      clients_sources_array: [],
      organizations_forms: [
        { id: 0, form: this.$t("organizations_forms.other") },
        { id: 1, form: this.$t("organizations_forms.ooo") },
        { id: 2, form: this.$t("organizations_forms.ip") },
        { id: 3, form: this.$t("organizations_forms.impresario") },
      ],
      new_counts_group: "",
      edit_counts_group: "",
      old_counts_group: "",
      doc_template_url: null,
      entity_doc_template_url: null,
      prolong_template_url: null,
      invoice_doc_template_url: null,
      send_start_booking_text: null,
      send_end_booking_text: null,
      send_start_booking_text_whatsapp: null,
      send_end_booking_text_whatsapp: null,
      review_email_text: null,
      review_whatsapp_text: null,
      periodic_payment_success_email_text: null,
      periodic_payment_success_whatsapp_text: null,
      periodic_payment_bad_email_text: null,
      periodic_payment_bad_whatsapp_text: null,
      accept_message_text: null,
      custom_html_template: false,
      decline_message_text: null,
      accept_whatsapp: null,
      decline_whatsapp: null,
      dataIntegrationsPanel: [],
      fines_auto_select: false,
      isSavingFinesProvider: false,
      sign: null,
      stamp: null,
      default_cashbox: null,
      showEdit: false,
      showSaveSeasons: false,
      showNewCountsGroup: false,
      showEditCountsGroup: false,
      showOverlayRemoveDemo: false,
      qrCodeDialog: false,
      qrCode: null,
      tinkoff_taxations: [
        { text: this.$t("tinkoff.osn"), value: "osn" },
        { text: this.$t("tinkoff.usn_income"), value: "usn_income" },
        { text: this.$t("tinkoff.usn_income_outcome"), value: "usn_income_outcome" },
        { text: this.$t("tinkoff.envd"), value: "envd" },
        { text: this.$t("tinkoff.esn"), value: "esn" },
        { text: this.$t("tinkoff.patent"), value: "patent" },
      ],
      tinkoff_vats: [
        { text: this.$t("tinkoff.vat_none"), value: "none" },
        { text: this.$t("tinkoff.vat20"), value: "vat20" },
        { text: this.$t("tinkoff.vat10"), value: "vat10" },
        { text: this.$t("tinkoff.vat5"), value: "vat5" },
        { text: this.$t("tinkoff.vat0"), value: "vat0" },
        { text: this.$t("tinkoff.vat110"), value: "vat110" },
        { text: this.$t("tinkoff.vat120"), value: "vat120" },
      ],
      tinkoff_ffd_versions: [
        "1.2",
        "1.05",
      ],
      tinkoff_enabled: false,
      tinkoff_terminal_key: null,
      tinkoff_password: null,
      tinkoff_taxation: "osn",
      tinkoff_ffd_version: "1.2",
      tinkoff_vat: "none",
      tinkoff_tarrifs_link: null,
      tinkoff_agreement_link: null,
      tinkoff_privacy_link: null,
      yandex_pay_enabled: false,
      yandex_pay_api_key: null,
      yandex_pay_merchant_id: null,
      yandex_pay_use_sandbox: true,
      yandex_pay_redirect_success_url: null,
      yandex_pay_redirect_error_url: null,
      yandex_pay_redirect_abort_url: null,
      yandex_pay_webhook_secret_key_id: null,
      isSavingYandexPay: false,
      stripe_enabled: false,
      stripe_publishable_key: null,
      stripe_secret_key: null,
      stripe_webhook_secret: null,
      stripe_redirect_success_url: null,
      stripe_redirect_cancel_url: null,
      isSavingStripe: false,
      isSavingStarline: false,
      isSavingWialon: false,
      showWialonToken: false,
      wialonHostSelection: 'hst-api.wialon.com',
      customWialonHost: '',
      wialonHostsBase: [
        { text: 'Wialon Hosting (COM)', value: 'hst-api.wialon.com' },
        { text: 'Wialon Hosting (US)', value: 'hst-api.wialon.us' },
        { text: 'Wialon Hosting (EU)', value: 'hst-api.wialon.eu' }
      ],
      isSavingAutofon: false,
      showAutofonApiKey: false,
      showAutofonPassword: false,
      isSavingTraccar: false,
      traccarServers: [
        { name: 'Russia (vos-rentprog.ru)', url: 'https://vos-rentprog.ru' }
      ],
      webhook_subscriptions: [
        { name: this.$t("api.booking_create"), value: "booking_create" },
        { name: this.$t("api.booking_update"), value: "booking_update" },
        { name: this.$t("api.booking_destroy"), value: "booking_destroy" },
        { name: this.$t("api.car_create"), value: "car_create" },
        { name: this.$t("api.car_update"), value: "car_update" },
        { name: this.$t("api.car_destroy"), value: "car_destroy" },
        { name: this.$t("api.client_create"), value: "client_create" },
        { name: this.$t("api.client_update"), value: "client_update" },
        { name: this.$t("api.client_destroy"), value: "client_destroy" },
      ],
      updated_docx_template: null,
      deleted_docx_template: null,
      moved_up_docx_template: null,
      moved_down_docx_template: null,
      isMobile: false,
      isLoadingMoveDocxTemplate: false,
      isLoadingSaveWebhookEndpoint: false,
      isLoadingUpdateWebhookEndpoint: false,
      isLoadingDeleteWebhookEndpoint: false,
      isLoadingActivateWebhookEndpoint: false,
      isLoadingDeactivateWebhookEndpoint: false,
      isLoadingFailedWebhookEvents: false,
      isLoadingMoreFailedWebhookEvents: false,
      failed_webhook_events: [],
      failedWebhookEventsHasMore: false,
      failedWebhookEventsLoaded: false,
      webhookEndpointsLoaded: false,
      // FT-090: секреты подписи держим отдельно от company.webhook_endpoints —
      // company aggregate перезаписывается любым setCompany (сохранение профиля,
      // broadcast) секретless-версией и терял бы их.
      webhookSecretsById: {},
      redeliveringWebhookEventIds: [],
      isLoadingCreateWhatsappInstance: false,
      isLoadingDeleteWhatsappInstance: false,
      isLoadingAuthoriseWhatsapp: false,
      isLoadingWhatsappActions: false,
      isLoadingCreateMaxInstance: false,
      isLoadingDeleteMaxInstance: false,
      isLoadingAuthoriseMax: false,
      isLoadingMaxActions: false,
      maxAuthDialog: false,
      maxQrCode: null,
      maxQrError: '',
      isLoadingMaxQr: false,
      maxQrRefreshInterval: null,
      maxAuthStep: 'qr',
      maxAuthPassword: '',
      maxPasswordError: '',
      isLoadingMaxPassword: false,
      // FT-149 REQ-02: диалог авторизации WhatsApp (код по номеру — основной путь, QR — альтернатива)
      whatsappAuthDialog: false,
      whatsappAuthTab: 'code',
      whatsappAuthPhone: '',
      whatsappAuthCode: null,
      whatsappAuthCodeIssuedAt: null,
      whatsappAuthState: null,
      whatsappAuthError: '',
      whatsappQrCode: null,
      isLoadingWhatsappAuth: false,
      whatsappAuthInterval: null,
      whatsappAuthNetErrors: 0,
      whatsappAuthTickAt: 0, // момент последнего тика — перерисовывает отсчёт срока кода
      whatsappAuthEpoch: 0, // номер сеанса диалога: ответ прошлого сеанса ничего не делает
      // Telegram Green-API
      isLoadingCreateTelegramGreenApiInstance: false,
      isLoadingDeleteTelegramGreenApiInstance: false,
      isLoadingTelegramGreenApiActions: false,
      telegramGreenApiAuthDialog: false,
      telegramGreenApiAuthStep: 'qr',
      telegramGreenApiQrCode: null,
      telegramGreenApiQrError: '',
      isLoadingTelegramGreenApiQr: false,
      telegramGreenApiQrInterval: null,
      telegramGreenApiAuthPassword: '',
      isLoadingTelegramGreenApiSendPassword: false,
      telegramGreenApiPasswordError: '',
      // Настройки каналов уведомлений
      notificationChannelsMode: 'all',
      notificationChannelsPriority: [],
      notificationChannelsPrimary: null,
      isLoadingSaveCashbox: false,
      isLoadingUpdateCashbox: false,
      isLoadingMakeCashboxDefault: false,
      isLoadingActivateCashbox: false,
      isLoadingDeleteCashbox: false,
      isLoadingUpdateManualCurrencyRateUpdate: false,
      isLoadingUpdateExchangeRate: false,
      isLoadingUpdateCurrencies: false,
      isLoadingUpdateDocxTemplate: false,
      isLoadingDeleteDocxTemplate: false,
      isLoading: false,
      error: "",
    };
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (
        this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isManager ||
        this.user_role == "guest"
      ) {
        this.isLoading = true;
        this.fetchCrispStatus(); // FT-080: 403 не-админам глотается в catch
        this.fetchAvitoStatus(); // FT-093: 403 не-админам глотается в catch
        this.axios
          .get(`/api/v1/company`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.$store.commit("setCompany", { company: response.data });
            this.loadWebhookEndpoints(); // FT-090: подтянуть секреты вебхуков из owner-index
            const ncc = response.data.notification_channels_config || {};
            this.notificationChannelsMode = ncc.mode || 'all';
            this.notificationChannelsPriority = ncc.priority || [];
            this.notificationChannelsPrimary = ncc.primary_channel || null;
            // Платёжный адрес и выбор хоста Wialon — из этого же ответа и здесь
            // же, а не наблюдателем company: тот срабатывает на КАЖДЫЙ commit
            // setCompany, включая broadcast ActionCable и refreshCompanyData(),
            // и затирал бы то, что человек в этот момент набирает в форме.
            this.hydrateBillingAddress(response.data.billing_address);
            this.initWialonHostSelection();
            this.tinkoff_enabled = response.data.tinkoff.tinkoff_enabled
            this.tinkoff_terminal_key = response.data.tinkoff.tinkoff_terminal_key
            this.tinkoff_password = response.data.tinkoff.tinkoff_password
            this.tinkoff_taxation = response.data.tinkoff.taxation
            this.tinkoff_ffd_version = response.data.tinkoff.ffd_version
            this.tinkoff_vat = response.data.tinkoff.vat
            this.tinkoff_tarrifs_link = response.data.tinkoff.tarrifs_link
            this.tinkoff_agreement_link = response.data.tinkoff.agreement_link
            this.tinkoff_privacy_link = response.data.tinkoff.privacy_link
            this.yandex_pay_enabled = response.data.yandex_pay_enabled
            this.yandex_pay_api_key = response.data.yandex_pay_api_key
            this.yandex_pay_merchant_id = response.data.yandex_pay_merchant_id
            this.yandex_pay_use_sandbox = response.data.yandex_pay_use_sandbox
            this.yandex_pay_redirect_success_url = response.data.yandex_pay_redirect_success_url
            this.yandex_pay_redirect_error_url = response.data.yandex_pay_redirect_error_url
            this.yandex_pay_redirect_abort_url = response.data.yandex_pay_redirect_abort_url
            this.yandex_pay_webhook_secret_key_id = response.data.yandex_pay_webhook_secret_key_id
            this.fines_auto_select = response.data.fines_auto_select
            this.company_currencies = response.data.currencies;
            this.docx_templates = response.data.docx_templates;

            // FT-085: сырьё для вкладки «Цены» — как раньше периоды/тумблеры
            this.pricing_company = response.data;
            this.axios
              .get(`/api/v1/counts_groups`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then((counts_response) => {
                function onlyUnique(value, index, self) {
                  return self.indexOf(value) === index;
                }
                self.company.counts_groups =
                  counts_response.data.filter(onlyUnique);
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.counts_groups_load"));
                console.log(error);
              });

            // Формируем массив для отображения источников клиентов
            if (
              this.company.clients_sources &&
              this.company.clients_sources.length > 0
            ) {
              this.company.clients_sources.forEach((source) => {
                self.clients_sources.push({ value: source });
              });
            }

            this.user = this.$store.getters.getCurrentUser;
            this.getBookingMessages();
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.company_load"));
            console.log(error);
          });
        this.axios
          .get(`api/v1/doc_templates/${null}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (response.data) {
              self.doc_template_url = response.data.url;
            } else {
              self.doc_template_url =
                "https://web.rentprog.ru/doc_example.docx";
            }
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.template_load"));
            console.log(error);
          });
        this.axios
          .get(`api/v1/currencies`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.currencies = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          });
        this.axios
          .get(`api/v1/doc_entity_templates/${null}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (response.data) {
              self.entity_doc_template_url = response.data.url;
            } else {
              self.entity_doc_template_url =
                "https://web.rentprog.ru/entity_doc_example.docx";
            }
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.template_load"));
            console.log(error);
          });
        this.axios
          .get(`api/v1/prolong_templates`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (response.data) {
              self.prolong_template_url = response.data.url;
            } else {
              self.prolong_template_url =
                "https://web.rentprog.ru/doc_example.docx";
            }
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.template_load"));
            console.log(error);
          });
        this.axios
          .get(`api/v1/invoice_templates`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (response.data) {
              self.invoice_doc_template_url = response.data.url;
            } else {
              self.invoice_doc_template_url =
                "https://web.rentprog.ru/invoice_example.docx";
            }
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.template_load"));
            console.log(error);
          });
        this.isLoading = false; // FT-085: сезоны грузит PricingSettingsTab
      } else {
        this.goBack();
        this.$notify(this.$t("errors.not_permitted_title"), this.$t("errors.only_admins_2"), "error");
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  mounted: function () {
    if (this.$tours["registrationTour"]) {
      this.$tours["registrationTour"].nextStep();
    }
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  beforeDestroy() {
    // Очищаем интервал обновления QR-кода MAX при уничтожении компонента
    this.stopMaxQrRefresh();
    this.stopWhatsappAuthPolling();
    // Очищаем интервал обновления QR-кода Telegram Green-API при уничтожении компонента
    this.stopTelegramGreenApiQrPolling();
  },
  watch: {
    // FT-157: раскрытый Client Secret обязан замаскироваться обратно, как только панель
    // интеграций закрыли или переключили на другую. Без этого живой ключ оставался
    // открытым текстом на экране настроек сколько угодно долго: раскрытие ставится при
    // отказе по секрету, а снималось только успешным подключением (dual-review, P1).
    // Заодно снимаем сообщения под полями — они описывают уже не то, что клиент видит.
    dataIntegrationsPanel() {
      this.avitoSecretVisible = false;
      this.avitoFieldErrors = { client_id: [], client_secret: [] };
    },
    // main_company приходит из Vuex асинхронно, иногда позже mounted. Триггерим
    // загрузку failed webhook events ровно один раз — когда доступ реально есть.
    main_company: {
      handler(val) {
        if (
          val &&
          val.webhook_access &&
          this.includedInPlan('webhooks') &&
          !this.failedWebhookEventsLoaded
        ) {
          this.failedWebhookEventsLoaded = true;
          this.loadFailedWebhookEvents();
        }
        // FT-090: та же гонка, что и у failed events — company-load мог отработать
        // до приезда main_company, и loadWebhookEndpoints() тогда молча вышел.
        // Метод сам проверяет роль/доступы/company и однократность.
        if (val) {
          this.loadWebhookEndpoints();
        }
      },
      immediate: true,
    },
    availableNotificationChannels: {
      handler(newChannels) {
        if (!newChannels || !Array.isArray(newChannels)) return;
        const available = newChannels.map(ch => ch.value);
        const priority = this.notificationChannelsPriority || [];
        if (available.length > 0 && priority.length === 0) {
          this.notificationChannelsPriority = available;
        } else if (available.length > 0) {
          // Убираем каналы, которых больше нет
          const filtered = this.notificationChannelsPriority.filter(ch => available.includes(ch));
          // Добавляем новые каналы, которых ещё нет в приоритете
          const added = available.filter(ch => !filtered.includes(ch));
          this.notificationChannelsPriority = [...filtered, ...added];
        } else {
          this.notificationChannelsPriority = [];
        }
      },
      deep: true
    },
    sign(value) {
      let fr = new FileReader();
      let self = this;
      fr.addEventListener("load", function (e) {
        self.isLoading = true;
        self.axios
          .post(
            "/api/v1/company_signature",
            {
              company_signatures: {
                sign: e.target.result,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            self.$notify(self.$t("sign.upload_success"), "", "success");
          })
          .catch((error) => {
            self.setError(error, self.$t("errors.sign_upload"));
          })
          .finally(() => (self.isLoading = false));
      });
      fr.readAsDataURL(value);
    },
    stamp(value) {
      let fr = new FileReader();
      let self = this;
      fr.addEventListener("load", function (e) {
        self.isLoading = true;
        self.axios
          .post(
            "/api/v1/company_stamp",
            {
              company_stamps: {
                stamp: e.target.result,
              },
            },
            {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            self.$notify(self.$t("sign.upload_stamp_success"), "", "success");
          })
          .catch((error) => {
            self.isLoading = false;
            self.setError(error, self.$t("errors.stamp_upload"));
          })
          .finally(() => (self.isLoading = false));
      });
      fr.readAsDataURL(value);
    },
    booking_message_selected_locale() {
      this.getBookingMessages();
    },
    company: {
      handler(newCompany) {
        if (newCompany) {
          // Загрузка настроек Yandex Pay
          if (newCompany.yandex_pay_enabled !== undefined) {
            this.yandex_pay_enabled = newCompany.yandex_pay_enabled || false;
            this.yandex_pay_api_key = newCompany.yandex_pay_api_key || null;
            this.yandex_pay_merchant_id = newCompany.yandex_pay_merchant_id || null;
            this.yandex_pay_use_sandbox = newCompany.yandex_pay_use_sandbox !== undefined ? newCompany.yandex_pay_use_sandbox : true;
            this.yandex_pay_redirect_success_url = newCompany.yandex_pay_redirect_success_url || null;
            this.yandex_pay_redirect_error_url = newCompany.yandex_pay_redirect_error_url || null;
            this.yandex_pay_redirect_abort_url = newCompany.yandex_pay_redirect_abort_url || null;
            this.yandex_pay_webhook_secret_key_id = newCompany.yandex_pay_webhook_secret_key_id || null;
          }
          
          // Загрузка настроек Stripe
          if (newCompany.stripe_enabled !== undefined) {
            this.stripe_enabled = newCompany.stripe_enabled || false;
            this.stripe_publishable_key = newCompany.stripe_publishable_key || null;
            this.stripe_secret_key = newCompany.stripe_secret_key || null;
            this.stripe_webhook_secret = newCompany.stripe_webhook_secret || null;
            this.stripe_redirect_success_url = newCompany.stripe_redirect_success_url || null;
            this.stripe_redirect_cancel_url = newCompany.stripe_redirect_cancel_url || null;
          }
        }
      },
      immediate: true,
      deep: false
    }
  },
  computed: {
    // Опции «Если доп. часы дороже суток» — значения enum'а Company#expensive_hours_mode.
    expensiveHoursModes() {
      return [
        {
          value: "add_day",
          text: this.$t("companies.expensive_hours_add_day"),
          hint: this.$t("companies.expensive_hours_add_day_hint"),
        },
        {
          value: "cap_hours",
          text: this.$t("companies.expensive_hours_cap_hours"),
          hint: this.$t("companies.expensive_hours_cap_hours_hint"),
        },
        {
          value: "full_hours",
          text: this.$t("companies.expensive_hours_full_hours"),
          hint: this.$t("companies.expensive_hours_full_hours_hint"),
        },
      ];
    },
    expensiveHoursModeHint() {
      const mode = this.company && this.company.expensive_hours_mode;
      const selected = this.expensiveHoursModes.find((item) => item.value === mode);
      return selected ? selected.hint : "";
    },
    // Crisp/Avito — источники CRM-инбокса, без активного add-on'а CRM панели заблокированы
    isCrmEnabled() {
      return this.$store.getters["crm/isCrmEnabled"];
    },
    // Crisp (FT-080)
    crispFormComplete() {
      return !!(this.crispForm.website_id && this.crispForm.identifier && this.crispForm.key);
    },
    // Avito (FT-093)
    avitoFormComplete() {
      return !!(this.avitoForm.client_id && this.avitoForm.client_secret);
    },
    tabs: {
      get() {
        return this.$store.getters.getCompanyProfileTab;
      },
      set(value) {
        this.$store.commit('setCompanyProfileTab', value);
      }
    },
    wialonHosts() {
      return [
        ...this.wialonHostsBase,
        { divider: true },
        { text: this.$t('wialon.custom_server'), value: 'custom' }
      ];
    },
    notificationChannelsModeOptions() {
      return [
        { text: this.$t('notification_channels.mode_all'), value: 'all' },
        { text: this.$t('notification_channels.mode_cascade'), value: 'cascade' },
        { text: this.$t('notification_channels.mode_single'), value: 'single' },
      ];
    },
    availableNotificationChannels() {
      const channels = [];
      if (this.company && this.company.chat_api_instance) {
        channels.push({ text: 'WhatsApp', value: 'whatsapp' });
      }
      if (this.company && this.company.max_instance) {
        channels.push({ text: 'MAX', value: 'max' });
      }
      if (this.company && this.company.telegram_green_api_instance && this.company.telegram_green_api_enabled) {
        channels.push({ text: 'Telegram', value: 'telegram_green_api' });
      }
      return channels;
    },
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company;
      }
      return undefined;
    },
    ygibdd_active() {
      const company = this.$store.getters.getCompany?.company;
      return !!(company && (company.fines_provider || company.ygibdd_active));  // fines_auto_select актуален для любого провайдера
    },
    finesMonitoringEnabled() {
      const company = this.$store.getters.getCompany?.company;
      return !!(company && company.fines_provider === "shtrafus");
    },
    main_company() {
      if (this.$store.getters.getMainCompany) {
        return this.$store.getters.getMainCompany;
      }
      return undefined;
    },
    showRemoveDemo() {
      return this.$store.getters.getCompany.company.demo_content;
    },
    isInvoiceClient() {
      return this.main_company?.payment_provider_preference === 'paddle' &&
             this.main_company?.plan?.billing_collection_method === 'invoice';
    },
    isBillingAddressFilled() {
      const addr = this.company?.billing_address;
      return addr && addr.country_code && addr.city && addr.first_line && addr.postal_code;
    },
    showBillingAddressBanner() {
      if (!this.isInvoiceClient) return false;
      if (this.isBillingAddressFilled) return false;
      
      // Проверяем что прошло 7 дней с регистрации
      const createdAt = this.main_company?.created_at;
      if (!createdAt) return false;
      
      const daysSinceRegistration = this.$moment().diff(this.$moment(createdAt), 'days');
      return daysSinceRegistration >= 7;
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    sortedCountries() {
      return countries
        .filter(c => c.code) // Только страны с ISO кодом
        .map(c => ({ text: c.name, value: c.code }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          cashboxes.push(cashbox);
        });
        // сортируем по id
        cashboxes.sort((a, b) => {
          return a.id - b.id;
        });

        return cashboxes;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.company_cashboxes && this.company_cashboxes.length > 0) {
        if (this.company_cashboxes.find((cashbox) => cashbox.is_default)) {
          return this.company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
        } else {
          return this.company_cashboxes[0].currency_id;
        }
      } else {
        return null;
      }
    },
    webhook_endpoints() {
      if (this.company && this.company.webhook_endpoints) {
        return this.company.webhook_endpoints;
      } else {
        return [];
      }
    },
    vatNumberHint() {
      // Маппинг стран на коды VAT и примеры
      const countryToVatCode = {
        'Austria': { code: 'AT', example: 'ATU12345678', pattern: /^ATU\d{8}$/ },
        'Belgium': { code: 'BE', example: 'BE0123456789', pattern: /^BE[01]\d{9}$/ },
        'Bulgaria': { code: 'BG', example: 'BG123456789', pattern: /^BG\d{9,10}$/ },
        'Croatia': { code: 'HR', example: 'HR12345678901', pattern: /^HR\d{11}$/ },
        'Cyprus': { code: 'CY', example: 'CY12345678A', pattern: /^CY\d{8}[A-Z]$/ },
        'Czech Republic': { code: 'CZ', example: 'CZ12345678', pattern: /^CZ\d{8,10}$/ },
        'Denmark': { code: 'DK', example: 'DK12345678', pattern: /^DK\d{8}$/ },
        'Estonia': { code: 'EE', example: 'EE123456789', pattern: /^EE\d{9}$/ },
        'Finland': { code: 'FI', example: 'FI12345678', pattern: /^FI\d{8}$/ },
        'France': { code: 'FR', example: 'FRXX123456789', pattern: /^FR[A-Z0-9]{2}\d{9}$/ },
        'Germany': { code: 'DE', example: 'DE123456789', pattern: /^DE\d{9}$/ },
        'Greece': { code: 'EL', example: 'EL123456789', pattern: /^EL\d{9}$/ },
        'Hungary': { code: 'HU', example: 'HU12345678', pattern: /^HU\d{8}$/ },
        'Ireland': { code: 'IE', example: 'IE1234567X', pattern: /^IE\d[A-Z0-9]\d{5}[A-Z]{1,2}$/ },
        'Italy': { code: 'IT', example: 'IT12345678901', pattern: /^IT\d{11}$/ },
        'Latvia': { code: 'LV', example: 'LV12345678901', pattern: /^LV\d{11}$/ },
        'Lithuania': { code: 'LT', example: 'LT123456789', pattern: /^LT\d{9,12}$/ },
        'Luxembourg': { code: 'LU', example: 'LU12345678', pattern: /^LU\d{8}$/ },
        'Malta': { code: 'MT', example: 'MT12345678', pattern: /^MT\d{8}$/ },
        'Netherlands': { code: 'NL', example: 'NL123456789B01', pattern: /^NL\d{9}B\d{2}$/ },
        'Poland': { code: 'PL', example: 'PL1234567890', pattern: /^PL\d{10}$/ },
        'Portugal': { code: 'PT', example: 'PT123456789', pattern: /^PT\d{9}$/ },
        'Romania': { code: 'RO', example: 'RO1234567890', pattern: /^RO\d{2,10}$/ },
        'Slovakia': { code: 'SK', example: 'SK1234567890', pattern: /^SK\d{10}$/ },
        'Slovenia': { code: 'SI', example: 'SI12345678', pattern: /^SI\d{8}$/ },
        'Spain': { code: 'ES', example: 'ESX1234567X', pattern: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/ },
        'Sweden': { code: 'SE', example: 'SE123456789012', pattern: /^SE\d{12}$/ },
        'United Kingdom': { code: 'GB', example: 'GB123456789', pattern: /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/ },
        'Switzerland': { code: 'CHE', example: 'CHE123456789MWST', pattern: /^CHE\d{9}(MWST|TVA|IVA)$/ },
        'Norway': { code: 'NO', example: 'NO123456789MVA', pattern: /^NO\d{9}MVA$/ },
        'Australia': { code: 'AU', example: 'AU12345678901', pattern: /^AU\d{11}$/ },
        'New Zealand': { code: 'NZ', example: 'NZ123456789', pattern: /^NZ\d{8,9}$/ },
        'India': { code: 'IN', example: 'IN22AAAAA0000A1Z5', pattern: /^IN\d{2}[A-Z]{5}\d{4}[A-Z]\d[A-Z]\d$/ },
        'Russia': { code: '', example: '1234567890', pattern: /^\d{10}$|^\d{12}$/ },
        'Belarus': { code: '', example: '123456789', pattern: /^\d{9}$/ },
        'United States': { code: 'US', example: 'US123456789', pattern: /^US\d{9}$/ },
        'Turkey': { code: 'TR', example: 'TR1234567890', pattern: /^TR\d{10}$/ },
        'Brazil': { code: 'BR', example: 'BR12.345.678/9012-34', pattern: /^BR\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/ },
        'Japan': { code: 'JP', example: 'JP1234567890123', pattern: /^JP\d{13}$/ },
        'South Korea': { code: 'KR', example: 'KR123-45-67890', pattern: /^KR\d{3}-\d{2}-\d{5}$/ },
        'Mexico': { code: 'MX', example: 'MXAAAA123456ABC', pattern: /^MX[A-Z]{4}\d{6}[A-Z0-9]{3}$/ },
        'Canada': { code: 'CA', example: 'CA123456789RT0001', pattern: /^CA\d{9}RT\d{4}$/ },
        'Singapore': { code: 'SG', example: 'SGM2-1234567-8', pattern: /^SG(M2-\d{7}-[0-9A-Z]|MR-\d{7}-[0-9A-Z]|\d{2}-\d{7}-[0-9A-Z]|F2-\d{7}-D)$/ },
        'South Africa': { code: 'ZA', example: 'ZA1234567890', pattern: /^ZA\d{10}$/ },
        'Thailand': { code: 'TH', example: 'TH1234567890123', pattern: /^TH\d{13}$/ },
        'Indonesia': { code: 'ID', example: 'ID123456789000000', pattern: /^ID\d{15}$/ },
        'Philippines': { code: 'PH', example: 'PH123-456-789-01234', pattern: /^PH\d{3}-\d{3}-\d{3}-\d{5}$/ },
        'Vietnam': { code: 'VN', example: 'VN1234567890', pattern: /^VN\d{10,13}$/ },
        'United Arab Emirates': { code: 'AE', example: 'AE123456789000000', pattern: /^AE\d{15}$/ },
        'Saudi Arabia': { code: 'SA', example: 'SA123456789000000', pattern: /^SA\d{15}$/ },
        'Israel': { code: 'IL', example: 'IL123456789', pattern: /^IL\d{9}$/ },
        'Egypt': { code: 'EG', example: 'EG123456789', pattern: /^EG\d{9}$/ },
      };

      // Определяем VAT формат для страны компании
      const countryVat = this.company && this.company.country ? countryToVatCode[this.company.country] : null;
      
      // Если поле пустое - показываем пример для страны или общий пример
      if (!this.company || !this.company.inn || this.company.inn.trim() === '') {
        if (countryVat) {
          return `${this.$t('tariffs.vat_number_hint')} ${countryVat.example}`;
        }
        return `${this.$t('tariffs.vat_number_hint')} DE123456789, ATU12345678, GB123456789`;
      }
      
      // Проверяем валидность введенного номера
      const vatNumber = this.company.inn.trim();
      
      // Если есть настройка для страны компании - проверяем по ней в первую очередь
      if (countryVat) {
        // Для стран без префикса (например, Россия) - проверяем напрямую по паттерну
        if (countryVat.code === '') {
          if (countryVat.pattern.test(vatNumber)) {
            return `${this.$t('tariffs.vat_number_hint')} ${countryVat.example} ✓`;
          } else {
            return `${this.$t('tariffs.vat_invalid_format')}. ${this.$t('tariffs.vat_number_hint')} ${countryVat.example}`;
          }
        }
        
        // Для стран с префиксом - проверяем с учетом префикса
        const vatNumberUpper = vatNumber.toUpperCase();
        if (countryVat.pattern.test(vatNumberUpper)) {
          return `${this.$t('tariffs.vat_number_hint')} ${countryVat.example} ✓`;
        } else if (vatNumberUpper.startsWith(countryVat.code)) {
          return `${this.$t('tariffs.vat_invalid_format_country', { country: countryVat.code })}. ${this.$t('tariffs.vat_number_hint')} ${countryVat.example}`;
        }
      }
      
      // Проверяем по всем известным форматам (если не совпал с форматом страны компании)
      const vatNumberUpper = vatNumber.toUpperCase();
      for (const [countryName, vatInfo] of Object.entries(countryToVatCode)) {
        // Пропускаем страны без префикса (они проверяются только если это страна компании)
        if (vatInfo.code === '') continue;
        
        if (vatNumberUpper.startsWith(vatInfo.code)) {
          if (vatInfo.pattern.test(vatNumberUpper)) {
            return `${this.$t('tariffs.vat_number_hint')} ${vatInfo.example} ✓`;
          } else {
            return `${this.$t('tariffs.vat_invalid_format_country', { country: vatInfo.code })}. ${this.$t('tariffs.vat_number_hint')} ${vatInfo.example}`;
          }
        }
      }
      
      // Базовая проверка без префикса
      if (vatNumber.length >= 8 && vatNumber.length <= 20 && /^[A-Z0-9\-./\s]+$/i.test(vatNumber)) {
        if (countryVat) {
          return `${this.$t('tariffs.vat_number_hint')} ${countryVat.example} ✓`;
        }
        return `${this.$t('tariffs.vat_number_hint')} DE123456789, ATU12345678, GB123456789 ✓`;
      }
      
      // По умолчанию показываем пример для страны или общий
      if (countryVat) {
        return `${this.$t('tariffs.vat_number_hint')} ${countryVat.example}`;
      }
      return `${this.$t('tariffs.vat_number_hint')} DE123456789, ATU12345678, GB123456789`;
    }
  },
  methods: {
    // --- Crisp (FT-080) ---
    fetchCrispStatus() {
      this.axios
        .get("/api/v1/integrations/crisp/status", {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          this.crisp = {
            connected: !!response.data.connected,
            website_id: response.data.crisp_website_id || null,
            webhook_url: response.data.webhook_url || null,
          };
        })
        .catch((error) => console.log(error)); // не-админам/старым бэкам — молча
    },
    crispConnect() {
      this.isLoadingCrisp = true;
      this.axios
        .post(
          "/api/v1/integrations/crisp/connect",
          {
            crisp_website_id: this.crispForm.website_id,
            crisp_token_identifier: this.crispForm.identifier,
            crisp_token_key: this.crispForm.key,
          },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then((response) => {
          this.crisp = {
            connected: true,
            website_id: response.data.crisp_website_id,
            webhook_url: response.data.webhook_url,
          };
          this.crispForm = { website_id: "", identifier: "", key: "" };
        })
        .catch((error) => {
          const code = error && error.response && error.response?.data && error.response?.data.error;
          const key = code === "crisp_website_taken" ? "crisp.error_taken" : "crisp.error_invalid";
          this.setError(error, this.$t(key));
        })
        .finally(() => {
          this.isLoadingCrisp = false;
        });
    },
    async crispDisconnect() {
      const result = await this.$confirm({
        title: this.$t("crisp.disconnect_confirm"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 500,
      });
      if (!result) return;

      this.isLoadingCrisp = true;
      this.axios
        .delete("/api/v1/integrations/crisp/disconnect", {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then(() => {
          this.crisp = { connected: false, website_id: null, webhook_url: null };
        })
        .catch((error) => this.setError(error, this.$t("crisp.error_invalid")))
        .finally(() => {
          this.isLoadingCrisp = false;
        });
    },
    copyCrispWebhookUrl() {
      if (navigator.clipboard && navigator.clipboard.writeText && this.crisp.webhook_url) {
        navigator.clipboard.writeText(this.crisp.webhook_url);
        this.crispCopied = true;
        setTimeout(() => {
          this.crispCopied = false;
        }, 1500);
      }
    },
    // --- /Crisp ---
    // --- Avito Messenger (FT-093) ---
    fetchAvitoStatus() {
      this.axios
        .get("/api/v1/integrations/avito/status", {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          this.avito = {
            connected: !!response.data.connected,
            user_id: response.data.user_id || null,
            webhook_url: response.data.webhook_url || null,
          };
        })
        .catch((error) => console.log(error)); // не-админам/старым бэкам — молча
    },
    avitoConnect() {
      this.isLoadingAvito = true;
      this.avitoFieldErrors = { client_id: [], client_secret: [] };
      this.axios
        .post(
          "/api/v1/integrations/avito/connect",
          {
            client_id: this.avitoForm.client_id,
            client_secret: this.avitoForm.client_secret,
          },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then((response) => {
          this.avito = {
            connected: true,
            user_id: response.data.user_id,
            webhook_url: response.data.webhook_url,
          };
          this.avitoForm = { client_id: "", client_secret: "" };
          this.avitoSecretVisible = false;
        })
        .catch((error) => this.showAvitoConnectError(error))
        .finally(() => {
          this.isLoadingAvito = false;
        });
    },
    // FT-157 REQ-02/REQ-04. Доменные коды Avito показываем САМИ, не через setError: для
    // тела вида { error: "<код>" } setErrorMixin не находит codeKey и печатает сырой код
    // латиницей ТЕЛОМ тоста под переведённым заголовком (известный класс). Коды,
    // адресующие поле, уходят в error-messages этого поля, остальные — одним тостом.
    //
    // ВСЁ ОСТАЛЬНОЕ обязано уйти в setError (dual-review, обе линии P1). Безусловный
    // перехват снимал два гварда, которые setErrorMixin держит намеренно: на мёртвой
    // сессии наш тост ЗАТИРАЛ сообщение интерсептора (снекбар в приложении один —
    // инвариант FT-136), на обрыве сети добавлялся вторым к баннеру «Проблема с сетью»,
    // а Rollbar переставал видеть настоящие сбои connect (500, 403). И это был бы
    // ровно тот misdiagnosis, ради устранения которого заведена фича: клиенту говорят
    // «проверьте ключи», когда виноват не он.
    showAvitoConnectError(error) {
      const code = error && error.response && error.response.data && error.response.data.error;
      const field = has(AVITO_FIELD_ERROR_CODES, code) && AVITO_FIELD_ERROR_CODES[code];

      if (field) {
        // Раскрываем секрет, если проблема в нём: сообщение под замаскированным полем
        // клиент прочитает, а причину — нет.
        if (field[0] === "client_secret") this.avitoSecretVisible = true;
        this.avitoFieldErrors = { ...this.avitoFieldErrors, [field[0]]: [this.$t(field[1])] };
        return;
      }

      if (has(AVITO_TOAST_ERROR_CODES, code)) {
        this.$notify(this.$t(AVITO_TOAST_ERROR_CODES[code]), "", "warning", 6000);
        return;
      }

      // Не доменный отказ Avito — сетевой сбой, мёртвая сессия, 500, 403. Глобальная
      // политика (гварды + Rollbar) знает про них больше, чем эта форма.
      this.setError(error, this.$t("avito.error_invalid"));
    },
    // Сообщение под полем живёт до следующей попытки ИЛИ до правки этого поля: клиент
    // исправил значение — красное под ним больше не описывает то, что он видит.
    clearAvitoFieldError(field) {
      if (!this.avitoFieldErrors[field].length) return;

      this.avitoFieldErrors = { ...this.avitoFieldErrors, [field]: [] };
    },
    async avitoDisconnect() {
      const result = await this.$confirm({
        title: this.$t("avito.disconnect_confirm"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 500,
      });
      if (!result) return;

      this.isLoadingAvito = true;
      this.axios
        .delete("/api/v1/integrations/avito/disconnect", {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then(() => {
          this.avito = { connected: false, user_id: null, webhook_url: null };
        })
        .catch((error) => this.setError(error, this.$t("avito.error_disconnect_failed")))
        .finally(() => {
          this.isLoadingAvito = false;
        });
    },
    // copyTextToClipboard (@/utils/clipboard), а не navigator.clipboard напрямую: в
    // Capacitor-сборках и в non-secure-context navigator.clipboard отсутствует — кнопка
    // молча ничего не копировала бы, при этом галочка «скопировано» всё равно загоралась.
    async copyAvitoWebhookUrl() {
      if (!this.avito.webhook_url) return;

      await copyTextToClipboard(this.avito.webhook_url);
      this.avitoCopied = true;
      setTimeout(() => {
        this.avitoCopied = false;
      }, 1500);
    },
    // --- /Avito ---
    validateWialonHostUrl(value) {
      if (!value) {
        return this.$t('wialon.custom_server_required');
      }
      const hostPattern = /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*$/;
      if (!hostPattern.test(value)) {
        return this.$t('wialon.custom_server_invalid');
      }
      return true;
    },
    // Форма платёжного адреса — локальная копия company.billing_address:
    // saveCompany() шлёт её отдельным полем и до отправки требует заполненной
    // у invoice-клиента. Заполняем без оглядки на isInvoiceClient: он считается
    // из main_company, а тот к моменту ответа /api/v1/company может быть ещё не
    // в сторе (та же гонка, что у вебхуков в наблюдателе main_company). Читают
    // billingAddress только ветки isInvoiceClient, лишнего вреда нет.
    hydrateBillingAddress(address) {
      if (!address) return;
      this.billingAddress = {
        country_code: address.country_code || '',
        city: address.city || '',
        first_line: address.first_line || '',
        postal_code: address.postal_code || ''
      };
    },
    initWialonHostSelection() {
      if (this.company && this.company.wialon_host) {
        const knownHost = this.wialonHostsBase.find(h => h.value === this.company.wialon_host);
        if (knownHost) {
          this.wialonHostSelection = this.company.wialon_host;
        } else {
          this.wialonHostSelection = 'custom';
          this.customWialonHost = this.company.wialon_host;
        }
      }
    },
    refreshCompanyData() {
      this.axios
        .get(`/api/v1/company`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.$store.commit("setCompany", { company: response.data });
        })
        .catch((error) => {
          console.error('Error refreshing company data:', error);
        });
    },
    formatedDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss');
    },
    async saveCompany() {
      if (this.isStaff) {
        // Валидация для invoice клиентов - обязательный биллинг адрес
        if (this.isInvoiceClient) {
          if (!this.billingAddress.country_code || !this.billingAddress.city || 
              !this.billingAddress.first_line || !this.billingAddress.postal_code) {
            this.$notify(
              this.$t("errors.error"),
              this.$t("tariffs.billing_address_required"),
              "warning"
            );
            return;
          }
        }
        
        this.isLoading = true;
        // Объект компании берём ДО ожидания. this.company — computed поверх Vuex, а
        // setCompany прилетает ещё и по CompanyChannel: broadcast, пришедший за время
        // сохранения курсов, подменил бы объект, и в PATCH уехали бы доредакционные
        // значения вместо набранных на странице.
        let company = this.company;
        // Курсы валют не входят в тело PATCH /api/v1/company, а ответ приходит С ними
        // из БД и коммитится в стор — набранное в поле курса иначе откатывается назад
        // сразу после «успешно сохранено».
        const rateOutcome = await this.saveDirtyExchangeRates();
        // setError внутри цепочки курсов гасит isLoading — восстанавливаем, иначе
        // спиннер кнопки погаснет, пока запрос компании ещё в полёте.
        this.isLoading = true;
        let self = this;
        if (this.new_counts_group != "") {
          company.counts_groups.push(this.new_counts_group);
        }
        if (this.edit_counts_group != "") {
          let foundIndex = company.counts_groups.findIndex(
            (element) => element === this.old_counts_group
          );
          company.counts_groups.splice(foundIndex, 1, this.edit_counts_group);
          this.axios
            .get(
              `/api/v1/update_counts_group/${this.old_counts_group}&${this.edit_counts_group}`,
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .catch((error) => {
              this.setError(error, this.$t("errors.counts_groups_upload"));
            });
        }

        // Формируем массив источников клиентов
        if (this.clients_sources && this.clients_sources.length > 0) {
          this.clients_sources_array = [];
          this.clients_sources.forEach((source) => {
            self.clients_sources_array.push(source.value);
          });
        }

        this.axios
          .patch(
            `/api/v1/company`,
            {
              company: {
                name: company.name,
                age_limit: company.age_limit,
                hours_limit: company.hours_limit,
                expensive_hours_mode: company.expensive_hours_mode,
                min_days: company.min_days,
                rent_type: company.rent_type,
                location_start: company.location_start,
                location_end: company.location_end,
                free_cancel: company.free_cancel,
                gas_cost: company.gas_cost,
                in_booking: company.in_booking,
                email_for_bookings: company.email_for_bookings,
                send_new_bookings: company.send_new_bookings,
                send_booking_icalendar: company.send_booking_icalendar,
                telegram_id: company.telegram_id,
                telegram_on: company.telegram_on,
                whatsapp: company.whatsapp,
                chat_api_instance: company.chat_api_instance,
                chat_api_token: company.chat_api_token,
                cash_payment: company.cash_payment,
                card_payment: company.card_payment,
                card_to_card_payment: company.card_to_card_payment,
                cashless_payment: company.card_payment,
                entity_payment: company.entity_payment,
                interval_bookings: company.interval_bookings,
                add_driver: company.add_driver,
                add_driver_cost: company.add_driver_cost,
                mileage_limit: company.mileage_limit,
                mileage_limit_cost: company.mileage_limit_cost,
                counts_groups: company.counts_groups,
                phone: company.phone,
                country: company.country,
                time_zone: company.time_zone,
                locale: company.locale,
                city: company.city,
                address: company.address,
                currency: company.currency,
                site: company.site,
                vk: company.vk,
                fb: company.fb,
                instagram: company.instagram,
                youtube: company.youtube,
                logout_interval: company.logout_interval,
                yandex: company.yandex,
                google: company.google,
                gis: company.gis,
                autofon_token: company.autofon_token,
                autofon_pwd: company.autofon_pwd,
                starline_app_id: company.starline_app_id,
                starline_secret: company.starline_secret,
                starline_login: company.starline_login,
                starline_password: company.starline_password,
                starline_auto_mileage_sync: company.starline_auto_mileage_sync,
                starline_mileage_threshold: company.starline_mileage_threshold,
                company_type: company.company_type,
                company_name: company.company_name,
                company_adress: company.company_adress,
                company_post_adress: company.company_post_adress,
                inn: company.inn,
                kpp: company.kpp,
                ogrn: company.ogrn,
                bank_account: company.bank_account,
                correspondent_account: company.correspondent_account,
                bank_name: company.bank_name,
                bik: company.bik,
                chief_name: company.chief_name,
                part_return_deposit_days: company.part_return_deposit_days,
                clients_sources: self.clients_sources_array,
                word_templates: company.word_templates,
                docx_templates_on: company.docx_templates_on,
                new_templates: company.new_templates,
                pdf_templates: company.pdf_templates,
                new_booking_sound: company.new_booking_sound,
                send_start_booking: company.send_start_booking,
                send_end_booking: company.send_end_booking,
                overbooking: company.overbooking,
                fines_auto_select: self.fines_auto_select,
                teletype_api_key: company.teletype_api_key,
                in_localrent: company.in_localrent,
                manual_currency_rate_update: company.manual_currency_rate_update,
                can_select_agents: company.can_select_agents,
                damage_marking: company.damage_marking,
                yandex_taxi_client_id: company.yandex_taxi_client_id,
                yandex_taxi_park_id: company.yandex_taxi_park_id,
                yandex_taxi_api_key: company.yandex_taxi_api_key,
                okidoki_enabled: company.okidoki_enabled,
                okidoki_api_key: company.okidoki_api_key,
                docuseal_api_key: company.docuseal_api_key,
                docuseal_domain: company.docuseal_domain,
                docuseal_enabled: company.docuseal_enabled,
                periodic_pricing_method: company.periodic_pricing_method,
                periodic_balance_warning_days: company.periodic_balance_warning_days,
                billing_address: this.isInvoiceClient ? this.billingAddress : company.billing_address,
                notification_channels_config: company.notification_channels_config,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.$store.commit("setCompany", { company: response.data });
            this.showEdit = false;
            this.showEditCountsGroup = false;
            this.showNewCountsGroup = false;
            // Одно сообщение на всё сохранение и последним: снекбар в приложении один,
            // и зелёное «успешно» затирало бы предупреждение о несохранённом курсе.
            // Черновик при этом остаётся, поэтому поле продолжает показывать
            // набранное — человек видит и что компания сохранена, и что курс нет.
            this.notifySaveOutcome(rateOutcome);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.profile_save"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    rental_object() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.rental_object) {
        return this.$store.getters.getCompany.company.rental_object;
      } else {
        return 'cars';
      }
    },
    updateManualCurrencyRateUpdate() {
      if (this.isStaff) {
        this.isLoadingUpdateManualCurrencyRateUpdate = true;

        this.axios
          .patch(
            `/api/v1/company`,
            {
              company: {
                manual_currency_rate_update: this.company.manual_currency_rate_update,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.$store.commit("setCompany", { company: response.data });
            this.$notify(this.$t("companies.updated_success"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.profile_save"));
          })
          .finally(() => (this.isLoadingUpdateManualCurrencyRateUpdate = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Значение в поле курса: черновик, пока пользователь правит, иначе — то, что в сторе.
    exchangeRateDraft(rate) {
      const draft = this.exchange_rate_drafts[rate.id];
      return draft === undefined ? this.exchangeRateStored(rate) : draft;
    },
    exchangeRateStored(rate) {
      return rate.rate === null || rate.rate === undefined ? "" : String(rate.rate);
    },
    setExchangeRateDraft(rate, value) {
      this.$set(this.exchange_rate_drafts, rate.id, value);
    },
    isExchangeRateDirty(rate) {
      const draft = this.exchange_rate_drafts[rate.id];
      if (draft === undefined) return false;
      return this.normalizeRateInput(draft) !== this.exchangeRateStored(rate);
    },
    // Разделитель у человека тот, что на его клавиатуре: «12,5» — обычная запись и в
    // русской, и в португальской раскладке. Правило НОРМАЛИЗАЦИИ здесь дословно
    // повторяет серверное (api DecimalInput, сеттер ExchangeRate#rate=): чистятся
    // только края, ровно один разделитель считается десятичным, больше одного —
    // строка не трогается.
    //
    // Внутренние пробелы НЕ убираются. Первая редакция сносила их целиком, и «12 5» —
    // промах по клавише вместо точки — превращался в 125 и сохранялся с зелёным
    // «Успешно», то есть множитель, завышенный в десять раз. Сервер такую строку
    // отбивал, и расхождение означало, что веб и мобильное приложение сохраняют из
    // одного ввода разное.
    normalizeRateInput(value) {
      const raw = String(value === null || value === undefined ? "" : value);
      // \s в JS покрывает и U+00A0, и U+202F — те самые, что приезжают вставкой из
      // Excel; Ruby-версия чистит края через [[:space:]] по той же причине.
      const trimmed = raw.replace(/^\s+|\s+$/g, "");
      const separators = (trimmed.match(/[.,]/g) || []).length;
      if (separators !== 1 || this.isAmbiguousRateInput(trimmed)) return trimmed;
      return trimmed.replace(",", ".");
    },
    // «17,000» читается и как 17 (тысячная группировка), и как 17.0 — разница в
    // тысячу раз в денежном множителе, а курсы обоих порядков у продукта настоящие
    // (EUR→IDR ≈ 17 000, USD/RUB ≈ 92,345). Отказываемся гадать — как и сервер.
    // Ноль в целой части исключён: группировка после голого нуля не пишется.
    isAmbiguousRateInput(value) {
      const trimmed = String(value === null || value === undefined ? "" : value).replace(/^\s+|\s+$/g, "");
      return /^\d+,\d{3}$/.test(trimmed) && trimmed.split(",")[0] !== "0";
    },
    // parseFloat разбирает ПРЕФИКС: parseFloat("12oops") === 12. Проверять им ввод в
    // денежное поле нельзя — «12oops» уезжал на сервер и возвращался невнятным 422.
    // Здесь значение проверяется целиком.
    //
    // Форма шире серверной ровно на то, что сервер принимает: «.5» и «+12.5» проходят
    // (замерено на модели). Экспонента («1e3») сервером принимается, а здесь нет —
    // осознанная строгость: в поле курса это опечатка, а не намерение, и цена её —
    // множитель ×1000. Отказ локальный и ничего больше не блокирует.
    isValidRateInput(value) {
      return /^\+?(\d+(\.\d+)?|\.\d+)$/.test(value) && parseFloat(value) > 0;
    },
    // Курс живёт в своём эндпоинте, но в сторе — внутри объекта компании. После
    // сохранения кладём ответ сервера в стор сами: PaymentDialog и остальные считают
    // по company.exchange_rates и не должны ждать broadcast по WebSocket.
    applyExchangeRateToStore(saved) {
      const company_data = this.company;
      if (!company_data || !company_data.exchange_rates || !saved) return;
      const found = company_data.exchange_rates.find((r) => r.id == saved.id);
      if (!found) return;
      found.rate = saved.rate;
      this.$store.commit("setCompany", { company: company_data });
    },
    notifySaveOutcome(rateOutcome) {
      const stuck = (rateOutcome.invalid || []).concat(rateOutcome.rejected || []);
      if (stuck.length === 0) {
        this.$notify(this.$t("companies.updated_success"), "", "success", 3000);
        return;
      }
      const problem = (rateOutcome.invalid || []).length
        ? this.$t("companies.rate_ambiguous_or_invalid")
        : this.$t("errors.error");
      this.$notify(this.$t("companies.saved_except_rate"), problem, "warning", 6000);
    },
    // Причина отказа для конкретного черновика: null — годен.
    exchangeRateInputProblem(rate) {
      const value = this.normalizeRateInput(this.exchangeRateDraft(rate));
      if (this.isAmbiguousRateInput(value)) return "companies.rate_ambiguous";
      if (!this.isValidRateInput(value)) return "companies.rate_invalid";
      return null;
    },
    // silent — для пачечного сохранения по кнопке «Сохранить»: снекбар в приложении
    // ОДИН, последний вызов затирает предыдущий, поэтому зелёное «успешно» по второму
    // курсу перекрывало красное по первому. Итог пачки объявляет вызывающий, один раз.
    updateExchangeRate(rate, { silent = false } = {}) {
      if (!this.isStaff) {
        if (!silent) this.$notify(this.$t("errors.no_access"), "", "warning");
        return Promise.resolve(false);
      }

      const problem = this.exchangeRateInputProblem(rate);
      if (problem) {
        if (!silent) this.$notify(this.$t("errors.error"), this.$t(problem), "warning");
        return Promise.resolve(false);
      }

      const value = this.normalizeRateInput(this.exchangeRateDraft(rate));
      this.isLoadingUpdateExchangeRate = true;
      this.updatingExchangeRateId = rate.id;

      return this.axios
        .patch(`/api/v1/exchange_rates/${rate.id}`, { rate: value }, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.applyExchangeRateToStore(response.data);
          // Черновик снимаем, ТОЛЬКО если он всё ещё тот, что отправляли. Иначе
          // правка, сделанная пока запрос был в полёте, стиралась ответом старого
          // запроса, и поле откатывалось к отправленному ранее значению — тот же
          // класс потери набранного, ради которого всё это и делалось.
          if (this.normalizeRateInput(this.exchangeRateDraft(rate)) === value) {
            this.$delete(this.exchange_rate_drafts, rate.id);
          }
          if (!silent) this.$notify(this.$t("custom.success"), "", "success", 3000);
          return true;
        })
        .catch((error) => {
          if (silent) return false;
          this.setError(error, this.$t("errors.error"));
          return false;
        })
        .finally(() => (this.isLoadingUpdateExchangeRate = false, this.updatingExchangeRateId = null));
    },
    // Кнопка «Сохранить» на странице шлёт PATCH /api/v1/company, а курса в этом теле
    // нет — ответ приходит с курсами из БД и затирает набранное. Поэтому изменённые
    // курсы сохраняем ДО запроса компании, каждый своим эндпоинтом.
    // Курсы, которые сейчас видны и правились. Скрытая панель (выключено ручное
    // обновление курса) в расчёт не идёт: иначе отредактированный и забытый черновик
    // уходил на сервер при следующем сохранении чего угодно на странице.
    dirtyVisibleExchangeRates() {
      if (!this.company || !this.company.manual_currency_rate_update) return [];
      return (this.company.exchange_rates || []).filter((rate) => this.isExchangeRateDirty(rate));
    },
    // Возвращает разбор: что сохранено, что отвергнуто сервером, что не отправлялось
    // из-за негодного ввода. Страницу НЕ блокирует.
    //
    // Первая редакция останавливала сохранение всей компании при любой неудаче курса.
    // Но saveCompany дёргают двадцать мест — переключатели, дискеты, кнопки, — и один
    // брошенный некорректный черновик гасил их все: настройка уже записана в Vuex
    // через v-model, выглядит сохранённой, а на сервер не ушла.
    saveDirtyExchangeRates() {
      const dirty = this.dirtyVisibleExchangeRates();
      const invalid = dirty.filter((rate) => this.exchangeRateInputProblem(rate));
      const sendable = dirty.filter((rate) => !this.exchangeRateInputProblem(rate));
      const rejected = [];

      // Последовательно: индикатор загрузки у поля один на все курсы.
      return sendable
        .reduce(
          (chain, rate) => chain.then(() =>
            this.updateExchangeRate(rate, { silent: true }).then((ok) => {
              if (!ok) rejected.push(rate);
            })
          ),
          Promise.resolve()
        )
        .then(() => ({ invalid, rejected }));
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    async updateToken() {
      if (
        this.isManagerPlus) {
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("companies.update_token_warning"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.isLoading = true;
          this.axios
            .patch(`/api/v1/update_api_token`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.company.token = response.data.token;
              this.$notify(this.$t("companies.update_token_success"), "", "success", 3000);
            })
            .catch((error) =>
              this.setError(error, this.$t("errors.seasons_delete"))
            )
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async copyToken() {
      try {
        await copyTextToClipboard(this.company.token);
        // document.execCommand('copy');
        this.$notify(this.$t("companies.copy_token_success"), "", "success", 3000);
      } catch (error) {
        this.$notify(this.$t("custom.copy_error"), "", "error");
      }
    },
    addCashbox() {
      let new_cashbox = {
        new: true,
        name: "",
        cash: 0,
        cashless: 0,
        is_default: false,
        is_active: true,
        currency_id: null,
      };
      let company_data = this.company;
      company_data.company_cashboxes.push(new_cashbox);
      console.log("company_data.company_cashboxes", company_data.company_cashboxes);
      this.$store.commit("setCompany", { company: company_data });
    },
    addWebhookEndpoint() {
      let new_endpoint = {
        new: true,
        url: null,
        enabled: true,
        subscriptions: []
      };
      let company_data = this.company;
      company_data.webhook_endpoints.push(new_endpoint);
      this.$store.commit("setCompany", { company: company_data });
    },
    loadFailedWebhookEvents() {
      this.isLoadingFailedWebhookEvents = true;
      this.axios
        .get(`/api/v1/webhook_endpoints/failed_events`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.failed_webhook_events = response.data.items || [];
          this.failedWebhookEventsHasMore = Boolean(response.data.has_more);
        })
        .catch((error) => {
          console.error('Error loading failed webhook events:', error);
        })
        .finally(() => {
          this.isLoadingFailedWebhookEvents = false;
        });
    },
    loadMoreFailedWebhookEvents() {
      if (this.isLoadingMoreFailedWebhookEvents || !this.failedWebhookEventsHasMore) return;
      const last = this.failed_webhook_events[this.failed_webhook_events.length - 1];
      if (!last) {
        this.loadFailedWebhookEvents();
        return;
      }
      this.isLoadingMoreFailedWebhookEvents = true;
      this.axios
        .get(`/api/v1/webhook_endpoints/failed_events`, {
          params: { before_id: last.id },
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          const newItems = response.data.items || [];
          this.failed_webhook_events = this.failed_webhook_events.concat(newItems);
          this.failedWebhookEventsHasMore = Boolean(response.data.has_more);
        })
        .catch((error) => {
          console.error('Error loading more failed webhook events:', error);
        })
        .finally(() => {
          this.isLoadingMoreFailedWebhookEvents = false;
        });
    },
    redeliverWebhookEvent(event) {
      if (this.redeliveringWebhookEventIds.includes(event.id)) return;
      this.redeliveringWebhookEventIds.push(event.id);
      this.axios
        .post(
          `/api/v1/webhook_endpoints/redeliver`,
          { event_id: event.id },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then(() => {
          this.failed_webhook_events = this.failed_webhook_events.filter(
            (e) => e.id !== event.id
          );
          this.$notify(this.$t("api.webhook_redeliver_success"), "", "success", 3000);
          // Visible list emptied but more pages exist → fetch them so the user
          // doesn't lose access to older failures and has to reload the page.
          if (this.failed_webhook_events.length === 0 && this.failedWebhookEventsHasMore) {
            this.loadFailedWebhookEvents();
          }
        })
        .catch((error) => {
          console.error('Error redelivering webhook event:', error);
          const code = error && error.response && error.response?.data && error.response?.data.error;
          let messageKey = "api.webhook_redeliver_failed";
          if (code === "endpoint_disabled") messageKey = "api.webhook_redeliver_endpoint_disabled";
          if (code === "not_failed") messageKey = "api.webhook_redeliver_not_failed";
          this.$notify(this.$t(messageKey), "", "error", 4000);
          // Status drifted on the server — pull the fresh list so the row
          // either disappears (if it's no longer failed) or reappears correctly.
          if (code === "not_failed" || code === "endpoint_disabled") {
            this.loadFailedWebhookEvents();
          }
        })
        .finally(() => {
          this.redeliveringWebhookEventIds = this.redeliveringWebhookEventIds.filter(
            (id) => id !== event.id
          );
        });
    },
    loadWebhookEndpoints() {
      // FT-090: signing_secret живёт только на owner-endpoint (index) — в company
      // payload он default-excluded. Тянем список с секретами и делаем его
      // единственным источником карточек, перезаписывая company.webhook_endpoints.
      // Секрет — привилегированный credential (как api_token, скрытый от guest/partner
      // в панели «API token»): этим ролям не тянем его в браузер вообще.
      // Вызывается и из company-load, и из watcher'а main_company (он приезжает из
      // Vuex асинхронно — см. watcher выше): кто пришёл последним, тот и загрузит.
      // Флаг делает загрузку однократной; при ошибке сбрасывается для ретрая.
      if (this.webhookEndpointsLoaded) return;
      if (!this.isStaff) return;
      if (!(this.main_company && this.main_company.api_access && this.main_company.webhook_access)) return;
      this.webhookEndpointsLoaded = true;
      this.axios
        .get(`/api/v1/webhook_endpoints`, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          const secrets = {};
          (response.data || []).forEach((ep) => {
            if (ep && ep.id && ep.signing_secret) secrets[ep.id] = ep.signing_secret;
          });
          this.webhookSecretsById = secrets;
        })
        .catch(() => {
          this.webhookEndpointsLoaded = false;
        });
    },
    copyWebhookSigningSecret(secret) {
      navigator.clipboard
        .writeText(secret)
        .then(() => this.$notify(this.$t("custom.copy_success"), "", "success", 2000))
        .catch(() => this.$notify(this.$t("custom.copy_error"), "", "error"));
    },
    saveWebhookEndpoint(webhook_endpoint) {
      if (this.isStaff) {
        if (!webhook_endpoint.url || webhook_endpoint.url.length < 5 || webhook_endpoint.subscriptions.length == 0) {
          this.$notify(this.$t("errors.not_enough_data"), "", "warning", 3000);
          return;
        }
        // check url format
        let url = webhook_endpoint.url;
        let url_format = new RegExp(
          "^(https?:\\/\\/)?" + // protocol
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
          "i"
        ); // fragment locator
        if (url != "http://localhost:3000/webhooks") {
          if (!url_format.test(url)) {
            this.$notify(this.$t("errors.url_format"), "", "warning", 3000);
            return;
          }
        }
        this.isLoadingSaveWebhookEndpoint = true;
        this.axios
          .post(
            `/api/v1/webhook_endpoints`,
            {
              webhook_endpoints: {
                url: webhook_endpoint.url,
                enabled: webhook_endpoint.enabled,
                subscriptions: webhook_endpoint.subscriptions,
                created_from_api: webhook_endpoint.created_from_api,
                updated_from_api: webhook_endpoint.updated_from_api,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let index_webhook_endpoint = this.company.webhook_endpoints.findIndex(
              (item) => item === webhook_endpoint
            );
            let company_data = this.company;
            company_data.webhook_endpoints.splice(index_webhook_endpoint, 1, response.data);
            this.$store.commit("setCompany", { company: company_data });
            // FT-090: ответ create несёт signing_secret — кладём в map ($set — реактивность новых ключей)
            if (response.data && response.data.id && response.data.signing_secret) {
              this.$set(this.webhookSecretsById, response.data.id, response.data.signing_secret);
            }
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
            // Обновляем список failed events
            this.loadFailedWebhookEvents();
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingSaveWebhookEndpoint = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateWebhookEndpoint(webhook_endpoint) {
      if (this.isStaff) {
        if (!webhook_endpoint.url || webhook_endpoint.url.length < 5 || webhook_endpoint.subscriptions.length == 0) {
          this.$notify(this.$t("errors.not_enough_data"), "", "warning", 3000);
          return;
        }
        // check url format
        let url = webhook_endpoint.url;
        let url_format = new RegExp(
          "^(https?:\\/\\/)?" + // protocol
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
          "i"
        ); // fragment locator
        if (url != "http://localhost:3000/webhooks") {
          if (!url_format.test(url)) {
            this.$notify(this.$t("errors.url_format"), "", "warning", 3000);
            return;
          }
        }
        this.isLoadingUpdateWebhookEndpoint = true;
        this.axios
          .patch(
            `/api/v1/webhook_endpoints/${webhook_endpoint.id}`,
            {
              webhook_endpoints: {
                url: webhook_endpoint.url,
                enabled: webhook_endpoint.enabled,
                subscriptions: webhook_endpoint.subscriptions,
                created_from_api: webhook_endpoint.created_from_api,
                updated_from_api: webhook_endpoint.updated_from_api,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let index_webhook_endpoint = this.company.webhook_endpoints.findIndex(
              (item) => item.id === webhook_endpoint.id
            );
            let company_data = this.company;
            company_data.webhook_endpoints.splice(index_webhook_endpoint, 1, response.data);
            this.$store.commit("setCompany", { company: company_data });
            // FT-090: ответ update несёт signing_secret — обновляем map
            if (response.data && response.data.id && response.data.signing_secret) {
              this.$set(this.webhookSecretsById, response.data.id, response.data.signing_secret);
            }
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
            // Обновляем список failed events
            this.loadFailedWebhookEvents();
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingUpdateWebhookEndpoint = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    activateWebhookEndpoint(webhook_endpoint) {
      if (this.isStaff) {
        this.isLoadingActivateWebhookEndpoint = true;
        this.axios
          .patch(
            `/api/v1/webhook_endpoints/${webhook_endpoint.id}`,
            {
              webhook_endpoints: {
                enabled: true,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let index_webhook_endpoint = this.company.webhook_endpoints.findIndex(
              (item) => item.id === webhook_endpoint.id
            );
            let company_data = this.company;
            company_data.webhook_endpoints.splice(index_webhook_endpoint, 1, response.data);
            this.$store.commit("setCompany", { company: company_data });
            // FT-090: ответ update несёт signing_secret — обновляем map
            if (response.data && response.data.id && response.data.signing_secret) {
              this.$set(this.webhookSecretsById, response.data.id, response.data.signing_secret);
            }
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingActivateWebhookEndpoint = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deactivateWebhookEndpoint(webhook_endpoint) {
      if (this.isStaff) {
        this.isLoadingDeactivateWebhookEndpoint = true;
        this.axios
          .patch(
            `/api/v1/webhook_endpoints/${webhook_endpoint.id}`,
            {
              webhook_endpoints: {
                enabled: false,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let index_webhook_endpoint = this.company.webhook_endpoints.findIndex(
              (item) => item.id === webhook_endpoint.id
            );
            let company_data = this.company;
            company_data.webhook_endpoints.splice(index_webhook_endpoint, 1, response.data);
            this.$store.commit("setCompany", { company: company_data });
            // FT-090: ответ update несёт signing_secret — обновляем map
            if (response.data && response.data.id && response.data.signing_secret) {
              this.$set(this.webhookSecretsById, response.data.id, response.data.signing_secret);
            }
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingDeactivateWebhookEndpoint = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async deleteWebhookEndpoint(webhook_endpoint) {
      if (this.isStaff) {
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed && webhook_endpoint.id) {
          this.isLoadingDeleteWebhookEndpoint = true;
          this.axios
            .delete(`/api/v1/webhook_endpoints/${webhook_endpoint.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then(() => {
              let index_webhook_endpoint = this.company.webhook_endpoints.findIndex(
                (item) => item.id === webhook_endpoint.id
              );
              let company_data = this.company;
              company_data.webhook_endpoints.splice(index_webhook_endpoint, 1);
              this.$store.commit("setCompany", { company: company_data });
              this.$notify(this.$t("custom.deleted"), "", "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"));
              console.log(error);
            })
            .finally(() => {
              this.isLoadingDeleteWebhookEndpoint = false;
            });
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deleteWebhookEndpointFromStore(webhook_endpoint) {
      let index_webhook_endpoint = this.company.webhook_endpoints.findIndex(
        (item) => item === webhook_endpoint
      );
      let updated_company = this.company;
      updated_company.webhook_endpoints.splice(
        index_webhook_endpoint,
        1
      );
      this.$store.commit("setCompany", { company: updated_company });
    },
    saveCashbox(cashbox) {
      if (this.isStaff) {
        if (!cashbox.name || cashbox.name.length < 3 || !cashbox.currency_id) {
          this.$notify(this.$t("errors.not_enough_data"), "", "warning", 3000);
          return;
        }
        this.isLoadingSaveCashbox = true;
        this.axios
          .post(
            `/api/v1/company_cashboxes`,
            {
              company_cashboxes: {
                name: cashbox.name,
                cash: cashbox.cash,
                cashless: cashbox.cashless,
                is_default: cashbox.is_default,
                is_active: cashbox.is_active,
                currency_id: cashbox.currency_id,
                currency_account: cashbox.currency_account,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingSaveCashbox = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateCashbox(cashbox) {
      if (this.isStaff) {
        if (!cashbox.name || cashbox.name.length < 3 || !cashbox.id) {
          this.$notify(this.$t("errors.not_enough_data"), "", "warning", 3000);
          return;
        }
        this.isLoadingUpdateCashbox = true;
        this.axios
          .patch(
            `/api/v1/company_cashboxes/${cashbox.id}`,
            {
              company_cashboxes: {
                name: cashbox.name,
                is_default: cashbox.is_default,
                is_active: cashbox.is_active,
                currency_account: cashbox.currency_account,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            // Находим индекс кассы в массиве company_cashboxes
            let index = this.company_cashboxes.findIndex(box => box.id === cashbox.id);

            // Создаем копию массива касс
            let updated_cashboxes = [...this.company_cashboxes];

            // Обновляем кассу в массиве
            updated_cashboxes[index] = response.data;

            // Обновляем состояние компании
            let updated_company = { ...this.company };
            updated_company.company_cashboxes = updated_cashboxes;

            this.$store.commit("setCompany", { company: updated_company });
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingUpdateCashbox = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    makeCashboxDefault(cashbox) {
      if (this.isStaff) {
        this.isLoadingMakeCashboxDefault = true;
        this.axios
          .patch(
            `/api/v1/company_cashboxes/${cashbox.id}`,
            {
              company_cashboxes: {
                is_default: true,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            // Обновляем данные в массиве
            let index_cashbox = this.company_cashboxes.findIndex(
              (item) => item.id === cashbox.id
            );
            let updated_company = this.company;
            updated_company.company_cashboxes.splice(
              index_cashbox,
              1,
              response.data
            );
            this.$store.commit("setCompany", { company: updated_company });
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingMakeCashboxDefault = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    activateCashbox(cashbox) {
      if (this.isStaff) {
        this.isLoadingActivateCashbox = true;
        this.axios
          .patch(
            `/api/v1/company_cashboxes/${cashbox.id}`,
            {
              company_cashboxes: {
                is_active: true,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            // Обновляем данные в массиве
            let index_cashbox = this.company_cashboxes.findIndex(
              (item) => item.id === cashbox.id
            );
            let updated_company = this.company;
            updated_company.company_cashboxes.splice(
              index_cashbox,
              1,
              response.data
            );
            this.$store.commit("setCompany", { company: updated_company });
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingActivateCashbox = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deactivateCashbox(cashbox) {
      if (this.isStaff) {
        this.isLoadingDeactivateCashbox = true;
        this.axios
          .patch(
            `/api/v1/company_cashboxes/${cashbox.id}`,
            {
              company_cashboxes: {
                is_active: false,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            // Находим индекс кассы в массиве company_cashboxes
            let index = this.company_cashboxes.findIndex(box => box.id === cashbox.id);

            // Создаем копию массива касс
            let updated_cashboxes = [...this.company_cashboxes];

            // Обновляем кассу в массиве
            updated_cashboxes[index] = response.data;

            // Обновляем состояние компании
            let updated_company = { ...this.company };
            updated_company.company_cashboxes = updated_cashboxes;

            this.$store.commit("setCompany", { company: updated_company });
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingDeactivateCashbox = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async deleteCashbox(cashbox) {
      if (this.isStaff) {
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("companies.delete_cashbox_warning"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed && cashbox.id) {
          this.isLoadingDeleteCashbox = true;
          this.axios
            .delete(`/api/v1/company_cashboxes/${cashbox.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then(() => {
              this.company_cashboxes.splice(
                this.company_cashboxes.indexOf(cashbox),
                1
              );
              let updated_company = this.company;
              updated_company.company_cashboxes = this.company_cashboxes;
              this.$store.commit("setCompany", { company: updated_company });
              this.$notify(this.$t("custom.deleted"), "", "success", 3000);
            })
            .catch((error) => {
              this.isLoadingDeleteCashbox = false;
              if (
                error.response &&
                error.response?.status &&
                error.response?.status == 406
              ) {
                this.setError("", this.$t("errors.cashbox_not_empty"));
                console.log(error);
              } else {
                this.setError(error, this.$t("errors.error"));
                console.log(error);
              }
            })
            .finally(() => {
              this.isLoadingDeleteCashbox = false;
            });
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deleteCashboxFromStore(cashbox) {
      let new_cashboxes = this.company_cashboxes.filter(
        (item) => item.id !== cashbox.id
      );
      let updated_company = this.company;
      updated_company.company_cashboxes = new_cashboxes;
      this.$store.commit("setCompany", { company: updated_company });
    },
    checkCurrencyLength() {
      if (!this.company_currencies || this.company_currencies.length == 0) {
        return this.$t("errors.most_one_currency");
      } else {
        return true;
      }
    },
    nullFunction() {
      return;
    },
    updateCurrencies() {
      if (this.isStaff) {
        // Проверка что в текущей версии есть все валюты которые были, и если какой то нет, то ничего не делать
        let check = true;
        this.company_currencies.forEach((currency) => {
          if (!this.currencies.find((item) => item.id == currency.id)) {
            check = false;
          }
        });
        if (check) {
          if (this.company_currencies && this.company_currencies.length > 0) {
            this.$refs.currencySelect.blur();
            this.isLoadingUpdateCurrencies = true;
            this.axios
              .patch(
                `/api/v1/currencies`,
                {
                  company_currencies: this.company_currencies.map((currency) => {
                    return currency.id;
                  }),
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then(() => {
                this.$notify(this.$t("custom.saved"), "", "success", 3000);
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.error"));
              })
              .finally(() => (this.isLoadingUpdateCurrencies = false));
          } else {
            this.$notify(this.$t("errors.most_one_currency"), "", "warning", 3000);
            // Ставим обратно старые значения
            this.company_currencies = this.company.company_currencies;
          }
        } else {
          return;
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveMessageBookingOn() {
      this.axios
        .patch(
          `/api/v1/company`,
          {
            company: {
              send_start_booking: this.company.send_start_booking,
              send_end_booking: this.company.send_end_booking,
              send_review_reminder: this.company.send_review_reminder,
              send_start_booking_whatsapp:
                this.company.send_start_booking_whatsapp,
              send_end_booking_whatsapp: this.company.send_end_booking_whatsapp,
              send_review_reminder_whatsapp:
                this.company.send_review_reminder_whatsapp,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.$notify(this.$t("custom.saved"), "", "success", 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        });
    },
    async removeDemoContent() {
      let self = this;
      const confirmed = await this.$confirm({
        title: this.$t("custom.you_sure_title"),
        text: this.$t("demo_content.remove_demo_content_text"),
        icon: "mdi-alert-outline",
        iconColor: "warning",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: this.$t("custom.you_sure_yes"),
        confirmButtonColor: "primary",
        cancelButtonText: this.$t("custom.you_sure_no"),
        cancelButtonColor: "grey darken-1",
        useFilledButtons: true,
        maxWidth: 450,
      });
      
      if (confirmed) {
        this.showOverlayRemoveDemo = true;
        this.axios
          .post(`/api/v1/remove_demo_content`,
            {
              company_id: self.$store.getters.getCompany.company.id,
            },
            {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            })
          .then(() => {
            self.$store.commit("setBannerRemoveDemoContent");
            setTimeout(() => {
              self.showOverlayRemoveDemo = false;
              self.$notify(self.$t("custom.deleted"), self.$t("demo_content.remove_demo_content_success"), "success", 3000);
            }, 2000);
          })
          .catch((error) => {
            self.showOverlayRemoveDemo = false;
            self.setError(error, self.$t("errors.error"));
            console.log(error);
          });
      }
    },
    addLocation() {
      let new_location = {
        new: true,
        active: true,
        address: null,
        city: this.company.city,
        email: this.company.email_for_bookings,
        is_airport: false,
        is_city: false,
        is_office: false,
        is_station: false,
        name: null,
        night_price: 0,
        phone_number: null,
        price: 0,
      };
      let company_data = this.company;
      company_data.locations.push(new_location);
      this.$store.commit("setCompany", { company: company_data });
    },
    saveNotificationChannelsConfig() {
      // Если приоритет пуст, пересчитываем из доступных каналов
      if (this.notificationChannelsPriority.length === 0 && this.availableNotificationChannels.length > 0) {
        this.notificationChannelsPriority = this.availableNotificationChannels.map(ch => ch.value);
      }
      const config = {
        mode: this.notificationChannelsMode,
        priority: this.notificationChannelsPriority,
        primary_channel: this.notificationChannelsPrimary,
      };
      this.company.notification_channels_config = config;
      this.saveCompany();
    },
    getChannelName(channel) {
      const names = {
        'whatsapp': 'WhatsApp',
        'max': 'MAX',
        'telegram_green_api': 'Telegram',
      };
      return names[channel] || channel;
    },
    getChannelColor(channel) {
      const colors = {
        'whatsapp': 'green',
        'max': 'blue',
        'telegram_green_api': 'deep-purple',
      };
      return colors[channel] || 'grey';
    },
    moveChannelUp(index) {
      if (index > 0) {
        const arr = [...this.notificationChannelsPriority];
        [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
        this.notificationChannelsPriority = arr;
        this.saveNotificationChannelsConfig();
      }
    },
    moveChannelDown(index) {
      if (index < this.notificationChannelsPriority.length - 1) {
        const arr = [...this.notificationChannelsPriority];
        [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]];
        this.notificationChannelsPriority = arr;
        this.saveNotificationChannelsConfig();
      }
    },
    saveNotificationMessages() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .post(
            `/api/v1/company/booking_message`,
            {
              booking_message: {
                custom_html: this.custom_html_template,
                start_message: this.send_start_booking_text,
                end_message: this.send_end_booking_text,
                start_message_whatsapp: this.send_start_booking_text_whatsapp,
                end_message_whatsapp: this.send_end_booking_text_whatsapp,
                review_email: this.review_email_text,
                review_whatsapp: this.review_whatsapp_text,
                accept_message: this.accept_message_text,
                decline_message: this.decline_message_text,
                accept_whatsapp: this.accept_whatsapp,
                decline_whatsapp: this.decline_whatsapp,
                lang: this.booking_message_selected_locale ? this.booking_message_selected_locale : null,
                periodic_payment_success: this.periodic_payment_success_email_text,
                periodic_payment_success_whatsapp: this.periodic_payment_success_whatsapp_text,
                periodic_payment_bad: this.periodic_payment_bad_email_text,
                periodic_payment_bad_whatsapp: this.periodic_payment_bad_whatsapp_text,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveSendReviewMessage() {
      if (this.isStaff) {
        if (
          this.company.send_review_reminder &&
          (this.review_email_text == "" || this.review_email_text == null)
        ) {
          this.$notify(this.$t("custom.no_data"), "", "warning", 3000);
          return;
        }
        if (
          this.company.send_end_booking &&
          (this.send_end_booking_text == "" ||
            this.send_end_booking_text == null)
        ) {
          this.$notify(this.$t("custom.no_data"), "", "warning", 3000);
          return;
        }
        this.isLoading = true;
        this.axios
          .post(
            `/api/v1/company/booking_message`,
            {
              booking_message: {
                start_message: this.send_start_booking_text,
                end_message: this.send_end_booking_text,
                start_message_whatsapp: this.send_start_booking_text_whatsapp,
                end_message_whatsapp: this.send_end_booking_text_whatsapp,
                review_email: this.review_email_text,
                review_whatsapp: this.review_whatsapp_text,
                accept_message: this.accept_message_text,
                decline_message: this.decline_message_text,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    getBookingMessages() {
      this.axios
        .get(`/api/v1/company/booking_messages_with_lang/${this.booking_message_selected_locale}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          if (response.data && response.data.custom_html) {
            this.custom_html_template = response.data.custom_html;
          } else {
            if (response.data && this.booking_message_selected_locale) {
              this.custom_html_template = true;
            } else {
              this.custom_html_template = false;
            }
          }
          if (
            (response.data && response.data.start_message) ||
            (response.data && response.data.start_message_whatsapp)
          ) {
            this.send_start_booking_text = response.data.start_message;
            this.send_start_booking_text_whatsapp =
              response.data.start_message_whatsapp;
          } else {
            this.send_start_booking_text = null;
            this.send_start_booking_text_whatsapp = null;
          }
          if (
            (response.data && response.data.end_message) ||
            (response.data && response.data.end_message_whatsapp)
          ) {
            this.send_end_booking_text = response.data.end_message;
            this.send_end_booking_text_whatsapp =
              response.data.end_message_whatsapp;
          } else {
            this.send_end_booking_text = null;
            this.send_end_booking_text_whatsapp = null;
          }
          if (response.data && response.data.review_email) {
            this.review_email_text = response.data.review_email;
          } else {
            this.review_email_text = null;
          }
          if (response.data && response.data.review_whatsapp) {
            this.review_whatsapp_text = response.data.review_whatsapp;
          } else {
            this.review_whatsapp_text = null;
          }
          if (response.data && response.data.accept_message) {
            this.accept_message_text = response.data.accept_message;
          } else {
            this.accept_message_text = null;
          }
          if (response.data && response.data.decline_message) {
            this.decline_message_text = response.data.decline_message;
          } else {
            this.decline_message_text = null;
          }
          if (response.data && response.data.accept_whatsapp) {
            this.accept_whatsapp = response.data.accept_whatsapp;
          } else {
            this.accept_whatsapp = null;
          }
          if (response.data && response.data.decline_whatsapp) {
            this.decline_whatsapp = response.data.decline_whatsapp;
          } else {
            this.decline_whatsapp = null;
          }
          if (response.data && response.data.periodic_payment_success) {
            this.periodic_payment_success_email_text = response.data.periodic_payment_success;
          } else {
            this.periodic_payment_success_email_text = null;
          }
          if (response.data && response.data.periodic_payment_success_whatsapp) {
            this.periodic_payment_success_whatsapp_text = response.data.periodic_payment_success_whatsapp;
          } else {
            this.periodic_payment_success_whatsapp_text = null;
          }
          if (response.data && response.data.periodic_payment_bad) {
            this.periodic_payment_bad_email_text = response.data.periodic_payment_bad;
          } else {
            this.periodic_payment_bad_email_text = null;
          }
          if (response.data && response.data.periodic_payment_bad_whatsapp) {
            this.periodic_payment_bad_whatsapp_text = response.data.periodic_payment_bad_whatsapp;
          } else {
            this.periodic_payment_bad_whatsapp_text = null;
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
    saveTinkoffSettings() {
      if (this.isManagerPlus) {
        if (this.tinkoff_enabled) {
          if (
            this.tinkoff_terminal_key == "" ||
            this.tinkoff_password == "" ||
            this.tinkoff_terminal_key == null ||
            this.tinkoff_password == null ||
            this.tinkoff_terminal_key.length < 5 ||
            this.tinkoff_password.length < 5
          ) {
            this.$notify(this.$t("custom.no_data"), "", "warning", 3000);
            return;
          }
        }
        this.isLoading = true;
        this.axios
          .post(
            `/api/v1/integrations/update_tinkoff`,
            {
              tinkoff: {
                tinkoff_enabled: this.tinkoff_enabled,
                tinkoff_terminal_key: this.tinkoff_terminal_key,
                tinkoff_password: this.tinkoff_password,
                taxation: this.tinkoff_taxation,
                ffd_version: this.tinkoff_ffd_version,
                vat: this.tinkoff_vat,
                tarrifs_link: this.tinkoff_tarrifs_link,
                agreement_link: this.tinkoff_agreement_link,
                privacy_link: this.tinkoff_privacy_link
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveYandexPaySettings() {
      if (!this.isManagerPlus) {
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }

      if (this.yandex_pay_enabled) {
        if (
          !this.yandex_pay_api_key ||
          this.yandex_pay_api_key.length < 10 ||
          !this.yandex_pay_merchant_id ||
          this.yandex_pay_merchant_id.length < 10 ||
          !this.yandex_pay_redirect_success_url ||
          !this.yandex_pay_redirect_error_url ||
          !this.yandex_pay_redirect_abort_url
        ) {
          this.$notify(this.$t("custom.no_data"), "", "warning", 3000);
          return;
        }
      }

      this.isSavingYandexPay = true;
      this.axios
        .patch(
          `/api/v1/integrations/yandex_pay`,
          {
            yandex_pay: {
              yandex_pay_enabled: this.yandex_pay_enabled,
              yandex_pay_api_key: this.yandex_pay_api_key,
              yandex_pay_merchant_id: this.yandex_pay_merchant_id,
              yandex_pay_use_sandbox: this.yandex_pay_use_sandbox,
              yandex_pay_redirect_success_url: this.yandex_pay_redirect_success_url,
              yandex_pay_redirect_error_url: this.yandex_pay_redirect_error_url,
              yandex_pay_redirect_abort_url: this.yandex_pay_redirect_abort_url,
              yandex_pay_webhook_secret_key_id: this.yandex_pay_webhook_secret_key_id,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.$notify(this.$t("custom.saved"), "", "success", 3000);
          if (this.company) {
            this.company.yandex_pay_enabled = this.yandex_pay_enabled;
            this.company.yandex_pay_api_key = this.yandex_pay_api_key;
            this.company.yandex_pay_merchant_id = this.yandex_pay_merchant_id;
            this.company.yandex_pay_use_sandbox = this.yandex_pay_use_sandbox;
            this.company.yandex_pay_redirect_success_url = this.yandex_pay_redirect_success_url;
            this.company.yandex_pay_redirect_error_url = this.yandex_pay_redirect_error_url;
            this.company.yandex_pay_redirect_abort_url = this.yandex_pay_redirect_abort_url;
            this.company.yandex_pay_webhook_secret_key_id = this.yandex_pay_webhook_secret_key_id;
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isSavingYandexPay = false));
    },
    saveStripeSettings() {
      if (!this.isManagerPlus) {
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      if (this.stripe_enabled) {
        if (
          !this.stripe_publishable_key ||
          !this.stripe_secret_key ||
          !this.stripe_webhook_secret ||
          !this.stripe_redirect_success_url ||
          !this.stripe_redirect_cancel_url
        ) {
          this.$notify(this.$t("errors.warning_title"), this.$t("stripe_payment.not_configured_text"), "warning", 3000);
          return;
        }
      }
      this.isSavingStripe = true;
      this.axios
        .patch(
          `/api/v1/integrations/stripe_payments`,
          {
            stripe: {
              stripe_enabled: this.stripe_enabled,
              stripe_publishable_key: this.stripe_publishable_key,
              stripe_secret_key: this.stripe_secret_key,
              stripe_webhook_secret: this.stripe_webhook_secret,
              stripe_redirect_success_url: this.stripe_redirect_success_url,
              stripe_redirect_cancel_url: this.stripe_redirect_cancel_url,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.$notify(this.$t("custom.saved"), "", "success", 3000);
          if (this.company) {
            this.company.stripe_enabled = this.stripe_enabled;
            this.company.stripe_publishable_key = this.stripe_publishable_key;
            this.company.stripe_secret_key = this.stripe_secret_key;
            this.company.stripe_webhook_secret = this.stripe_webhook_secret;
            this.company.stripe_redirect_success_url = this.stripe_redirect_success_url;
            this.company.stripe_redirect_cancel_url = this.stripe_redirect_cancel_url;
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isSavingStripe = false));
    },
    toggleFinesMonitoring(value) {
      this.isSavingFinesProvider = true;
      const newValue = value ? "shtrafus" : null;
      this.axios
        .patch(
          `/api/v1/company`,
          { company: { fines_provider: newValue } },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then((response) => {
          this.$store.commit("setCompany", { company: response.data });
          this.$notify(
            value ? this.$t("fines.fines_monitoring_enabled") : this.$t("fines.fines_monitoring_disabled"),
            "",
            "success"
          );
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isSavingFinesProvider = false));
    },
    saveStarlineSettings() {
      this.isSavingStarline = true;
      this.axios
        .patch(
          `/api/v1/company`,
          {
            company: {
              starline_app_id: this.company.starline_app_id,
              starline_secret: this.company.starline_secret,
              starline_login: this.company.starline_login,
              starline_password: this.company.starline_password,
              starline_auto_mileage_sync: this.company.starline_auto_mileage_sync,
              starline_mileage_threshold: this.company.starline_mileage_threshold,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.$notify(this.$t("starline.settings_saved"), "", "success");
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isSavingStarline = false));
    },
    saveWialonSettings() {
      this.isSavingWialon = true;
      const wialonHost = this.wialonHostSelection === 'custom' ? this.customWialonHost : this.wialonHostSelection;
      this.axios
        .patch(
          `/api/v1/company`,
          {
            company: {
              wialon_token: this.company.wialon_token,
              wialon_host: wialonHost,
              wialon_auto_mileage_sync: this.company.wialon_auto_mileage_sync,
              wialon_mileage_threshold: this.company.wialon_mileage_threshold
            }
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        )
        .then(() => {
          this.$notify(this.$t("wialon.settings_saved"), "", "success");
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isSavingWialon = false));
    },
    saveAutofonSettings() {
      this.isSavingAutofon = true;
      this.axios
        .patch(
          `/api/v1/company`,
          {
            company: {
              autofon_api_key: this.company.autofon_api_key,
              autofon_password: this.company.autofon_password
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.$notify(this.$t("autofon.settings_saved"), "", "success");
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isSavingAutofon = false));
    },
    saveTraccarSettings() {
      this.isSavingTraccar = true;
      this.axios
        .patch(
          `/api/v1/company`,
          {
            company: {
              traccar_server_url: this.company.traccar_server_url
            }
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        )
        .then(() => {
          this.$store.commit("setCompany", {
            company: this.company
          });
          this.$notify(this.$t("custom.saved"), "", "success", 3000);
        })
        .catch(error => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isSavingTraccar = false));
    },
    periodsFormat(periods) {
      let self = this;
      if (periods) {
        let result = [];
        periods.forEach((period) => {
          result.push(` ${period} ${self.$t("companies.days")}`);
        });
        return result.toString();
      }
    },
    updateDocxTemplate(docx_template) {
      if (this.isManagerPlus) {
        if (docx_template.name == "" || docx_template.name == null || docx_template.id == undefined || docx_template.id == null) {
          return;
        }
        this.isLoadingUpdateDocxTemplate = true;
        this.updated_docx_template = docx_template;
        this.axios
          .patch(
            `/api/v1/docx_templates/${docx_template.id}`,
            {
              docx_templates: {
                id: docx_template.id,
                name: docx_template.name,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.docx_templates[this.docx_templates.findIndex((docx_template) => docx_template.id == response.data.id)] = response.data;
            this.$notify(this.$t("custom.saved"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoadingUpdateDocxTemplate = false, this.updated_docx_template = null));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    addNewDocxTemplate() {
      const defaultName = `${this.$t("companies.docx_template")} ${this.docx_templates.length + 1}`;
      this.docx_templates.push({ name: defaultName, url: '' });
      this.$notify(this.$t("custom.added"), "", "success");
    },
    moveDocxTemplate(docx_template, index, direction) {
      if (this.isManagerPlus) {
        this.isLoadingMoveDocxTemplate = true;
        if (direction === "up") {
          this.moved_up_docx_template = docx_template.id;
        } else {
          this.moved_down_docx_template = docx_template.id;
        }

        const endpoint = direction === "up" ? "move_up" : "move_down";

        this.axios
          .patch(`/api/v1/docx_templates/${docx_template.id}/${endpoint}`, {}, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.docx_templates = response.data;
            this.$notify(this.$t("custom.saved"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoadingMoveDocxTemplate = false, this.moved_up_docx_template = null, this.moved_down_docx_template = null));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deleteDocxTemplate(docx_template, index) {
      if (docx_template.id == undefined || docx_template.id == null) {
        this.docx_templates.splice(index, 1);
        return;
      }
      if (this.isManagerPlus) {
        this.deleted_docx_template = docx_template;
        this.isLoadingDeleteDocxTemplate = true;
        this.axios
          .delete(`/api/v1/docx_templates/${docx_template.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then(() => {
            this.docx_templates.splice(index, 1);
            this.$notify(this.$t("custom.deleted"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoadingDeleteDocxTemplate = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    addClientSource() {
      this.clients_sources.push({ value: "" });
    },
    deleteClientSource(index) {
      this.clients_sources.splice(index, 1);
    },
    async createWhatsappInstance() {
      if (this.main_company.balance > 0) {
        const result = await this.$confirm({
          title: this.$t("companies.whatsapp_create_instance_warning"),
          text: this.$t("companies.whatsapp_create_instance_warning_text"),
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
          maxWidth: 600,
        });

        if (result) {
          this.isLoadingCreateWhatsappInstance = true;
          this.axios
            .post(
              "/api/v1/create_whatsapp_instance",
              {
                company_id: this.company.id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken
                }
              }
            )
            .then(() => {
              setTimeout(() => {
                this.isLoadingCreateWhatsappInstance = false;
                this.$notify(this.$t('companies.whatsapp_create_instance_success'), this.$t('companies.whatsapp_create_instance_success_text'), 'info', 5000);
                this.refreshCompanyData();
              }, 30000);
            })
            .catch((error) => {
              this.isLoadingCreateWhatsappInstance = false;
              this.setError(error, this.$t("errors.error"));
            });
        }
      } else {
        this.$notify(this.$t('companies.whatsapp_create_instance_error'), this.$t('companies.whatsapp_create_instance_no_balance'), 'warning');
      }
    },
    async deleteWhatsappInstance() {
      const result = await this.$confirm({
        title: this.$t("companies.whatsapp_delete_instance_warning"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 700,
      });

      if (result) {
        this.isLoadingDeleteWhatsappInstance = true;
        this.axios
          .post(
            "/api/v1/delete_whatsapp_instance",
            {
              company_id: this.company.id,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken
              }
            }
          )
          .then(() => {
            // set timeout for wait until instance will be deleted
            setTimeout(() => {
              this.isLoadingDeleteWhatsappInstance = false;
              this.$notify(this.$t('companies.whatsapp_delete_instance_success'), '', 'success');
              // Обновляем данные компании
              this.refreshCompanyData();
            }, 5000);
          })
          .catch((error) => {
            this.isLoadingDeleteWhatsappInstance = false;
            this.setError(error, this.$t("errors.error"));
          });
      }
    },
    // FT-149 REQ-02: авторизация WhatsApp внутри приложения — код по номеру (основной
    // путь) и QR (альтернатива); внешняя страница провайдера через window.open больше не открывается.
    authoriseWhatsapp() {
      if (!(this.company.chat_api_instance && this.company.chat_api_instance.length > 0 && this.company.chat_api_token && this.company.chat_api_token.length > 0)) {
        this.$notify(this.$t("errors.error"), this.$t("errors.whatsapp_instance_creating"), "warning");
        return;
      }
      this.whatsappAuthEpoch += 1;
      this.whatsappAuthDialog = true;
      this.whatsappAuthTab = 'code';
      this.whatsappAuthPhone = this.whatsappAuthPhone || String(this.company.phone || '').replace(/\D/g, '');
      this.whatsappAuthCode = null;
      this.whatsappAuthCodeIssuedAt = null;
      this.whatsappAuthState = null;
      this.whatsappAuthError = '';
      this.whatsappQrCode = null;
      this.whatsappAuthNetErrors = 0;
      this.whatsappAuthTick();
      this.startWhatsappAuthPolling();
    },
    closeWhatsappAuthDialog() {
      this.whatsappAuthEpoch += 1; // всё, что сейчас летит, относится к прошлому сеансу
      this.whatsappAuthDialog = false;
      this.whatsappAuthCode = null;
      this.whatsappAuthCodeIssuedAt = null;
      this.whatsappAuthState = null;
      this.whatsappAuthError = '';
      this.whatsappQrCode = null;
      this.whatsappAuthNetErrors = 0;
      this.stopWhatsappAuthPolling();
    },
    whatsappAuthHeaders() {
      return { headers: { Authorization: this.$store.getters.getAuthToken } };
    },
    // Один тик на состояние и (на вкладке QR) на картинку — каждые 5 секунд (DEC-07).
    startWhatsappAuthPolling() {
      this.stopWhatsappAuthPolling();
      this.whatsappAuthInterval = this.$options.timers.setInterval(() => {
        if (!this.whatsappAuthDialog) {
          this.stopWhatsappAuthPolling();
          return;
        }
        this.whatsappAuthTick();
      }, 5000);
    },
    stopWhatsappAuthPolling() {
      if (this.whatsappAuthInterval) {
        this.$options.timers.clearInterval(this.whatsappAuthInterval);
        this.whatsappAuthInterval = null;
      }
    },
    // Код провайдера живёт ≈2,5 минуты — по истечении показываем «Новый код» (Flow 2).
    whatsappAuthCodeExpired() {
      if (!this.whatsappAuthCodeIssuedAt) return false;
      return this.$options.timers.now() - this.whatsappAuthCodeIssuedAt > 150000;
    },
    whatsappAuthCodeSecondsLeft() {
      if (!this.whatsappAuthCodeIssuedAt) return 0;
      return Math.max(0, Math.ceil((150000 - (this.$options.timers.now() - this.whatsappAuthCodeIssuedAt)) / 1000));
    },
    async whatsappAuthTick() {
      // Срок кода считается по now() без отдельного таймера: реактивная метка тика
      // заставляет шаблон пересчитать «действует ещё N с» и истечение каждые 5 с.
      this.whatsappAuthTickAt = this.$options.timers.now();
      const epoch = this.whatsappAuthEpoch;
      try {
        const stateResponse = await this.axios.post("/api/v1/whatsapp_get_state", { company_id: this.company.id }, this.whatsappAuthHeaders());
        // Диалог могли закрыть или открыть заново, пока летел ответ: уведомление и
        // перечитывание компании на чужом сеансе — лишний шум и лишний запрос экрана.
        if (epoch !== this.whatsappAuthEpoch) return;
        this.whatsappAuthNetErrors = 0;
        const state = stateResponse.data.stateInstance;
        this.whatsappAuthState = state;
        if (state === 'authorized') {
          this.$notify(this.$t("companies.whatsapp_authorise_success"), "", "success");
          this.closeWhatsappAuthDialog();
          this.refreshCompanyData();
          return;
        }
        if (state === 'starting') return; // тик продолжается, код и QR не запрашиваются
        if (['blocked', 'suspended', 'yellowCard', 'sleepMode'].includes(state)) {
          this.stopWhatsappAuthPolling();
          return;
        }
        if (this.whatsappAuthTab === 'qr') await this.fetchWhatsappQr();
      } catch (error) {
        if (epoch !== this.whatsappAuthEpoch) return;
        this.whatsappAuthNetErrors += 1;
        if (this.whatsappAuthNetErrors >= 3) {
          this.whatsappAuthError = this.$t("companies.whatsapp_auth_network_error");
          this.stopWhatsappAuthPolling();
        }
      }
    },
    async fetchWhatsappQr() {
      const epoch = this.whatsappAuthEpoch;
      this.isLoadingWhatsappAuth = !this.whatsappQrCode;
      try {
        const qrResponse = await this.axios.post("/api/v1/whatsapp_get_qr", { company_id: this.company.id }, this.whatsappAuthHeaders());
        if (epoch !== this.whatsappAuthEpoch) return;
        const { type, message } = qrResponse.data;
        if (type === "qrCode" && message) {
          this.whatsappQrCode = message;
          this.whatsappAuthError = '';
        } else if (type === "alreadyLogged") {
          this.$notify(this.$t("companies.whatsapp_authorise_success"), "", "success");
          this.closeWhatsappAuthDialog();
          this.refreshCompanyData();
        } else if (type === "passkeyRequired") {
          this.whatsappAuthTab = 'code';
          this.whatsappAuthError = this.$t("companies.whatsapp_auth_passkey");
        } else if (type === "error" && message && message.toLowerCase().includes("log out")) {
          this.whatsappQrCode = null;
          this.whatsappAuthError = this.$t("companies.whatsapp_need_logout");
        } else {
          this.whatsappQrCode = null;
          this.whatsappAuthError = message || this.$t("companies.whatsapp_auth_error");
        }
      } catch (error) {
        if (epoch !== this.whatsappAuthEpoch) return;
        this.whatsappQrCode = null;
        this.whatsappAuthError = this.$t("companies.whatsapp_auth_error");
      } finally {
        this.isLoadingWhatsappAuth = false;
      }
    },
    // Код по номеру: провайдер отдаёт его до 30 с — клиентский таймаут 45 с (CON-05), не глобальные 30.
    async requestWhatsappAuthCode() {
      const phone = String(this.whatsappAuthPhone || '').replace(/\D/g, '');
      if (!phone) return;
      const epoch = this.whatsappAuthEpoch;
      this.isLoadingWhatsappAuth = true;
      this.whatsappAuthError = '';
      this.whatsappAuthCode = null;
      try {
        const response = await this.axios.post(
          "/api/v1/whatsapp_get_authorization_code",
          { company_id: this.company.id, phone_number: phone },
          Object.assign({ timeout: 45000 }, this.whatsappAuthHeaders())
        );
        if (epoch !== this.whatsappAuthEpoch) return;
        this.whatsappAuthCode = response.data.code;
        this.whatsappAuthCodeIssuedAt = this.$options.timers.now();
      } catch (error) {
        if (epoch !== this.whatsappAuthEpoch) return;
        // На экран уходит только текст, который назвал провайдер. Наши машинные
        // коды (code_unavailable, provider_timeout, Bad data) — диагностика: их
        // печать была бы английской строкой мимо локализации.
        const data = error && error.response && error.response.data;
        this.whatsappAuthError = (data && data.provider_reason) || this.$t("companies.whatsapp_auth_error");
      } finally {
        this.isLoadingWhatsappAuth = false;
      }
    },
    async createMaxInstance() {
      if (this.main_company.balance > 0) {
        const result = await this.$confirm({
          title: this.$t("companies.max_create_instance_warning"),
          text: this.$t("companies.max_create_instance_warning_text"),
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
          maxWidth: 600,
        });
        
        if (result) {
          this.isLoadingCreateMaxInstance = true;
          this.axios
            .post(
              "/api/v1/create_max_instance",
              {
                company_id: this.company.id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken
                },
              }
            )
            .then(() => {
              // set timeout for wait until instance will be created
              setTimeout(() => {
                this.isLoadingCreateMaxInstance = false;
                this.$notify(this.$t('companies.max_create_instance_success'), this.$t('companies.max_create_instance_success_text'), 'info', 5000);
                // Обновляем данные компании
                this.refreshCompanyData();
              }, 30000);
            })
            .catch((error) => {
              this.isLoadingCreateMaxInstance = false;
              this.setError(error, this.$t("errors.error"));
            });
        }
      } else {
        this.$notify(this.$t('companies.max_create_instance_error'), this.$t('companies.max_create_instance_no_balance'), 'warning');
      }
    },
    async deleteMaxInstance() {
      const result = await this.$confirm({
        title: this.$t("companies.max_delete_instance_warning"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });
      
      if (result) {
        this.isLoadingDeleteMaxInstance = true;
        this.axios
          .post(
            "/api/v1/delete_max_instance",
            {
              company_id: this.company.id,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken
              },
            }
          )
          .then(() => {
            // set timeout for wait until instance will be deleted
            setTimeout(() => {
              this.isLoadingDeleteMaxInstance = false;
              this.$notify(this.$t('companies.max_delete_instance_success'), '', 'success');
              // Обновляем данные компании
              this.refreshCompanyData();
            }, 5000);
          })
          .catch((error) => {
            this.isLoadingDeleteMaxInstance = false;
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          });
      }
    },
    async authoriseMax() {
      if (!(this.company.max_instance && this.company.max_instance.length > 0 && this.company.max_token && this.company.max_token.length > 0)) {
        this.$notify(this.$t("errors.error"), this.$t("errors.max_instance_creating"), "warning");
        return;
      }
      
      // Проверяем состояние инстанса перед авторизацией
      this.isLoadingAuthoriseMax = true;
      
      try {
        const stateResponse = await this.axios.post(
          "/api/v1/max_get_state",
          { company_id: this.company.id },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        );
        
        const state = stateResponse.data.stateInstance;
        
        // Проверяем состояние и показываем соответствующие сообщения
        if (state === "authorized") {
          this.$notify(this.$t("companies.max_already_authorized"), "", "info");
          this.isLoadingAuthoriseMax = false;
          return;
        } else if (state === "blocked") {
          this.$notify(this.$t("errors.error"), this.$t("companies.max_blocked"), "error");
          this.isLoadingAuthoriseMax = false;
          return;
        } else if (state === "starting") {
          this.$notify(this.$t("companies.max_starting"), this.$t("companies.max_starting_text"), "warning");
          this.isLoadingAuthoriseMax = false;
          return;
        } else if (state === "suspended") {
          this.$notify(this.$t("companies.max_suspended"), this.$t("companies.max_suspended_text"), "warning");
          this.isLoadingAuthoriseMax = false;
          return;
        } else if (state === "pendingPassword") {
          // 2FA — нужен пароль после QR
          this.isLoadingAuthoriseMax = false;
          this.maxAuthDialog = true;
          this.maxAuthStep = 'pendingPassword';
          return;
        }

        // Если состояние notAuthorized - открываем диалог с QR-кодом
        this.isLoadingAuthoriseMax = false;
        this.maxAuthDialog = true;
        this.maxAuthStep = 'qr';
        this.maxQrCode = null;
        this.maxQrError = '';

        // Запускаем получение QR-кода
        await this.fetchMaxQrCode();
        
        // Запускаем периодическое обновление QR-кода (каждые 5 секунд согласно API)
        this.startMaxQrRefresh();
      } catch (error) {
        console.error('Error checking MAX state:', error);
        this.$notify(this.$t("errors.error"), this.$t("companies.max_state_check_error"), "error");
        this.isLoadingAuthoriseMax = false;
      }
    },
    
    closeMaxAuthDialog() {
      this.maxAuthDialog = false;
      this.maxQrCode = null;
      this.maxQrError = '';
      this.maxAuthStep = 'qr';
      this.maxAuthPassword = '';
      this.maxPasswordError = '';
      this.stopMaxQrRefresh();
    },
    
    async fetchMaxQrCode() {
      this.isLoadingMaxQr = true;
      this.maxQrError = '';

      try {
        // Сначала проверяем состояние — может быть pendingPassword
        const stateResponse = await this.axios.post(
          "/api/v1/max_get_state",
          { company_id: this.company.id },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        );
        const state = stateResponse.data.stateInstance;
        if (state === 'authorized') {
          this.$notify(this.$t("companies.max_authorise_success"), "", "success");
          this.closeMaxAuthDialog();
          this.refreshCompanyData();
          return;
        }
        if (state === 'pendingPassword') {
          this.maxAuthStep = 'pendingPassword';
          this.isLoadingMaxQr = false;
          return;
        }

        const qrResponse = await this.axios.post(
          "/api/v1/max_get_qr",
          { company_id: this.company.id },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        );

        const { type, message } = qrResponse.data;

        if (type === "qrCode") {
          this.maxQrCode = message;
        } else if (type === "alreadyLogged") {
          this.$notify(this.$t("companies.max_authorise_success"), "", "success");
          this.closeMaxAuthDialog();
          setTimeout(() => {
            this.refreshCompanyData();
          }, 2000);
        } else if (type === "error") {
          if (message && message.includes("log out")) {
            this.maxQrError = this.$t("companies.max_need_logout");
          } else {
            this.maxQrError = message || this.$t("companies.max_qr_error");
          }
        }

        this.isLoadingMaxQr = false;
      } catch (error) {
        console.error('Error fetching MAX QR code:', error);
        this.maxQrError = this.$t("companies.max_qr_error");
        this.isLoadingMaxQr = false;
      }
    },
    
    startMaxQrRefresh() {
      // Останавливаем предыдущий интервал если был
      this.stopMaxQrRefresh();
      
      // FT-149 REQ-01: QR MAX обновляется каждые 5 секунд (документация: «запрашивать новый каждые 5 секунд»)
      this.maxQrRefreshInterval = this.$options.timers.setInterval(async () => {
        if (!this.maxAuthDialog) {
          this.stopMaxQrRefresh();
          return;
        }

        try {
          // Проверяем состояние — может перейти в pendingPassword или authorized
          const stateResponse = await this.axios.post(
            "/api/v1/max_get_state",
            { company_id: this.company.id },
            { headers: { Authorization: this.$store.getters.getAuthToken } }
          );
          const state = stateResponse.data.stateInstance;
          if (state === 'authorized') {
            this.$notify(this.$t("companies.max_authorise_success"), "", "success");
            this.closeMaxAuthDialog();
            this.refreshCompanyData();
            return;
          }
          if (state === 'pendingPassword') {
            this.maxAuthStep = 'pendingPassword';
            this.stopMaxQrRefresh();
            return;
          }

          // Обновляем QR-код если ещё на шаге QR
          if (this.maxAuthStep === 'qr') {
            const qrResponse = await this.axios.post(
              "/api/v1/max_get_qr",
              { company_id: this.company.id },
              { headers: { Authorization: this.$store.getters.getAuthToken } }
            );

            const { type, message } = qrResponse.data;

            if (type === "qrCode") {
              this.maxQrCode = message;
            } else if (type === "alreadyLogged") {
              this.$notify(this.$t("companies.max_authorise_success"), "", "success");
              this.closeMaxAuthDialog();
              setTimeout(() => {
                this.refreshCompanyData();
              }, 2000);
            }
          }
        } catch (error) {
          console.error('Error refreshing MAX QR code:', error);
        }
      }, 5000);
    },
    
    stopMaxQrRefresh() {
      if (this.maxQrRefreshInterval) {
        this.$options.timers.clearInterval(this.maxQrRefreshInterval);
        this.maxQrRefreshInterval = null;
      }
    },
    async submitMaxAuthPassword() {
      this.isLoadingMaxPassword = true;
      this.maxPasswordError = '';
      try {
        await this.axios.post(
          "/api/v1/max_send_authorization_password",
          { company_id: this.company.id, password: this.maxAuthPassword },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        );
        // Проверяем состояние с двумя попытками (5с и 15с)
        const checkStateAfterPassword = async (attempt) => {
          try {
            const stateResponse = await this.axios.post(
              "/api/v1/max_get_state",
              { company_id: this.company.id },
              { headers: { Authorization: this.$store.getters.getAuthToken } }
            );
            const state = stateResponse.data.stateInstance;
            if (state === 'authorized') {
              this.$notify(this.$t("companies.max_authorise_success"), "", "success");
              this.closeMaxAuthDialog();
              this.refreshCompanyData();
              this.isLoadingMaxPassword = false;
              return;
            }
            if (attempt < 2) {
              setTimeout(() => checkStateAfterPassword(attempt + 1), 10000);
              return;
            }
            // После 2-й попытки — показываем ошибку
            this.maxPasswordError = this.$t("companies.max_password_error");
          } catch (e) {
            console.error('Error checking state after password:', e);
          }
          this.isLoadingMaxPassword = false;
        };
        setTimeout(() => checkStateAfterPassword(1), 5000);
      } catch (error) {
        console.error('Error sending MAX auth password:', error);
        this.maxPasswordError = this.$t("companies.max_password_error");
        this.isLoadingMaxPassword = false;
      }
    },
    getMaxStateColor(state) {
      const stateColors = {
        'authorized': 'success',
        'notAuthorized': 'warning',
        'pendingPassword': 'deep-purple',
        'starting': 'info',
        'blocked': 'error',
        'suspended': 'orange',
        'not_exists': 'grey'
      };
      return stateColors[state] || 'grey';
    },
    getMaxStateText(state) {
      const translationKey = `companies.max_state_${state}`;
      return this.$t(translationKey) !== translationKey ? this.$t(translationKey) : state;
    },
    getWhatsappStateColor(state) {
      const stateColors = {
        'authorized': 'success',
        'notAuthorized': 'warning',
        'starting': 'info',
        'blocked': 'error',
        'sleepMode': 'grey',
        'yellowCard': 'orange',
        'suspended': 'orange',
        'not_exists': 'grey'
      };
      return stateColors[state] || 'grey';
    },
    getWhatsappStateText(state) {
      const translationKey = `companies.whatsapp_state_${state}`;
      return this.$t(translationKey) !== translationKey ? this.$t(translationKey) : state;
    },
    formatWhatsappSuspendedUntil(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    async checkWhatsappState() {
      this.isLoadingWhatsappActions = true;
      try {
        const response = await this.axios.post(
          `/api/v1/whatsapp_get_state`,
          {
            company_id: this.company.id
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        );

        if (response.status === 200) {
          this.$notify(this.$t("companies.whatsapp_check_state_success"), `${this.$t("companies.whatsapp_state")}: ${this.getWhatsappStateText(response.data.stateInstance)}`, "success");
          this.refreshCompanyData();
        }
      } catch (error) {
        console.error('WhatsApp check state error:', error);
        this.$notify(this.$t("errors.error"), error.response?.data?.error || "Ошибка проверки состояния", "error");
      } finally {
        this.isLoadingWhatsappActions = false;
      }
    },
    async rebootWhatsapp() {
      const result = await this.$confirm({
        title: this.$t("companies.whatsapp_reboot_warning"),
        text: this.$t("companies.whatsapp_reboot_warning_text"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });

      if (result) {
        this.isLoadingWhatsappActions = true;
        try {
          const response = await this.axios.post(
            `/api/v1/whatsapp_reboot`,
            {
              company_id: this.company.id
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          );

          if (response.status === 200) {
            this.$notify(this.$t("companies.whatsapp_reboot_success"), "", "success");
            setTimeout(() => {
              this.refreshCompanyData();
            }, 2000);
          }
        } catch (error) {
          console.error('WhatsApp reboot error:', error);
          this.$notify(this.$t("errors.error"), error.response?.data?.error || "Ошибка перезапуска", "error");
        } finally {
          this.isLoadingWhatsappActions = false;
        }
      }
    },
    async logoutWhatsapp() {
      const result = await this.$confirm({
        title: this.$t("companies.whatsapp_logout_warning"),
        text: this.$t("companies.whatsapp_logout_warning_text"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });

      if (result) {
        this.isLoadingWhatsappActions = true;
        try {
          const response = await this.axios.post(
            `/api/v1/whatsapp_logout`,
            {
              company_id: this.company.id
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          );

          if (response.status === 200) {
            this.$notify(this.$t("companies.whatsapp_logout_success"), "", "success");
            this.refreshCompanyData();
          }
        } catch (error) {
          console.error('WhatsApp logout error:', error);
          this.$notify(this.$t("errors.error"), error.response?.data?.error || "Ошибка разлогирования", "error");
        } finally {
          this.isLoadingWhatsappActions = false;
        }
      }
    },
    async checkMaxState() {
      this.isLoadingMaxActions = true;
      try {
        const response = await this.axios.post(
          `/api/v1/max_get_state`,
          {
            company_id: this.company.id
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        );

        if (response.status === 200) {
          this.$notify(this.$t("companies.max_check_state_success"), `${this.$t("companies.max_state")}: ${this.getMaxStateText(response.data.stateInstance)}`, "success");
          this.refreshCompanyData();
        }
      } catch (error) {
        console.error('MAX check state error:', error);
        this.$notify(this.$t("errors.error"), error.response?.data?.error || "Ошибка проверки состояния", "error");
      } finally {
        this.isLoadingMaxActions = false;
      }
    },
    async rebootMax() {
      const result = await this.$confirm({
        title: this.$t("companies.max_reboot_warning"),
        text: this.$t("companies.max_reboot_warning_text"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });

      if (result) {
        this.isLoadingMaxActions = true;
        try {
          const response = await this.axios.post(
            `/api/v1/max_reboot`,
            {
              company_id: this.company.id
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          );

          if (response.status === 200) {
            this.$notify(this.$t("companies.max_reboot_success"), "", "success");
            setTimeout(() => {
              this.refreshCompanyData();
            }, 2000);
          }
        } catch (error) {
          console.error('MAX reboot error:', error);
          this.$notify(this.$t("errors.error"), error.response?.data?.error || "Ошибка перезапуска", "error");
        } finally {
          this.isLoadingMaxActions = false;
        }
      }
    },
    async logoutMax() {
      const result = await this.$confirm({
        title: this.$t("companies.max_logout_warning"),
        text: this.$t("companies.max_logout_warning_text"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });

      if (result) {
        this.isLoadingMaxActions = true;
        try {
          const response = await this.axios.post(
            `/api/v1/max_logout`,
            {
              company_id: this.company.id
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          );

          if (response.status === 200) {
            this.$notify(this.$t("companies.max_logout_success"), "", "success");
            this.refreshCompanyData();
          }
        } catch (error) {
          console.error('MAX logout error:', error);
          this.$notify(this.$t("errors.error"), error.response?.data?.error || "Ошибка разлогирования", "error");
        } finally {
          this.isLoadingMaxActions = false;
        }
      }
    },
    // Telegram Green-API methods
    async createTelegramGreenApiInstance() {
      if (this.main_company.balance > 0) {
        const result = await this.$confirm({
          title: this.$t("telegram_green_api.create_instance_warning"),
          text: this.$t("telegram_green_api.create_instance_warning_text"),
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
          maxWidth: 600,
        });

        if (result) {
          this.isLoadingCreateTelegramGreenApiInstance = true;
          this.axios
            .post(
              "/api/v1/create_telegram_green_api_instance",
              {
                company_id: this.company.id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken
                },
              }
            )
            .then(() => {
              setTimeout(() => {
                this.isLoadingCreateTelegramGreenApiInstance = false;
                this.$notify(this.$t('telegram_green_api.create_instance_success'), this.$t('telegram_green_api.create_instance_success_text'), 'info', 5000);
                this.refreshCompanyData();
              }, 30000);
            })
            .catch((error) => {
              this.isLoadingCreateTelegramGreenApiInstance = false;
              this.setError(error, this.$t("errors.error"));
            });
        }
      } else {
        this.$notify(this.$t('telegram_green_api.create_instance_error'), this.$t('telegram_green_api.create_instance_no_balance'), 'warning');
      }
    },
    async deleteTelegramGreenApiInstance() {
      const result = await this.$confirm({
        title: this.$t("telegram_green_api.delete_instance_warning"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });

      if (result) {
        this.isLoadingDeleteTelegramGreenApiInstance = true;
        this.axios
          .post(
            "/api/v1/delete_telegram_green_api_instance",
            {
              company_id: this.company.id,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken
              },
            }
          )
          .then(() => {
            setTimeout(() => {
              this.isLoadingDeleteTelegramGreenApiInstance = false;
              this.$notify(this.$t('telegram_green_api.delete_instance_success'), '', 'success');
              this.refreshCompanyData();
            }, 5000);
          })
          .catch((error) => {
            this.isLoadingDeleteTelegramGreenApiInstance = false;
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          });
      }
    },
    openTelegramGreenApiAuthDialog() {
      this.telegramGreenApiAuthDialog = true;
      this.telegramGreenApiAuthStep = 'qr';
      this.telegramGreenApiQrCode = null;
      this.telegramGreenApiQrError = '';
      this.telegramGreenApiAuthPassword = '';
      this.telegramGreenApiPasswordError = '';
      this.fetchTelegramGreenApiQrCode();
      this.startTelegramGreenApiQrPolling();
    },
    closeTelegramGreenApiAuthDialog() {
      this.telegramGreenApiAuthDialog = false;
      this.telegramGreenApiAuthStep = 'qr';
      this.telegramGreenApiQrCode = null;
      this.telegramGreenApiQrError = '';
      this.telegramGreenApiAuthPassword = '';
      this.telegramGreenApiPasswordError = '';
      this.stopTelegramGreenApiQrPolling();
    },
    async fetchTelegramGreenApiQrCode() {
      this.isLoadingTelegramGreenApiQr = true;
      this.telegramGreenApiQrError = '';
      try {
        // Сначала проверяем состояние — может быть pendingPassword
        const stateResponse = await this.axios.post(
          "/api/v1/telegram_green_api_get_state",
          { company_id: this.company.id },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        );
        const state = stateResponse.data.state;
        if (state === 'authorized') {
          this.$notify(this.$t("telegram_green_api.auth_success"), "", "success");
          this.closeTelegramGreenApiAuthDialog();
          this.refreshCompanyData();
          return;
        }
        if (state === 'pendingPassword') {
          this.telegramGreenApiAuthStep = 'pendingPassword';
          this.isLoadingTelegramGreenApiQr = false;
          return;
        }

        const response = await this.axios.post(
          "/api/v1/telegram_green_api_get_qr",
          { company_id: this.company.id },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        );

        const data = response.data;
        if (data.type === "qrCode" && data.message) {
          this.telegramGreenApiQrCode = data.message;
        } else if (data.type === "alreadyLogged") {
          this.$notify(this.$t("telegram_green_api.auth_success"), "", "success");
          this.closeTelegramGreenApiAuthDialog();
          this.refreshCompanyData();
        } else if (data.type === "error") {
          this.telegramGreenApiQrError = data.error || this.$t("errors.error");
        } else {
          this.telegramGreenApiQrError = data.error || this.$t("errors.error");
        }
      } catch (error) {
        console.error('Telegram Green-API get QR error:', error);
        this.telegramGreenApiQrError = error.response?.data?.error || this.$t("errors.error");
      } finally {
        this.isLoadingTelegramGreenApiQr = false;
      }
    },
    startTelegramGreenApiQrPolling() {
      this.stopTelegramGreenApiQrPolling();
      // Обновляем QR-код и проверяем состояние каждые 30 секунд
      this.telegramGreenApiQrInterval = setInterval(async () => {
        if (!this.telegramGreenApiAuthDialog) {
          this.stopTelegramGreenApiQrPolling();
          return;
        }
        try {
          // Проверяем состояние инстанса
          const stateResponse = await this.axios.post(
            "/api/v1/telegram_green_api_get_state",
            { company_id: this.company.id },
            { headers: { Authorization: this.$store.getters.getAuthToken } }
          );
          const state = stateResponse.data.state;
          if (state === 'authorized') {
            this.$notify(this.$t("telegram_green_api.auth_success"), "", "success");
            this.closeTelegramGreenApiAuthDialog();
            this.refreshCompanyData();
            return;
          }
          if (state === 'pendingPassword') {
            this.telegramGreenApiAuthStep = 'pendingPassword';
            return;
          }

          // Обновляем QR-код если ещё на шаге QR
          if (this.telegramGreenApiAuthStep === 'qr') {
            const response = await this.axios.post(
              "/api/v1/telegram_green_api_get_qr",
              { company_id: this.company.id },
              { headers: { Authorization: this.$store.getters.getAuthToken } }
            );

            const data = response.data;
            if (data.type === "qrCode" && data.message) {
              this.telegramGreenApiQrCode = data.message;
            } else if (data.type === "alreadyLogged") {
              this.$notify(this.$t("telegram_green_api.auth_success"), "", "success");
              this.closeTelegramGreenApiAuthDialog();
              this.refreshCompanyData();
            }
          }
        } catch (error) {
          console.error('Telegram Green-API QR polling error:', error);
        }
      }, 30000);
    },
    stopTelegramGreenApiQrPolling() {
      if (this.telegramGreenApiQrInterval) {
        clearInterval(this.telegramGreenApiQrInterval);
        this.telegramGreenApiQrInterval = null;
      }
    },
    async telegramGreenApiSendPassword() {
      this.isLoadingTelegramGreenApiSendPassword = true;
      this.telegramGreenApiPasswordError = '';
      try {
        const response = await this.axios.post(
          "/api/v1/telegram_green_api_send_authorization_code",
          {
            company_id: this.company.id,
            password: this.telegramGreenApiAuthPassword,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        );

        const data = response.data;
        if (data.status === true || (data.data && data.data.status === "success")) {
          this.$notify(this.$t("telegram_green_api.auth_success"), "", "success");
          this.closeTelegramGreenApiAuthDialog();
          this.refreshCompanyData();
        } else {
          this.telegramGreenApiPasswordError = data.data?.reason || data.error || this.$t("errors.error");
        }
      } catch (error) {
        console.error('Telegram Green-API send password error:', error);
        this.telegramGreenApiPasswordError = error.response?.data?.error || this.$t("errors.error");
      } finally {
        this.isLoadingTelegramGreenApiSendPassword = false;
      }
    },
    async checkTelegramGreenApiState() {
      this.isLoadingTelegramGreenApiActions = true;
      try {
        const response = await this.axios.post(
          `/api/v1/telegram_green_api_get_state`,
          {
            company_id: this.company.id
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        );

        if (response.status === 200) {
          this.$notify(this.$t("telegram_green_api.check_state_success"), `${this.$t("telegram_green_api.state")}: ${this.getTelegramGreenApiStateText(response.data.state)}`, "success");
          this.refreshCompanyData();
        }
      } catch (error) {
        console.error('Telegram Green-API check state error:', error);
        this.$notify(this.$t("errors.error"), error.response?.data?.error || this.$t("telegram_green_api.state_check_error"), "error");
      } finally {
        this.isLoadingTelegramGreenApiActions = false;
      }
    },
    async rebootTelegramGreenApi() {
      const result = await this.$confirm({
        title: this.$t("telegram_green_api.reboot_warning"),
        text: this.$t("telegram_green_api.reboot_warning_text"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });

      if (result) {
        this.isLoadingTelegramGreenApiActions = true;
        try {
          const response = await this.axios.post(
            `/api/v1/telegram_green_api_reboot`,
            {
              company_id: this.company.id
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          );

          if (response.status === 200) {
            this.$notify(this.$t("telegram_green_api.reboot_success"), "", "success");
            setTimeout(() => {
              this.refreshCompanyData();
            }, 2000);
          }
        } catch (error) {
          console.error('Telegram Green-API reboot error:', error);
          this.$notify(this.$t("errors.error"), error.response?.data?.error || this.$t("telegram_green_api.reboot_error"), "error");
        } finally {
          this.isLoadingTelegramGreenApiActions = false;
        }
      }
    },
    async logoutTelegramGreenApi() {
      const result = await this.$confirm({
        title: this.$t("telegram_green_api.logout_warning"),
        text: this.$t("telegram_green_api.logout_warning_text"),
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
        maxWidth: 600,
      });

      if (result) {
        this.isLoadingTelegramGreenApiActions = true;
        try {
          const response = await this.axios.post(
            `/api/v1/telegram_green_api_logout`,
            {
              company_id: this.company.id
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          );

          if (response.status === 200) {
            this.$notify(this.$t("telegram_green_api.logout_success"), "", "success");
            this.refreshCompanyData();
          }
        } catch (error) {
          console.error('Telegram Green-API logout error:', error);
          this.$notify(this.$t("errors.error"), error.response?.data?.error || this.$t("telegram_green_api.logout_error"), "error");
        } finally {
          this.isLoadingTelegramGreenApiActions = false;
        }
      }
    },
    getTelegramGreenApiStateColor(state) {
      const stateColors = {
        'authorized': 'success',
        'notAuthorized': 'warning',
        'not_authorized': 'warning',
        'pendingPassword': 'deep-purple',
        'starting': 'info',
        'creating': 'info',
        'blocked': 'error',
        'suspended': 'orange',
        'not_exists': 'grey',
        'deleting': 'grey'
      };
      return stateColors[state] || 'grey';
    },
    getTelegramGreenApiStateText(state) {
      const translationKey = `telegram_green_api.state_${state}`;
      return this.$t(translationKey) !== translationKey ? this.$t(translationKey) : state;
    },
    includedInPlan(service) {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan) {
          if (this.$store.getters.getMainCompany.plan.included_services) {
            // check trial period
            if (this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment()) && service != 'multicashboxes' && service != 'multicurrency') {
              return true;
            }
            return this.$store.getters.getMainCompany.plan.included_services.includes(service);
          }
        }
      }
      return false;
    },
    addNewCurrency() {
      this.$notify(this.$t('companies.multicurrency_not_included'), '', 'warning')
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    updateTab(value) {
      console.log(value);
      this.$store.commit('setCompanyProfileTab', value);
    },
  },
  components: {
    PricingSettingsTab,
    BookableAddonsTab,
    Uppy,
    UppyEntity,
    UppyProlong,
    UppyInvoice,
    UppyDocx,
    PeriodicPaymentTemplates,
    BookingMessageTemplates,
    TagGroupManager,
    SitesBuilderTokens,
  },
};
</script>
<style scoped>
/* xs: боковые отступы страницы настроек набегают каскадом (контейнеры,
   v-card__text, заголовки панелей — суммарно ~76px на сторону) и съедают
   половину ширины телефона. Срезаем каждый уровень, десктоп не трогаем. */
@media (max-width: 599px) {
  ::v-deep .container {
    padding-left: 4px;
    padding-right: 4px;
  }
  ::v-deep .v-card__text {
    padding-left: 8px;
    padding-right: 8px;
  }
  ::v-deep .v-expansion-panel-header {
    padding-left: 12px;
    padding-right: 12px;
  }
  ::v-deep .v-expansion-panel-content__wrap {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
